;(function () {
  function factory(globalPromise) {
    var bluebird_extended, utils_mappers, utils_utils, utils_http, events_notifier, sources_Source, sources_bigstock_settings, sources_bigstock_mappers_folder, sources_bigstock_parsers_folders, sources_bigstock_folders, sources_bigstock_mappers_item, sources_bigstock_parsers_items, sources_bigstock_parsers_error, sources_bigstock_items, sources_decorators, events_list, sources_bigstock_BigStock, sources_shutterstock_settings, sources_shutterstock_mappers_folder, sources_shutterstock_parsers_folders, sources_shutterstock_folders, sources_shutterstock_mappers_item, sources_shutterstock_parsers_items, sources_shutterstock_parsers_error, sources_shutterstock_items, sources_shutterstock_ShutterStock, sources_public_mappers_folder, sources_public_parsers_folders, sources_public_parsers_error, sources_public_folders, services_thumbnail_generator_resize, services_thumbnail_generator_get_wix_thumbnails_urls, services_thumbnail_generator_get_wix_video_preview_urls, sources_public_mappers_item, sources_public_parsers_items, sources_public_items, sources_public_item, sources_public_settings, sources_public_Public, sources_private_mappers_folder, sources_private_parsers_error, sources_private_folders, sources_private_validators_new_props, sources_private_folder, sources_private_mappers_item, sources_private_items, constants_transcoding_statuses, sources_private_item, sources_private_trash, sources_private_itemstrash, sources_private_itemssite_media, sources_private_folderstrash, sources_private_settings, services_channel_channel, services_new_relic, services_channel_black_arrow, sources_private_refresh_token_wrapper, services_polling, services_crc32, services_upload_file_to_upload, services_upload_upload_collection, services_bi_send_request, services_bi_event_ids, services_resumable, sources_private_Private, sources_platform_mappers_folder, sources_platform_parsers_error, sources_platform_folders, sources_platform_validators_new_props, sources_platform_folder, sources_platform_mappers_item, sources_platform_items, sources_platform_item, sources_platform_trash, sources_platform_itemstrash, sources_platform_itemssite_media, sources_platform_folderstrash, sources_platform_settings, sources_platform_Platform, sources_picasa_settings, sources_picasa_mappers_folder, sources_picasa_parsers_folders, sources_picasa_parsers_error, sources_picasa_folders, sources_picasa_mappers_item, sources_picasa_parsers_items, sources_picasa_items, sources_picasa_Picasa, sources_drive_settings, sources_drive_mappers_folder, sources_drive_parsers_folders, sources_drive_parsers_error, sources_drive_folders, sources_drive_mappers_item, sources_drive_parsers_items, sources_drive_items, sources_drive_Drive, sources_dropbox_settings, sources_dropbox_mappers_folder, sources_dropbox_parsers_folders, sources_dropbox_parsers_error, sources_dropbox_folders, sources_dropbox_mappers_item, sources_dropbox_parsers_items, sources_dropbox_items, sources_dropbox_Dropbox, sources_instagram_settings, sources_instagram_mappers_folder, sources_instagram_parsers_folders, sources_instagram_parsers_error, sources_instagram_folders, sources_instagram_mappers_item, sources_instagram_parsers_items, sources_instagram_items, sources_instagram_Instagram, sources_instagram_video_settings, sources_instagram_video_mappers_folder, sources_instagram_video_parsers_folders, sources_instagram_video_folders, sources_instagram_video_mappers_item, sources_instagram_video_parsers_items, sources_instagram_video_parsers_error, sources_instagram_video_items, sources_instagram_video_InstagramVideo, sources_facebook_settings, sources_facebook_mappers_folder, sources_facebook_parsers_folders, sources_facebook_parsers_error, sources_facebook_folders, sources_facebook_mappers_item, sources_facebook_parsers_items, sources_facebook_items, sources_facebook_Facebook, sources_facebook_video_settings, sources_facebook_video_mappers_folder, sources_facebook_video_parsers_folders, sources_facebook_video_folders, sources_facebook_video_mappers_item, sources_facebook_video_parsers_items, sources_facebook_video_parsers_error, sources_facebook_video_items, sources_facebook_video_FacebookVideo, sources_flickr_settings, sources_flickr_mappers_folder, sources_flickr_parsers_folders, sources_flickr_parsers_error, sources_flickr_folders, sources_flickr_mappers_item, sources_flickr_parsers_items, sources_flickr_items, sources_flickr_Flickr, sources_flickr_search_settings, sources_flickr_search_mappers_item, sources_flickr_search_parsers_items, sources_flickr_search_parsers_error, sources_flickr_search_items, sources_flickr_search_FlickrSearch, sources_google_search_settings, sources_google_search_mappers_item, sources_google_search_parsers_items, sources_google_search_parsers_error, sources_google_search_items, sources_google_search_GoogleSearch, sources_collection_settings, sources_collection_mappers_folder, sources_collection_parsers_selector, sources_collection_parsers_folders, sources_collection_parsers_error, sources_collection_folders, sources_collection_mappers_item, sources_collection_parsers_items, sources_collection_items, sources_collection_Collection, sources_vimeo_settings, sources_vimeo_mappers_folder, sources_vimeo_parsers_folders, sources_vimeo_folders, sources_vimeo_mappers_item, sources_vimeo_parsers_items, sources_vimeo_parsers_error, sources_vimeo_items, sources_vimeo_Vimeo, sources_vimeo_search_settings, sources_vimeo_search_mappers_item, sources_vimeo_search_parsers_items, sources_vimeo_search_parsers_error, sources_vimeo_search_items, sources_vimeo_search_VimeoSearch, sources_youtube_settings, sources_youtube_mappers_folder, sources_youtube_parsers_folders, sources_youtube_parsers_error, sources_youtube_folders, sources_youtube_mappers_item, sources_youtube_parsers_items, sources_youtube_items, sources_youtube_YouTube, sources_youtube_search_settings, sources_youtube_search_mappers_item, sources_youtube_search_parsers_items, sources_youtube_search_parsers_error, sources_youtube_search_items, sources_youtube_search_YouTubeSearch, sources_showbox_mappers_folder, sources_showbox_parsers_error, sources_showbox_folders, sources_showbox_mappers_item, sources_showbox_items, sources_showbox_settings, sources_showbox_Showbox, sources_list, events_events, connector_connector_settings, connector_connector, services_bi_benchmarks, services_bi_errors, services_bi_upload_queue, services_bi_bi, services_thumbnail_generator_thumbnail_generator, wixmp;
var cancellationErrorCode = -7799;
bluebird_extended = function () {
  var Promise = globalPromise;
  function CancellationError() {
    Promise.CancellationError.apply(this, arguments);
    this.data = {
      errorCode: cancellationErrorCode,
      errorDescription: 'Canceled by user',
      errorInfo: {
        key: 'wmp_error.canceled_by_user',
        args: []
      }
    };
  }
  if (Promise.CancellationError) {
    CancellationError.prototype = Object.create(Promise.CancellationError.prototype);
  }
  Promise.newAbortable = function (func) {
    var reject;
    var promise = new Promise(function () {
      reject = arguments[1];
      return func.apply(this, arguments);
    });
    if (promise.cancellable) {
      promise = promise.cancellable();
      promise.abort = function () {
        this.cancel(new CancellationError());
      };
    } else {
      promise.abort = function () {
        reject(new CancellationError());
      };
    }
    return promise;
  };
  Promise.defer = function () {
    var resolve, reject;
    var promise = Promise.newAbortable(function () {
      resolve = arguments[0];
      reject = arguments[1];
    });
    return {
      resolve: resolve,
      reject: reject,
      promise: promise
    };
  };
  if (!Promise.CancellationError) {
    Promise.CancellationError = function () {
      Error.apply(this, arguments);
    };
    Promise.CancellationError.prototype = Object.create(Error.prototype);
  }
  [
    'then',
    'catch'
  ].forEach(function (name) {
    var original = Promise.prototype[name];
    Promise.prototype[name] = function () {
      var promise = original.apply(this, arguments);
      if (!promise.abort) {
        promise.abort = this.abort;
      }
      return promise;
    };
  });
  Promise.prototype.progress = function (callback) {
    this._progressCallback = callback;
    return this;
  };
  Promise.prototype.notify = function (message) {
    if (typeof this._progressCallback === 'function') {
      this._progressCallback(message);
    }
    return this;
  };
  return Promise;
}();
utils_mappers = {
  toObject: function (data) {
    if (!data) {
      return null;
    }
    if (typeof data === 'string') {
      if ([
          '{',
          '['
        ].indexOf(data[0]) >= 0) {
        try {
          return JSON.parse(data);
        } catch (err) {
          return {
            error_code: -100,
            error_description: 'Can`t parse JSON',
            error_info: { key: 'wmp_error.cant_parse_json' }
          };
        }
      }
      return { message: data };
    }
    return data;
  },
  toError: function (error) {
    var errorObject = new Error();
    errorObject.code = error.status || error.code;
    errorObject.message = error.statusText || error.message || error.data.message || error.data.error && error.data.error.message || '';
    errorObject.data = error.data && (error.data.errors || error.data.error || error.data);
    errorObject.config = error.config;
    return errorObject;
  }
};
utils_utils = function (Promise, mappers) {
  function minMaxFinder(method, arr, predicate) {
    var mappedArr;
    if (predicate) {
      mappedArr = arr.map(predicate);
      return arr[mappedArr.indexOf(Math[method].apply(null, mappedArr))];
    }
    return Math[method].apply(this, arr);
  }
  var utils = {
    /**
     * Extend object values with sources objects data
     * @param dest {Object}
     * @param source.. {Object}
     * @returns {*}
     */
    extend: function (dest) {
      dest = dest || {};
      var sources = Array.prototype.slice.call(arguments, 1);
      sources.forEach(function (source) {
        if (typeof source === 'object' && source !== null) {
          Object.keys(source).forEach(function (key) {
            dest[key] = source[key];
          });
        }
      });
      return dest;
    },
    /**
     * Extend deep objects
     * @param object {Object}
     * @returns {Object}
     * @description Deep merge objects, works like lodash merge.
     */
    extendDeep: function extendDeep(object) {
      object = object || {};
      for (var i = 1, len = arguments.length; i < len; ++i) {
        var obj = arguments[i];
        if (!obj) {
          continue;
        }
        for (var key in obj) {
          if (!obj.hasOwnProperty(key)) {
            continue;
          }
          if (obj[key] === undefined) {
            continue;
          }
          if (Object.prototype.toString.call(obj[key]) === '[object Object]') {
            object[key] = extendDeep(object[key], obj[key]);
            continue;
          }
          object[key] = obj[key];
        }
      }
      return object;
    },
    /**
     * Gets the value at path of object.
     * If the resolved value is undefined, the defaultValue is returned in its place.
     * @param object
     * @param path
     * @param defaultValue
     * @returns {*}
     */
    get: function (object, path, defaultValue) {
      if (!object || !path) {
        return defaultValue;
      }
      var paths = Array.isArray(path) ? path : path.split(/[\.\[\]]/);
      paths = paths.filter(function (path) {
        return path;
      });
      var result = paths.reduce(function (prevValue, currentNamespace) {
        if (prevValue && prevValue[currentNamespace]) {
          return prevValue[currentNamespace];
        }
        return undefined;
      }, object);
      if (result) {
        return result;
      }
      return defaultValue;
    },
    /**
     * Merge
     * @returns {*}
     */
    merge: function () {
      var hop = Object.prototype.hasOwnProperty;
      return Array.prototype.reduce.call(arguments, function (result, source) {
        Object.keys(result).forEach(function (key) {
          if (hop.call(source, key)) {
            result[key] = source[key];
          }
        });
        Object.keys(source).forEach(function (key) {
          result[key] = source[key];
        });
        return result;
      }, {});
    },
    bytesToSize: function (bytes) {
      if (bytes === 0) {
        return '0 Byte';
      }
      var k = 1024;
      var sizes = [
        'Bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
      ];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
    },
    /**
     * Return function with preset arguments
     * @param func {Function}
     * @param [argument..] {*}
     * @returns {Function}
     */
    partial: function (func) {
      var partialArguments = Array.prototype.slice.call(arguments, 1);
      return function () {
        var args = Array.prototype.slice.call(arguments);
        return func.apply(this, partialArguments.concat(args));
      };
    },
    /**
     * Return parameter value from search string
     * @param searchString {String}
     * @param name {String}
     * @returns {String}
     */
    getParameterByName: function (searchString, name) {
      var regex, results;
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      results = regex.exec(searchString);
      if (!results) {
        return '';
      }
      return decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    /**
     * Return camel case string from snake case string
     * @param string {String}
     * @returns {String}
     */
    snakeToCamel: function (string) {
      string = string[0].toLowerCase() + string.slice(1);
      return string.replace(/[_]+$/g, '').replace(/([^_]?)[_]+([^_])/g, function ($0, $1, $2) {
        if (!$1) {
          return $2.toLowerCase();
        }
        return $1.toLowerCase() + $2.toUpperCase();
      });
    },
    /**
     * Return snake case string from camel case string
     * @param string {String}
     * @returns {String}
     */
    camelToSnake: function (string) {
      return string.replace(/([a-z]?)([A-Z])/g, function ($0, $1, $2) {
        if (!$1) {
          return $0.toLowerCase();
        }
        return $1 + '_' + $2.toLowerCase();
      });
    },
    find: function (arr, predicate) {
      var found;
      arr.some(function (el) {
        if (predicate(el) === true) {
          found = el;
          return true;
        }
      });
      return found;
    },
    encodeParams: function (a) {
      var s = [], add = function (key, value) {
          s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value);
        };
      Object.keys(a).forEach(function (entity) {
        add(entity, a[entity]);
      });
      return s.join('&').replace(/%20/g, '+');
    },
    splitTags: function (tags) {
      if (!tags) {
        return [];
      }
      if (Array.isArray(tags)) {
        return tags;
      }
      return tags.split(/\s*,\s*/);
    },
    normalizeUri: function (uri) {
      if (typeof uri !== 'string') {
        throw new Error('URI is not a string');
      }
      return uri.replace(/([a-z\-_0-9]+)\/\//gi, '$1/');
    },
    getScript: function (src) {
      return Promise.newAbortable(function (resolve, reject) {
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        var done = false;
        script.src = src;
        script.onload = script.onreadystatechange = function () {
          if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
            done = true;
            resolve();
            script.onload = script.onreadystatechange = null;
            if (head && script.parentNode) {
              head.removeChild(script);
            }
          } else {
            reject(mappers.toError());
          }
        };
        head.insertBefore(script, head.firstChild);
      });
    },
    startsWithGuid: function (guid) {
      return /^\w{8}-(\w{4}-){3}\w{12}/.test(guid);
    },
    endsWith: function (string, suffix) {
      return string.indexOf(suffix, string.length - suffix.length) !== -1;
    },
    /**
     * sortBy like lodash _.sortBy
     * @param {Object[]} arrayOfObjects
     * @param {String} key
     * @param {String} [sortOrder='asc']
     * @returns {Object[]} sorted array
     */
    sortBy: function (arrayOfObjects, key, sortOrder) {
      return arrayOfObjects.slice().sort(function (a, b) {
        var order = 0;
        if (a[key] < b[key]) {
          order = -1;
        } else if (a[key] > b[key]) {
          order = 1;
        }
        if (sortOrder === 'desc') {
          return -order;
        }
        return order;
      });
    },
    /**
     * objectValues doesn't work like a native Object.values
     * @param {Object} object
     * @returns {Array} Array of given object property values
     */
    objectValues: function (object) {
      if (!object) {
        return [];
      }
      return Object.keys(object).map(function (key) {
        return object[key];
      });
    },
    /**
     * getThumbnailsUrlsFromList
     * @param {Array} sourceSizes
     * @param {Object} requiredSizes
     * @returns {Object.<thumbnailUrl, previewUrl>}
     */
    getThumbnailsUrlsFromList: function (sourceSizes, requiredSizes) {
      if (!sourceSizes.length) {
        return {};
      }
      function canFill(sizes, sizesToTest) {
        return sizesToTest.width >= sizes.width && sizesToTest.height >= sizes.height;
      }
      function canFit(sizes, sizesToTest) {
        return sizesToTest.width >= sizes.width || sizesToTest.height >= sizes.height;
      }
      var sourceSizesSorted = utils.sortBy(sourceSizes, 'width');
      return Object.keys(requiredSizes).reduce(function (urls, sizeName) {
        var requiredSize = requiredSizes[sizeName];
        var currentSize = utils.find(sourceSizesSorted, function (size) {
          return requiredSize.mode === 'fill' ? canFill(requiredSize, size) : canFit(requiredSize, size);
        });
        urls[sizeName + 'Url'] = currentSize ? currentSize.url : sourceSizesSorted[sourceSizesSorted.length - 1].url;
        return urls;
      }, {});
    },
    /**
     * replaceHtml
     * @param {String} htmlString
     * @returns {String}
     */
    replaceHtml: function (htmlString) {
      return (htmlString || '').replace(/<\/?[a-z]+.*?>/gi, '');
    },
    /**
     * toTimeStamp
     * @param {String} date
     * @returns {Number} time stamp in seconds
     */
    toTimeStamp: function (date) {
      return !date ? null : Math.floor(new Date(date).getTime() / 1000);
    }
  };
  utils.min = utils.partial(minMaxFinder, 'min');
  utils.max = utils.partial(minMaxFinder, 'max');
  return utils;
}(bluebird_extended, utils_mappers);
utils_http = function (Promise, utils, mappers) {
  var contentTypes = {
    JSON: 'application/json',
    URL_ENCODED: 'application/x-www-form-urlencoded',
    MULTIPART: 'multipart/form-data'
  };
  var defaultOptions = {
    withCredentials: false,
    cache: true,
    headers: { Accept: 'application/json, text/plain, */*' }
  };
  function parseResponseData(response) {
    if (typeof response === 'string') {
      if ([
          '{',
          '['
        ].indexOf(response[0]) >= 0) {
        response = JSON.parse(response);
      } else {
        response = { message: response };
      }
    }
    return response;
  }
  function parseResponse(request) {
    return {
      status: request.status,
      statusText: request.statusText,
      responseSize: request.responseText.length,
      data: parseResponseData(request.responseText)
    };
  }
  function encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
  }
  function buildUrl(url, params) {
    if (!params) {
      return url;
    }
    var parts = [];
    Object.keys(params).forEach(function (key) {
      var val = params[key];
      if (val === null || typeof val === 'undefined') {
        return;
      }
      if (!(val instanceof Array)) {
        val = [val];
      }
      val.forEach(function (v) {
        if (v instanceof Date && !isNaN(v.valueOf())) {
          v = v.toISOString();
        } else if (typeof v === 'object') {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });
    if (parts.length > 0) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + parts.join('&');
    }
    return url;
  }
  function encodeRequestData(data, contentType) {
    if (contentType.indexOf(contentTypes.JSON) !== -1) {
      return JSON.stringify(data);
    }
    if (contentType.indexOf(contentTypes.URL_ENCODED) !== -1) {
      return utils.encodeParams(data);
    }
    if (contentType.indexOf(contentTypes.MULTIPART) !== -1) {
      var formData = new FormData();
      Object.keys(data).forEach(function (name) {
        var value = data[name];
        var args = name === 'file' ? [
          name,
          value,
          value.name
        ] : [
          name,
          value
        ];
        return formData.append.apply(formData, args);
      });
      return formData;
    }
  }
  return function (options) {
    var requestOptions = utils.extend({}, options);
    function setRequestOptions(settings) {
      requestOptions = utils.extendDeep(requestOptions, settings);
    }
    function wrapRequestWithPromise(request, callSend, hasProgress) {
      var promise = Promise.newAbortable(function (resolve, reject) {
        request.addEventListener('error', function () {
          reject(mappers.toError(utils.extend({}, request, {
            message: 'error',
            code: -201,
            errorInfo: { key: request.responseText || 'internal_server_error' }
          })));
        }, false);
        request.addEventListener('timeout', function () {
          reject(mappers.toError(utils.extend({}, request, {
            message: 'timeout_has_exceeded',
            code: 408
          })));
        }, false);
        request.addEventListener('load', function () {
          if (request.status.toString().match(/^2\d+/i)) {
            resolve(parseResponse(request));
          } else {
            reject(mappers.toError(utils.extend({}, request, {
              message: 'error',
              code: request.status,
              data: mappers.toObject(request.responseText),
              errorInfo: { key: request.responseText || 'load_error' }
            })));
          }
        }, false);
      });
      if (hasProgress) {
        request.upload.onprogress = function (event) {
          var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
          var status = progress <= 99 ? 'uploading' : 'processing';
          promise.notify({
            status: status,
            total: event.total,
            loaded: event.loaded
          });
        };
      } else {
        request.addEventListener('loadstart', function (event) {
          if (!event) {
            return;
          }
          promise.notify({
            status: 'uploading',
            total: event.total,
            loaded: event.loaded
          });
        }, false);
        request.addEventListener('loadend', function (event) {
          if (!event) {
            return;
          }
          promise.notify({
            status: 'processing',
            total: event.total,
            loaded: event.loaded
          });
        }, false);
      }
      promise.catch(function (err) {
        if (err instanceof Promise.CancellationError) {
          request.abort();
        }
      });
      callSend();
      return promise;
    }
    function openRequest(method, url, options) {
      var request = new XMLHttpRequest();
      if (options.cache === false) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + '_=' + Date.now();
      }
      request.open(method.toUpperCase(), utils.normalizeUri(url));
      if (options.responseType) {
        request.responseType = options.responseType;
      }
      request.withCredentials = options.withCredentials;
      Object.keys(options.headers).forEach(function (name) {
        request.setRequestHeader(name, options.headers[name]);
      });
      request.config = utils.extend({
        url: url,
        method: method
      }, options);
      return request;
    }
    function get(url, params, options) {
      params = utils.extend({}, params, requestOptions.params);
      var request = openRequest('get', buildUrl(url, params), utils.extendDeep({}, defaultOptions, requestOptions, options));
      return wrapRequestWithPromise(request, function () {
        request.send(null);
      });
    }
    /**
     * POST request
     * @param url {String}
     * @param data {Object} Post data
     * @param params {Object} Url get params
     * @param options {Object} Options
     * @returns {*}
     */
    function post(url, data, params, options) {
      data = data || {};
      params = params || {};
      options = options || {};
      var userOptions = utils.extendDeep({}, defaultOptions, { headers: { 'Content-Type': 'application/json; charset=utf-8' } }, requestOptions, options);
      data = utils.extend({}, data, requestOptions.params);
      data = encodeRequestData(data, userOptions.headers['Content-Type']);
      var request = openRequest('post', buildUrl(url, params), userOptions);
      return wrapRequestWithPromise(request, function () {
        request.send(data);
      });
    }
    function upload(url, multipart, options) {
      var userOptions = utils.extendDeep({}, defaultOptions, options);
      var request = openRequest('post', url, userOptions);
      var multipartData = utils.extend({}, multipart, requestOptions.params);
      multipartData = encodeRequestData(multipartData, contentTypes.MULTIPART);
      return wrapRequestWithPromise(request, function () {
        request.send(multipartData);
      }, true);
    }
    function catchError(method, onError) {
      return function () {
        var self = this;
        var args = arguments;
        var firstPromise;
        function callOriginalMethod() {
          return method.apply(self, args);
        }
        firstPromise = callOriginalMethod();
        var promise = Promise.newAbortable(function (resolve, reject) {
          firstPromise.then(resolve, function (reason) {
            if (onError !== undefined) {
              return onError.call(this, reason, callOriginalMethod);
            }
            return reason;
          }).then(resolve, reject);
        });
        firstPromise.progress(function (progress) {
          promise.notify(progress);
        });
        promise.catch(function (err) {
          if (err instanceof Promise.CancellationError) {
            firstPromise.abort();
          }
        });
        return promise;
      };
    }
    function makeRetriable(method) {
      return catchError(method, function (reason, callOriginalMethod) {
        if (reason instanceof Promise.CancellationError || reason.code === 406 || reason.code === 403) {
          return Promise.reject(reason);
        }
        return callOriginalMethod();
      });
    }
    return {
      get: makeRetriable(get),
      post: makeRetriable(post),
      upload: makeRetriable(upload),
      catchError: catchError,
      setRequestOptions: setRequestOptions
    };
  };
}(bluebird_extended, utils_utils, utils_mappers);
events_notifier = function (Promise) {
  var listeners = {};
  function noop() {
  }
  function callEach(functions, data) {
    functions.forEach(function (currentFunction) {
      currentFunction(data);
    });
  }
  function callEachAtIndex(functions, index, data) {
    functions.forEach(function (functions) {
      functions[index](data);
    });
  }
  function emitWithArrayOfPromises(eventTarget, eventName, params) {
    // no listeners
    if (typeof listeners[eventName] === 'undefined') {
      return {
        resolveAt: noop,
        rejectAt: noop
      };
    }
    var resolvers = [], rejectors = [];
    listeners[eventName].forEach(function (listener) {
      var thisEventResolvers = [], thisEventRejectors = [];
      var eventPromises = params.promises.map(function () {
        return new Promise(function (resolve, reject) {
          thisEventResolvers.push(resolve);
          thisEventRejectors.push(reject);
        });
      });
      resolvers.push(thisEventResolvers);
      rejectors.push(thisEventRejectors);
      listener(eventPromises, params);
    });
    return {
      resolveAt: function (index, data) {
        callEachAtIndex(resolvers, index, data);
      },
      rejectAt: function (index, data) {
        callEachAtIndex(rejectors, index, data);
      }
    };
  }
  function emit(eventTarget, eventName, params) {
    if (typeof eventTarget !== 'object' || eventTarget === null) {
      throw new Error('target should be a function');
    }
    if (typeof eventName !== 'string') {
      throw new Error('eventName should be a string');
    }
    params = params || {};
    params.eventTarget = eventTarget;
    params.eventName = eventName;
    if (params.promises && params.promises.length) {
      return emitWithArrayOfPromises(eventTarget, eventName, params);
    }
    // no listeners
    if (typeof listeners[eventName] === 'undefined') {
      return {
        resolve: noop,
        reject: noop
      };
    }
    var resolvers = [], rejectors = [];
    listeners[eventName].forEach(function (listener) {
      var promise = new Promise(function (resolveCurrent, rejectCurrent) {
        resolvers.push(resolveCurrent);
        rejectors.push(rejectCurrent);
      });
      listener(promise, params);
    });
    return {
      resolve: function (data) {
        callEach(resolvers, data);
      },
      reject: function (reason) {
        callEach(rejectors, reason);
      }
    };
  }
  function emitResolve(eventTarget, eventName, params, result) {
    var promise = new Promise(function (resolve) {
      resolve(result);
    });
    params.promises = [promise];
    var event = emit(eventTarget, eventName, params);
    promise.then(function (data) {
      event.resolveAt(0, data);
    });
    return event;
  }
  /**
   * @summary Subscribe listener to event
   * @name on
   * @memberof wixmp.events
   * @method
   * @param eventName {String} Event name
   * @param listener {Function} Callback function that is when corresponding method is fired
   */
  function addListener(eventName, listener) {
    if (typeof listeners[eventName] === 'undefined') {
      listeners[eventName] = [];
    }
    listeners[eventName].push(listener);
  }
  /**
   * @summary Unsubscribe listener from event
   * @name off
   * @memberof wixmp.events
   * @method
   * @param eventName {String} Event name
   * @param listener {Function} Callback function
   */
  function removeListener(eventName, listener) {
    if (listeners[eventName]) {
      var index = listeners[eventName].indexOf(listener);
      listeners[eventName].splice(index, 1);
    }
  }
  return {
    emit: emit,
    emitResolve: emitResolve,
    addListener: addListener,
    removeListener: removeListener
  };
}(bluebird_extended);
sources_Source = function (initHttp, notifier) {
  /**
   * @summary The constructor function of a source
   * @namespace Source
   * @class
   * @memberof wixmp
   * @param {Function} Source constructor function
   * @param {Object} Source settings
   */
  return function (SourceConstructor, settings) {
    if (typeof SourceConstructor !== 'function') {
      throw new Error('Source constructor should be a function');
    }
    if (typeof settings !== 'undefined' && (typeof settings !== 'object' || settings === null)) {
      throw new Error('Source settings should be an object');
    }
    var http = initHttp();
    return new SourceConstructor(settings, notifier.emit, http);
  };
}(utils_http, events_notifier);
sources_bigstock_settings = { apiUrl: '//pix.wix.com/services/bigstock' };
sources_bigstock_mappers_folder = function (data) {
  return {
    id: data.id,
    name: data.name,
    mediaType: 'picture',
    parentId: null,
    filesCount: null,
    createdAt: null
  };
};
sources_bigstock_parsers_folders = function (toFolder) {
  return function (res) {
    res.data = (res.data || []).map(toFolder);
    return res;
  };
}(sources_bigstock_mappers_folder);
sources_bigstock_folders = function (mapFolderList, Promise) {
  return function () {
    var folders = mapFolderList({
      data: [
        {
          id: null,
          name: 'All'
        },
        {
          id: 'Abstract',
          name: 'Abstract'
        },
        {
          id: 'Animals',
          name: 'Animals'
        },
        {
          id: 'Architecture',
          name: 'Architecture'
        },
        {
          id: 'Backgrounds',
          name: 'Backgrounds'
        },
        {
          id: 'Business',
          name: 'Business'
        },
        {
          id: 'Communication',
          name: 'Communication'
        },
        {
          id: 'Computers',
          name: 'Computers'
        },
        {
          id: 'Conceptual',
          name: 'Conceptual'
        },
        {
          id: 'Editorial',
          name: 'Editorial'
        },
        {
          id: 'Education',
          name: 'Education'
        },
        {
          id: 'Food',
          name: 'Food'
        },
        {
          id: 'Health',
          name: 'Health'
        },
        {
          id: 'Holidays',
          name: 'Holidays'
        },
        {
          id: 'Industry',
          name: 'Industry'
        },
        {
          id: 'Internet',
          name: 'Internet'
        },
        {
          id: 'Landscapes',
          name: 'Landscapes'
        },
        {
          id: 'Maps',
          name: 'Maps'
        },
        {
          id: 'Miscellaneous',
          name: 'Miscellaneous'
        },
        {
          id: 'Musical',
          name: 'Musical'
        },
        {
          id: 'Nature',
          name: 'Nature'
        },
        {
          id: 'Objects',
          name: 'Objects'
        },
        {
          id: 'People',
          name: 'People'
        },
        {
          id: 'Places',
          name: 'Places'
        },
        {
          id: 'Sports',
          name: 'Sports'
        },
        {
          id: 'Transportation',
          name: 'Transportation'
        }
      ]
    });
    function list() {
      return Promise.resolve(folders);
    }
    return { list: list };
  };
}(sources_bigstock_parsers_folders, bluebird_extended);
sources_bigstock_mappers_item = function (utils) {
  return function (data) {
    var size = utils.find(data.formats, function (format) {
      return format.size_code === 'l';
    });
    if (!size) {
      size = data.formats.pop();
    }
    return {
      id: data.id,
      name: data.title,
      folderId: null,
      mediaType: 'picture',
      fileUrl: null,
      thumbnailUrl: utils.normalizeUri(data.large_thumb.url),
      previewUrl: utils.normalizeUri(data.preview.url),
      createdAt: null,
      tags: [],
      width: size.width,
      height: size.height
    };
  };
}(utils_utils);
sources_bigstock_parsers_items = function (toItem) {
  return function (res) {
    var data = res.data.data;
    var cursor = data.paging && data.paging.page < data.paging.total_pages ? data.paging.page + 1 : null;
    var size = Number(data.paging.items_per_page);
    res.data = (data.images || []).map(toItem);
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_bigstock_mappers_item);
sources_bigstock_parsers_error = function (Promise) {
  return function (response) {
    if (response.code === 503 && response.data && response.data.code === 'search-critical') {
      return {
        data: [],
        status: response.code,
        error: response.data
      };
    }
    response.data = response.data || {};
    var data = response.data;
    var code;
    if (Array.isArray(data)) {
      code = data[0].code || data[0];
    } else {
      code = data.code;
    }
    response.data.message = code;
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_bigstock_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      options.sort = options.sort || {};
      var requestOptions = {
        limit: options.paging.size || 50,
        page: options.paging.cursor || null,
        order: options.sort.field || null,
        category: folderId || null,
        orientation: options.orientation || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, { headers: options.headers || {} }).then(mapItemList).catch(toError);
    }
    function search(folderId, query, options) {
      options = options || {};
      options.paging = options.paging || {};
      options.sort = options.sort || {};
      var requestOptions = {
        q: query || null,
        limit: options.paging.size || 50,
        page: options.paging.cursor || null,
        order: options.sort.field || null,
        category: folderId || null,
        orientation: options.orientation || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, { headers: options.headers || {} }).then(mapItemList).catch(toError);
    }
    return {
      list: list,
      search: search
    };
  };
}(sources_bigstock_parsers_items, sources_bigstock_parsers_error);
sources_decorators = function (Promise, notifier, utils) {
  function addEvents(eventsTarget, events, methods) {
    var methodsWithEvents = {};
    Object.keys(events).forEach(function (eventKey) {
      var methodName = utils.snakeToCamel(eventKey.toLowerCase());
      if (typeof methods[methodName] === 'object' && methods[methodName] !== null && typeof events[eventKey] === 'object' && events[eventKey] !== null) {
        methodsWithEvents[methodName] = addEvents(eventsTarget, events[eventKey], methods[methodName]);
        return;
      } else if (typeof methods[methodName] !== 'function') {
        return;
      }
      // define new method with event generation
      methodsWithEvents[methodName] = function () {
        // emit before event and call native method
        //var event = notifier.emit(eventsTarget, events[eventKey], {arguments: arguments});
        var args = [].slice.call(arguments);
        var promise = methods[methodName].apply(methods, args);
        var params = { arguments: args };
        var event;
        var wrapped;
        if (Array.isArray(promise)) {
          params.promises = promise;
          event = notifier.emit(eventsTarget, events[eventKey], params);
          promise.forEach(function (promise, index) {
            var wrappedInner = promise.then(function (data) {
              event.resolveAt(index, data);
            }, function (reason) {
              event.rejectAt(index, reason);
            });
            promise.progress(function (progress) {
              wrappedInner.notify(progress);
            });
          });
          return promise;
        }
        event = notifier.emit(eventsTarget, events[eventKey], params);
        wrapped = promise.then(function (data) {
          event.resolve(data);
          return data;
        }, function (reason) {
          event.reject(reason);
          return Promise.reject(reason);
        });
        promise.progress(function (progress) {
          wrapped.notify(progress);
        });
        return wrapped;
      };
    });
    return methodsWithEvents;
  }
  return { addEvents: addEvents };
}(bluebird_extended, events_notifier, utils_utils);
events_list = {
  /**
   * @summary List of possible folders events
   * @enum
   * @memberof wixmp.events
   */
  FOLDERS: {
    LIST: 'folders.list',
    REMOVE: 'folders.remove',
    /**
     * @summary List of possible trashed folders events
     * @enum
     * @memberof wixmp.events.folders
     */
    TRASH: {
      LIST: 'folders.trash.list',
      RESTORE: 'folders.trash.restore',
      REMOVE: 'folders.trash.remove'
    }
  },
  /**
   * @summary List of possible folder events
   * @enum
   * @memberof wixmp.events
   */
  FOLDER: {
    CREATE: 'folder.create',
    UPDATE: 'folder.update'
  },
  /**
   * @summary List of possible items events
   * @enum
   * @memberof wixmp.events
   */
  ITEMS: {
    LIST: 'items.list',
    REMOVE: 'items.remove',
    SEARCH: 'items.search',
    SEARCH_BY_TAG: 'items.searchByTag',
    /**
     * @summary List of possible trashed items events
     * @enum
     * @memberof wixmp.events.items
     */
    TRASH: {
      LIST: 'items.trash.list',
      RESTORE: 'items.trash.restore',
      REMOVE: 'items.trash.remove'
    },
    /**
     * @summary List of possible site_media items events
     * @enum
     * @memberof wixmp.events.items
     */
    SITE_MEDIA: {
      LIST: 'items.siteMedia.list',
      REMOVE: 'items.siteMedia.remove',
      ADD: 'items.siteMedia.add'
    }
  },
  /**
   * @summary List of possible item events
   * @enum
   * @memberof wixmp.events
   */
  ITEM: {
    GET: 'item.get',
    UPDATE: 'item.update',
    UPLOAD: 'item.upload',
    UPLOAD_RESUMABLE: 'item.uploadResumable',
    UPLOAD_BY_URL: 'item.uploadByUrl'
  },
  /**
   * @summary List of possible trash events
   * @enum
   * @memberof wixmp.events
   */
  TRASH: {
    REMOVE: 'trash.remove',
    RESTORE: 'trash.restore'
  }
};
sources_bigstock_BigStock = function (defaultSettings, initFolders, initItems, initHttp, utils, decorators, eventsList) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'bigstock';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_bigstock_settings, sources_bigstock_folders, sources_bigstock_items, utils_http, utils_utils, sources_decorators, events_list);
sources_shutterstock_settings = {
  apiUrl: '//pix.wix.com/services/shutterstock',
  itemsLimit: 50
};
sources_shutterstock_mappers_folder = function (data) {
  return {
    id: data.id,
    name: data.name,
    mediaType: 'picture',
    parentId: null,
    filesCount: null,
    createdAt: null
  };
};
sources_shutterstock_parsers_folders = function (toFolder) {
  return function (res) {
    res.data = (res.data || []).map(toFolder);
    return res;
  };
}(sources_shutterstock_mappers_folder);
sources_shutterstock_folders = function (mapFolderList, Promise) {
  return function () {
    var folders = mapFolderList({
      data: [
        {
          id: null,
          name: 'All'
        },
        {
          id: 0,
          name: 'Transportation'
        },
        {
          id: 1,
          name: 'Animals/Wildlife'
        },
        {
          id: 2,
          name: 'Buildings/Landmarks'
        },
        {
          id: 3,
          name: 'Backgrounds/Textures'
        },
        {
          id: 4,
          name: 'Business/Finance'
        },
        {
          id: 5,
          name: 'Education'
        },
        {
          id: 6,
          name: 'Food and Drink'
        },
        {
          id: 7,
          name: 'Healthcare/Medical'
        },
        {
          id: 8,
          name: 'Holidays'
        },
        {
          id: 9,
          name: 'Objects'
        },
        {
          id: 10,
          name: 'Industrial'
        },
        {
          id: 11,
          name: 'The Arts'
        },
        {
          id: 12,
          name: 'Nature'
        },
        {
          id: 13,
          name: 'People'
        },
        {
          id: 14,
          name: 'Religion'
        },
        {
          id: 15,
          name: 'Science'
        },
        {
          id: 16,
          name: 'Technology'
        },
        {
          id: 17,
          name: 'Signs/Symbols'
        },
        {
          id: 18,
          name: 'Sports/Recreation'
        },
        {
          id: 21,
          name: 'Interiors'
        },
        {
          id: 22,
          name: 'Miscellaneous'
        },
        // {id: 23, name: 'Illustrations/Clip-Art'},
        {
          id: 24,
          name: 'Vintage'
        },
        {
          id: 25,
          name: 'Parks/Outdoor'
        },
        {
          id: 26,
          name: 'Abstract'
        },
        {
          id: 27,
          name: 'Beauty/Fashion'
        },
        // {id: 28, name: 'Editorial'},
        // {id: 29, name: 'Vectors'},
        {
          id: 30,
          name: 'Model Released Only'
        },
        {
          id: 31,
          name: 'Celebrities'
        }
      ]
    });
    function list() {
      return Promise.resolve(folders);
    }
    return { list: list };
  };
}(sources_shutterstock_parsers_folders, bluebird_extended);
sources_shutterstock_mappers_item = function (utils) {
  return function (data) {
    var thumbnailUrl = utils.normalizeUri(data.mosaic_url);
    var previewUrl = utils.normalizeUri(utils.get(data, 'assets.preview.url'));
    return {
      id: data.id,
      name: data.description,
      folderId: null,
      mediaType: 'picture',
      fileUrl: null,
      thumbnailUrl: thumbnailUrl,
      previewUrl: previewUrl,
      createdAt: null,
      tags: [],
      width: null,
      height: null
    };
  };
}(utils_utils);
sources_shutterstock_parsers_items = function (toItem) {
  return function (res) {
    var data = res.data;
    var remainingItemsCount = data.total_count - data.page * data.per_page;
    var cursor = remainingItemsCount > 0 ? data.page + 1 : null;
    var size = data.per_page;
    res.data = (data.data || []).map(toItem);
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_shutterstock_mappers_item);
sources_shutterstock_parsers_error = function (Promise) {
  return function (response) {
    response.data = response.data || {};
    var data = response.data;
    var code;
    if (Array.isArray(data)) {
      code = data[0].code || data[0];
    } else {
      code = data.code;
    }
    response.data.message = code;
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_shutterstock_items = function (mapItemList, toError) {
  return function (settings, http) {
    function formatCategory(id) {
      if (id === null || typeof id === 'undefined') {
        return null;
      }
      return id;
    }
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      options.sort = options.sort || {};
      var requestOptions = {
        per_page: options.paging.size || settings.itemsLimit,
        page: options.paging.cursor || null,
        order: options.sort.field || null,
        category: formatCategory(folderId),
        orientation: options.orientation || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, { headers: options.headers || {} }).then(mapItemList).catch(toError);
    }
    function search(folderId, query, options) {
      options = options || {};
      options.paging = options.paging || {};
      options.sort = options.sort || {};
      var requestOptions = {
        query: query || null,
        per_page: options.paging.size || settings.itemsLimit,
        page: options.paging.cursor || null,
        order: options.sort.field || null,
        category: formatCategory(folderId),
        orientation: options.orientation || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, { headers: options.headers || {} }).then(mapItemList).catch(toError);
    }
    return {
      list: list,
      search: search
    };
  };
}(sources_shutterstock_parsers_items, sources_shutterstock_parsers_error);
sources_shutterstock_ShutterStock = function (defaultSettings, initFolders, initItems, initHttp, utils, decorators, eventsList) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'shutterstock';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_shutterstock_settings, sources_shutterstock_folders, sources_shutterstock_items, utils_http, utils_utils, sources_decorators, events_list);
sources_public_mappers_folder = function (data, parentId) {
  return {
    id: data.guid,
    name: data.title,
    mediaType: data.mediaType,
    parentId: parentId || null,
    filesCount: null,
    createdAt: null
  };
};
sources_public_parsers_folders = function (toFolder) {
  return function (res) {
    res.data = (res.data.category.children || []).map(toFolder);
    return res;
  };
}(sources_public_mappers_folder);
sources_public_parsers_error = function (Promise) {
  return function (response) {
    response.data = response.data || {};
    response.data.message = response.message;
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_public_folders = function (utils, mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      var data = {
        levels: 1,
        language: options.language
      };
      if (settings.wixUser) {
        folderId += ':wix';
      }
      data.guid = folderId;
      return http.get(settings.apiUrl + '/categories', data, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapFolderList).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_public_parsers_folders, sources_public_parsers_error);
services_thumbnail_generator_resize = function (utils) {
  function isResizable(url) {
    return /\.(png|jpe?g|gif)/i.test(url);
  }
  function getFullName(url) {
    var path = url.split('/');
    return path.pop() || '';
  }
  function getFolderUrl(url) {
    var path = url.split('/');
    if (path.length <= 1) {
      return '';
    }
    path.pop();
    return path.join('/') + '/';
  }
  var vangoghModes = {
    fill: 'srz',
    fit: 'srb'
  };
  function transformModeToVangogh(mode) {
    return vangoghModes[mode] || mode;
  }
  function createRegexp(t, options) {
    t = t.replace(/[()\[\]\.^$|?+]/g, '\\$&');
    return new RegExp(t, options);
  }
  function insertDataInTemplate(template, data) {
    Object.keys(data).forEach(function (key) {
      var regExp = createRegexp('#' + key + '#', 'g');
      template = template.replace(regExp, data[key]);
    });
    return template;
  }
  var compilers = {
    // //some.server.com/folder/123.jpg >>
    // //some.server.com/folder/123.jpg_srz_100_200_75_22_0.5_1.20_0.00_jpg_srz
    vangogh: function (sourceUrl) {
      return getFolderUrl(sourceUrl) + getFullName(sourceUrl) + '_#mode#_#width#_#height#_75_22_0.5_1.20_0.00_jpg_#mode#';
    },
    // //some.server.com/folder/123/file.jpg >>
    // //some.server.com/folder/123/v1/fill/w_100,h_200/file.jpg'
    // //some.server.com/folder/123/123.jpg >>
    // //some.server.com/folder/123/v1/fill/w_100,h_200/123.jpg'
    rembrandt: function (sourceUrl) {
      return getFolderUrl(sourceUrl) + 'v1/#mode#/w_#width#,h_#height#/' + getFullName(sourceUrl);
    },
    // //some.server.com/folder/123.jpg >>
    // //some.server.com/folder/123.jpg/v1/fill/w_100,h_200/123.jpg
    vanbrandt: function (sourceUrl) {
      return getFolderUrl(sourceUrl) + getFullName(sourceUrl) + '/v1/#mode#/w_#width#,h_#height#/' + getFullName(sourceUrl);
    }
  };
  var REGEXPS = {
    VANGOGH: /_sr[bz]_(?:[0-9\.]+_)+[a-z0-9]+_sr[bz]$/i,
    VANBRANDT: /([a-z0-9_\-]+\.[a-z0-9]+)\/v[0-9]+\/(?:fill|fit)\/[^\/]+\/\1$/i,
    REMBRANDT: /([a-z0-9_\-]+)\/v[0-9]+\/(?:fill|fit)\/[^\/]+(\/(?:\1|file)\.[a-z0-9_]+)$/i
  };
  function restoreUrlIfResized(sourceUrl) {
    return sourceUrl.replace(REGEXPS.VANGOGH, '').replace(REGEXPS.VANBRANDT, '$1').replace(REGEXPS.REMBRANDT, '$1$2');
  }
  /**
   * Resize image
   * @param sourceUrl {string}
   * @param settings {object}
   * @param settings.width {number} default 200
   * @param settings.height {number} default 200
   * @param settings.mode {string} from this.MODES, default 'fill'
   * @param apiName {string} from this.APIS, default 'rembrandt'
   * @return {string|undefined} URL for resized image or undefined if can`t resize
   */
  return function (sourceUrl, settings, apiName) {
    sourceUrl = restoreUrlIfResized(sourceUrl);
    if (!isResizable(sourceUrl)) {
      return undefined;
    }
    apiName = apiName || 'rembrandt';
    settings = utils.extend({
      width: 200,
      height: 200,
      mode: 'fill'
    }, settings);
    if (apiName === 'vangogh') {
      settings.mode = transformModeToVangogh(settings.mode);
    }
    var templateUrl = compilers[apiName](sourceUrl);
    var compiledUrl = insertDataInTemplate(templateUrl, settings);
    return utils.normalizeUri(compiledUrl);
  };
}(utils_utils);
services_thumbnail_generator_get_wix_thumbnails_urls = function (utils, resize) {
  function getUrlForResize(item, filesUrl) {
    if (item.thumbnailUrl) {
      return filesUrl + '/' + item.thumbnailUrl;
    }
    switch (item.mediaType) {
    case 'picture':
    case 'site_icon':
    case 'watermark':
    case 'secure_picture':
      return filesUrl + '/' + item.fileUrl;
    case 'video':
    case 'secure_video':
      if (item.fileOutput && item.fileOutput.image && item.fileOutput.image[2] && item.fileOutput.image[2].url) {
        return filesUrl + '/' + item.fileOutput.image[2].url;
      }
      break;
    case 'ufont':
      if (item.fileOutput && item.fileOutput.image && item.fileOutput.image[0] && item.fileOutput.image[0].url) {
        return filesUrl + '/' + item.fileOutput.image[0].url;
      }
      break;
    default:
      break;
    }
  }
  function getSameUrls(thumbnailSizes, url) {
    return Object.keys(thumbnailSizes).reduce(function (urls, sizeName) {
      urls[sizeName + 'Url'] = url;
      return urls;
    }, {});
  }
  function getResizedUrls(thumbnailSizes, urlForResize, imageOperationsApi) {
    return Object.keys(thumbnailSizes).reduce(function (urls, sizeName) {
      var url = resize(urlForResize, thumbnailSizes[sizeName], imageOperationsApi);
      if (url) {
        urls[sizeName + 'Url'] = url;
      }
      return urls;
    }, {});
  }
  return function (item, thumbnailSizes, settings) {
    var urlForResize = getUrlForResize(item, settings.filesUrl);
    var urls = {};
    if (item.mediaType === 'shape') {
      item.thumbnailUrl = utils.normalizeUri(settings.filesUrl + '/' + item.thumbnailUrl);
      urls = getSameUrls(thumbnailSizes, item.thumbnailUrl);
    } else if (urlForResize) {
      urls = getResizedUrls(thumbnailSizes, urlForResize, settings.imageOperationsApi);
    }
    if (item.fileUrl) {
      urls.originalUrl = utils.normalizeUri(settings.filesUrl + '/' + item.fileUrl);
    }
    return urls;
  };
}(utils_utils, services_thumbnail_generator_resize);
services_thumbnail_generator_get_wix_video_preview_urls = function (utils) {
  return function (item, settings) {
    if (!item.fileOutput || !item.fileOutput.video) {
      return null;
    }
    return item.fileOutput.video.filter(function (video) {
      return video.quality <= settings.videoPreviewQuality;
    }).map(function (video) {
      return utils.normalizeUri(settings.videoFilesUrl + '/' + video.url);
    });
  };
}(utils_utils);
sources_public_mappers_item = function (utils, getWixThumbnailsUrls, getWixVideoPreviewUrls) {
  return function (itemData, settings, thumbnailSizes) {
    var item = {
      id: itemData.guid,
      name: itemData.title,
      mediaType: itemData.mediaType,
      fileName: itemData.fileName,
      fileUrl: itemData.fileUrl,
      createdAt: null,
      tags: utils.splitTags(itemData.tags),
      tagsEn: utils.splitTags(itemData.tagsEn),
      width: itemData.width,
      height: itemData.height,
      fileOutput: itemData.fileOutput || null,
      fileInput: itemData.fileInput || null,
      vendor: itemData.vendor || null,
      reference: itemData.reference || null,
      creator: itemData.creator || null,
      externalId: itemData.externalId || null,
      subtype: itemData.subtype || null
    };
    if (itemData.thumbnailUrl && itemData.fileUrl) {
      var folderName = itemData.fileUrl.split('/')[0];
      item.thumbnailUrl = folderName + '/' + itemData.thumbnailUrl;
    }
    item.videoPreviewUrls = getWixVideoPreviewUrls(item, settings);
    var sizes = utils.extend({}, settings.thumbnailSizes, thumbnailSizes);
    utils.extend(item, getWixThumbnailsUrls(item, sizes, settings));
    return item;
  };
}(utils_utils, services_thumbnail_generator_get_wix_thumbnails_urls, services_thumbnail_generator_get_wix_video_preview_urls);
sources_public_parsers_items = function (utils, toItem) {
  return function (res, settings, thumbnailSizes) {
    res.data.nextPage = res.data.nextPage || '';
    var cursor = utils.getParameterByName(res.data.nextPage, 'pageNumber') || null;
    var size = utils.getParameterByName(res.data.nextPage, 'pageSize') || null;
    res.data = (res.data.items || []).map(function (itemData) {
      return toItem(itemData, settings, thumbnailSizes);
    });
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(utils_utils, sources_public_mappers_item);
sources_public_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function requestItems(action, requestOptions, thumbSizeData, headers) {
      return http.get(settings.apiUrl + action, requestOptions, {
        withCredentials: true,
        headers: headers || {}
      }).then(function (response) {
        return mapItemList(response, settings, thumbSizeData);
      }).catch(toError);
    }
    /**
     * Gets list of items
     * @param folderId
     * @param options
     * @returns {Promise}
     * @fulfill {Items}
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        guid: folderId || null,
        language: options.language,
        pageSize: options.paging.size || settings.itemsLimit,
        pageNumber: options.paging.cursor || 1
      };
      return requestItems('/items', requestOptions, options.thumbnails, options.headers);
    }
    function search(folderId, query, options) {
      options = options || {};
      options.paging = options.paging || {};
      var mediaType = options.mediaType || 'picture';
      var requestOptions = {
        guid: folderId || null,
        language: options.language,
        searchString: query || '',
        pageSize: options.paging.size || settings.itemsLimit,
        pageNumber: options.paging.cursor || 1
      };
      var path = '/search';
      if (mediaType === 'picture') {
        path = '/search2';
      }
      //return requestItems('/search2', requestOptions, options.thumbnails, options.headers);
      return requestItems(path, requestOptions, options.thumbnails, options.headers);
    }
    return {
      list: list,
      search: search
    };
  };
}(utils_utils, sources_public_parsers_items, sources_public_parsers_error);
sources_public_item = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function getMulti(itemIds, options) {
      options = options || {};
      if (Array.isArray(itemIds)) {
        itemIds = itemIds.join(',');
      }
      var postData = {
        guid: itemIds,
        language: options.language
      };
      var headers = utils.extend(options.headers || {}, { 'Content-Type': 'application/x-www-form-urlencoded' });
      return http.post(settings.apiUrl + '/item', postData, {}, {
        withCredentials: true,
        headers: headers
      }).then(function (response) {
        return mapItemList(response, settings, options.thumbnails);
      }).catch(toError);
    }
    return { get: getMulti };
  };
}(utils_utils, sources_public_parsers_items, sources_public_parsers_error);
sources_public_settings = {
  apiUrl: '//publicmedia.wix.com/public',
  itemsLimit: 50,
  imageOperationsApi: 'vangogh',
  filesUrl: '//static.wixstatic.com',
  videoFilesUrl: '//video.wixstatic.com',
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  },
  videoPreviewQuality: '480p',
  wixUser: false
};
sources_public_Public = function (initFolders, initItems, initItem, initHttp, defaultSettings, utils, decorators, eventsList) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    var item = initItem(settings, http);
    this.name = 'public';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
    this.item = decorators.addEvents(this, eventsList.ITEM, item);
  };
}(sources_public_folders, sources_public_items, sources_public_item, utils_http, sources_public_settings, utils_utils, sources_decorators, events_list);
sources_private_mappers_folder = function (folderData) {
  /**
   * Folder
   * {String} id
   * {String} parentId
   * {String} name
   * {String} mediaType
   * {Number} filesCount
   * {Number} createdAt
   */
  return {
    id: folderData.folder_id,
    parentId: folderData.parent_folder_id || null,
    name: folderData.folder_name,
    mediaType: folderData.media_type,
    filesCount: folderData.files_count,
    createdAt: folderData.created_ts
  };
};
sources_private_parsers_error = function (Promise) {
  return function (reason) {
    if (reason && reason.status === 403 && reason.data && reason.data.error_description === 'Missing Wix session') {
      reason.status = 401;
      reason.data.message = 'Wix Session required';
    }
    return Promise.reject(reason);
  };
}(bluebird_extended);
sources_private_folders = function (toFolder, toError) {
  return function (settings, http) {
    function mapFolderList(res) {
      res.data = (res.data.folders || []).map(toFolder);
      return res;
    }
    /**
     * @summary Return the list of folders
     * @memberof source.folders
     * @param {String} folderId
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List[]} List with Folders
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      return http.get(settings.apiUrl + '/folders', {
        media_type: options.mediaType || 'picture',
        folder_id: folderId || null
      }, { headers: options.headers || {} }).then(mapFolderList).catch(toError);
    }
    function removeFolder(folderId, options) {
      var url = settings.apiUrl + '/folders/' + folderId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: folderId };
        return res;
      }).catch(toError);
    }
    /**
     * @summary Removes the list of folders with given ids
     * @memberof source.folders
     * @param {string[]} folderIds Array of folder ids
     * @param {Object} options
     * @returns {Promise[]}
     */
    function remove(folderIds, options) {
      options = options || {};
      return folderIds.map(function (folderId) {
        return removeFolder(folderId, options);
      });
    }
    return {
      list: list,
      remove: remove
    };
  };
}(sources_private_mappers_folder, sources_private_parsers_error);
sources_private_validators_new_props = function (newProps) {
  if (typeof newProps !== 'object' || newProps === null) {
    return {
      valid: false,
      message: 'Please specify new props'
    };
  }
  if (typeof newProps.name !== 'undefined' && !newProps.name) {
    return {
      valid: false,
      message: 'Please specify name'
    };
  }
  if (typeof newProps.folderId !== 'undefined' && !newProps.folderId) {
    return {
      valid: false,
      message: 'Please specify folder id'
    };
  }
  if (typeof newProps.parentId !== 'undefined' && !newProps.parentId) {
    return {
      valid: false,
      message: 'Please specify parent folder id'
    };
  }
  if (typeof newProps.tags !== 'undefined' && !Array.isArray(newProps.tags)) {
    return {
      valid: false,
      message: 'Tags should be an array'
    };
  }
  return { valid: true };
};
sources_private_folder = function (mappers, utils, toFolder, toError, validateNewProps) {
  return function (settings, http) {
    function mapFolder(res) {
      res.data = toFolder(res.data);
      return res;
    }
    /**
     * @summary Create a new folder with given name and parameters
     * @memberof source.folder
     * @param {string} folderName
     * @param {object} options
     * @param {string} options.mediaType
     * @param {string} options.parentId
     * @returns {Promise}
     * @fulfill {Folder} New folder object
     * @reject {Error}
     */
    function create(folderName, options) {
      if (!folderName) {
        return toError(mappers.toError({
          status: -200,
          statusText: 'Internal JS Error',
          data: { message: 'Please specify name' }
        }));
      }
      options = options || {};
      var url = settings.apiUrl + '/folders';
      var data = {
        folder_name: folderName,
        media_type: options.mediaType || 'picture',
        parent_folder_id: options.parentId || null
      };
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(mapFolder).catch(toError);
    }
    /**
     * @summary Updates the folder with given diff object
     * @memberof source.folder
     * @param {Folder} folder Current folder object that should be updated
     * @param {object} newFolderProps
     * @param {object} options
     * @returns {Promise}
     * @fulfill {Folder} Modified folder object
     * @reject {Error}
     */
    function update(folder, newFolderProps, options) {
      var arePropsValid = validateNewProps(newFolderProps);
      if (arePropsValid.valid === false) {
        return toError(mappers.toError({
          status: -200,
          statusText: 'Internal JS Error',
          data: { message: arePropsValid.message }
        }));
      }
      var data = {};
      if (newFolderProps.name) {
        data.folder_name = newFolderProps.name;
      }
      if (newFolderProps.parentId) {
        data.parent_folder_id = newFolderProps.parentId;
      }
      options = options || {};
      var url = settings.apiUrl + '/folders/' + folder.id + '/put';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(function (res) {
        res.data = utils.extend({}, folder, newFolderProps);
        return res;
      }).catch(toError);
    }
    return {
      create: create,
      update: update
    };
  };
}(utils_mappers, utils_utils, sources_private_mappers_folder, sources_private_parsers_error, sources_private_validators_new_props);
sources_private_mappers_item = function (mappers, utils, getWixThumbnailsUrls, getWixVideoPreviewUrls) {
  return function (itemData, settings, thumbnailSizes) {
    var normalizeUri = utils.normalizeUri;
    var item = {
      id: itemData.file_name,
      folderId: itemData.parent_folder_id || null,
      fileSize: itemData.file_size,
      name: itemData.original_file_name,
      mediaType: itemData.media_type,
      fileUrl: itemData.file_url ? normalizeUri(itemData.file_url) : null,
      createdAt: itemData.created_ts,
      readOnly: itemData.read_only || null,
      labels: itemData.labels || [],
      tags: utils.splitTags(itemData.tags),
      width: itemData.width || null,
      height: itemData.height || null,
      fileInfo: itemData.file_info ? mappers.toObject(itemData.file_info) : null,
      fileInput: itemData.file_input ? mappers.toObject(itemData.file_input) : null,
      fileOutput: itemData.file_output ? mappers.toObject(itemData.file_output) : null,
      transcodingStatus: itemData.op_status
    };
    var sizes = utils.extend({}, settings.thumbnailSizes, thumbnailSizes);
    utils.extend(item, getWixThumbnailsUrls(item, sizes, settings));
    if (sizes.thumbnail && !item.thumbnailUrl && itemData.icon_url) {
      item.thumbnailUrl = normalizeUri(settings.filesUrl + '/' + itemData.icon_url);
    }
    Object.keys(sizes).forEach(function (thumbType) {
      if (!item[thumbType + 'Url']) {
        item[thumbType + 'Url'] = item.thumbnailUrl;
      }
    });
    Object.keys(item).forEach(function (prop) {
      if (item[prop] === undefined) {
        delete item[prop];
      }
    });
    item.videoPreviewUrls = getWixVideoPreviewUrls(item, settings) || null;
    return item;
  };
}(utils_mappers, utils_utils, services_thumbnail_generator_get_wix_thumbnails_urls, services_thumbnail_generator_get_wix_video_preview_urls);
sources_private_items = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.files || []).map(function (data) {
        return toItem(data, settings, thumbnailSizes);
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    var previousCursor = null;
    /**
     * @summary Returns the list of items from the given folder
     * @memberof source.items
     * @param {string} folderId
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        parent_folder_id: folderId,
        media_type: options.mediaType || 'picture'
      };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      return http.get(settings.apiUrl + '/files/getpage', queryParams, { headers: options.headers || {} }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: previousCursor === response.data.cursor ? null : response.data.cursor
        };
        previousCursor = response.data.cursor;
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    function removeItem(itemId, options) {
      var queryParams = {};
      if (settings.ns) {
        queryParams.ns = settings.ns;
      }
      var url = settings.apiUrl + '/files/' + itemId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, queryParams, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    /**
     * @summary Removes the items with given ids
     * @memberof source.items
     * @param {Array} itemIds
     * @returns {Array}
     */
    function remove(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return removeItem(itemId, options);
      });
    }
    /**
     * @summary Return list of items found by tag
     * @memberof source.items
     * @param {string} tag
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function searchByTag(tag, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        media_type: options.mediaType || 'picture',
        order: sort.direction === 'desc' ? '-' + sort.order : sort.order
      };
      return http.get(settings.apiUrl + '/files/get?tag=' + tag, queryParams, {
        cache: false,
        headers: options.headers || {}
      }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    /**
     * @summary Return list of items found by text query
     * @memberof source.items
     * @param {string} folderId
     * @param {string} query
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function search(folderId, query, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      query = encodeURIComponent(query);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        media_type: options.mediaType || 'picture',
        parent_folder_id: folderId,
        order: sort.direction === 'desc' ? '-' + sort.order : sort.order
      };
      return http.get(settings.apiUrl + '/files/search/getpage?query=' + query, queryParams, {
        cache: false,
        headers: options.headers || {}
      }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    return {
      list: list,
      remove: remove,
      searchByTag: searchByTag,
      search: search
    };
  };
}(bluebird_extended, utils_utils, sources_private_mappers_item, sources_private_parsers_error);
constants_transcoding_statuses = {
  FAILED: 'FAILED',
  IN_QUEUE: 'IN-QUEUE',
  INPROGRESS: 'INPROGRESS',
  PREVIEW_READY: 'PREVIEW_READY',
  READY: 'READY'
};
sources_private_item = function (Promise, utils, toItem, toError, validateNewProps, mappers, TRANSCODING_STATUSES) {
  var POLLING_TIMEOUT = 15 * 1000;
  var TIMEOUT_BEFORE_REJECT = 10 * 60 * 1000;
  var MIN_FONT_SIZE = 4096;
  return function (settings, http, socket, pollItem, resumableUpload) {
    var isPromiseResolved;
    var rejectTimeoutId;
    var funcToUnsubscribe;
    function getFilesSizeLimit(mediaType) {
      return settings.uploadLimits[utils.snakeToCamel(mediaType)];
    }
    function fileSizeIsInvalid(fileSource) {
      return fileSource.file.size >= getFilesSizeLimit(fileSource.mediaType);
    }
    function mapItem(res, thumbnailsSizes) {
      res.data = toItem(res.data, settings, thumbnailsSizes);
      return res;
    }
    function cleanUp() {
      isPromiseResolved = true;
      clearTimeout(rejectTimeoutId);
      socket.off('message', funcToUnsubscribe);
    }
    function resolveItemIdFromSocketMessage(itemIdFromResponse, resolve) {
      return function (message) {
        var itemId = utils.get(message, 'file.file_name');
        if (message.type === 'status_update' && utils.get(message, 'file.op_status') === TRANSCODING_STATUSES.READY && itemId === itemIdFromResponse) {
          resolve(itemId);
        }
      };
    }
    function checkItemStatus(itemId, resolve) {
      setTimeout(function () {
        if (isPromiseResolved) {
          return;
        }
        get(itemId).then(function (response) {
          if (utils.get(response, 'data.transcodingStatus') !== TRANSCODING_STATUSES.READY) {
            return Promise.reject();
          }
          resolve(itemId);
        }).catch(function () {
          checkItemStatus(itemId, resolve);
        });
      }, POLLING_TIMEOUT);
    }
    function resolveItemIdFromResponse(itemId) {
      return new Promise(function (resolve, reject) {
        if (!itemId) {
          reject();
          return;
        }
        checkItemStatus(itemId, resolve);
      });
    }
    function waitForItemFromStorage(response) {
      isPromiseResolved = false;
      var itemId = utils.get(response, 'data.payload.file_name') || utils.get(response, 'data.file_name');
      var resolveItemIdFromSocket = new Promise(function (resolve) {
        funcToUnsubscribe = resolveItemIdFromSocketMessage(itemId, resolve);
        socket.on('message', funcToUnsubscribe);
      });
      var rejectNotReadyItem = new Promise(function (resolve, reject) {
        rejectTimeoutId = setTimeout(function () {
          reject({
            status: 406,
            data: { message: 'Not ready item' }
          });
        }, TIMEOUT_BEFORE_REJECT);
      });
      return Promise.race([
        resolveItemIdFromSocket,
        resolveItemIdFromResponse(itemId),
        rejectNotReadyItem
      ]).then(function (itemId) {
        cleanUp();
        return Promise.resolve(itemId);
      }).catch(function (error) {
        cleanUp();
        return Promise.reject(error);
      });
    }
    function getUploadUrl(fileSource) {
      function getEndpoint(mediaType) {
        if (mediaType === 'secure_music') {
          return 'music-goods/upload';
        } else if (mediaType === 'video') {
          return 'video/upload';
        }
        return 'upload';
      }
      var file = fileSource.file;
      var url = settings.apiUrl + '/files/' + getEndpoint(fileSource.mediaType) + '/url';
      var data = {
        media_type: fileSource.mediaType,
        // we just need an extension here
        file_name: file.name.toLowerCase(),
        // file_name: '_.' + file.name.split('.').pop().toLowerCase(),
        file_size: file.size,
        content_type: file.type
      };
      var postOptions = {
        withCredentials: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      };
      return http.post(url, data, null, postOptions);
    }
    function uploadByUrl(fileSource, options, skipWaitingItemFromStorage) {
      options = options || {};
      var data = {
        url: utils.normalizeUri(fileSource.url),
        media_type: fileSource.mediaType,
        name: fileSource.name || 'Untitled',
        tags: fileSource.tags ? fileSource.tags.join(',') : null,
        parent_folder_id: fileSource.folderId || null
      };
      // some sources as Google Drive requires auth headers to allow downloading files via url
      if (fileSource.headers) {
        data.headers = JSON.stringify(fileSource.headers);
      }
      if (fileSource.catalogCallbackUrl) {
        data.cat_callback_url = fileSource.catalogCallbackUrl;
      }
      if (settings.siteMediaToken) {
        data.siteMediaToken = settings.siteMediaToken;
      }
      var apiUrl = settings.apiUrl + '/files/upload/external';
      if (settings.asyncUploadByUrl || skipWaitingItemFromStorage) {
        socket.open();
        var apiUrlAsync = apiUrl + '/async';
        var headers = utils.extend({}, options.headers, { 'Content-Type': 'application/x-www-form-urlencoded' });
        var postOptions = { headers: headers };
        return http.post(apiUrlAsync, data, null, postOptions).then(function (response) {
          if (skipWaitingItemFromStorage) {
            pollItem(response.data.payload.file_name);
            response.data = toItem(response.data.payload, settings);
            return response;
          }
          return waitForItemFromStorage(response).then(get);
        }).catch(toError);
      }
      var uploadPromise = http.get(apiUrl, data, { headers: options.headers || {} }).progress(function (progress) {
        uploadPromise.notify(progress);
      }).then(function (res) {
        return mapItem(res, options.thumbnails);
      });
      return uploadPromise;
    }
    function upload(fileSource, options) {
      options = options || {};
      var data = {
        parent_folder_id: fileSource.folderId || null,
        file: fileSource.file,
        media_type: fileSource.mediaType
      };
      if (fileSource.catalogCallbackUrl) {
        data.cat_callback_url = fileSource.catalogCallbackUrl;
      }
      if (fileSource.encodingOptions) {
        data.encoding_options = JSON.stringify(fileSource.encodingOptions);
      }
      if (settings.vision) {
        data.vision = settings.vision.join(',');
      }
      if (settings.siteMediaToken) {
        data.siteMediaToken = settings.siteMediaToken;
      }
      if (fileSizeIsInvalid(fileSource)) {
        var limit = utils.bytesToSize(getFilesSizeLimit(fileSource.mediaType));
        var fileSize = utils.bytesToSize(fileSource.file.size);
        return Promise.reject(mappers.toError({
          status: -406,
          statusText: 'Not Acceptable',
          data: {
            error_code: -7752,
            error_description: 'File size ' + fileSize + ' exceeds upload limit of ' + limit,
            error_info: {
              key: 'wmp_error.file_size_exceeded_limit',
              args: [
                fileSize,
                limit
              ]
            }
          }
        }));
      }
      var isAsyncFontUploadAllowed = settings.asyncFontUpload;
      var isUploadFont = data.media_type === 'ufont';
      var isBigFile = utils.get(data, 'file.size') > MIN_FONT_SIZE;
      var isAsyncFontUpload = isAsyncFontUploadAllowed && isUploadFont && isBigFile;
      var uploadPromiseChain = getUploadUrl(fileSource).then(function (response) {
        var responseData = response.data;
        data.upload_token = responseData.upload_token;
        if (isAsyncFontUpload) {
          socket.open();
          data.upload_async = true;
        }
        return http.upload(responseData.upload_url, data, { headers: options.headers || {} }).progress(function (progress) {
          uploadPromiseChain.notify(progress);
        });
      }).then(function (response) {
        response.data = response.data[0];
        if (isAsyncFontUpload) {
          return waitForItemFromStorage(response).then(get);
        }
        var status = utils.get(response, 'data.op_status');
        if (settings.asyncTranscoding && status && status !== TRANSCODING_STATUSES.READY) {
          socket.open();
          pollItem(response.data.file_name);
        }
        response.data = toItem(response.data, settings);
        return response;
      }).catch(toError);
      return uploadPromiseChain;
    }
    function uploadResumable(fileSource, options) {
      if (fileSizeIsInvalid(fileSource)) {
        var limit = utils.bytesToSize(getFilesSizeLimit(fileSource.mediaType));
        var fileSize = utils.bytesToSize(fileSource.file.size);
        return Promise.reject(mappers.toError({
          status: -406,
          statusText: 'Not Acceptable',
          data: {
            error_code: -7752,
            error_description: 'File size ' + fileSize + ' exceeds upload limit of ' + limit,
            error_info: {
              key: 'wmp_error.file_size_exceeded_limit',
              args: [
                fileSize,
                limit
              ]
            }
          }
        }));
      }
      var data = {
        parent_folder_id: fileSource.folderId || null,
        file: fileSource.file,
        media_type: fileSource.mediaType || 'picture'
      };
      return resumableUpload(data, options);
    }
    /**
     * @summary Returns item
     * @memberof source.item
     * @param {String} itemId
     * @param {Object} [options]
     * @returns {Promise}
     * @fulfill {Item}
     * @reject {Error}
     */
    function get(itemId, options) {
      options = options || {};
      return http.get(settings.apiUrl + '/files/' + itemId, null, {
        cache: false,
        headers: options.headers || {}
      }).then(function (res) {
        return mapItem(res, options.thumbnails);
      }).catch(toError);
    }
    /**
     * @summary Updates the item with given diff object
     * @memberof source.item
     * @param {Item} item Current item object that should be updated
     * @param {object} newItemProps
     * @param {Object} options
     * @returns {Promise}
     * @fulfill {Item} Modified item object
     * @reject {Error}
     */
    function update(item, newItemProps, options) {
      var arePropsValid = validateNewProps(newItemProps);
      if (arePropsValid.valid === false) {
        return toError(mappers.toError({
          status: -200,
          statusText: 'Internal JS Error',
          data: { message: arePropsValid.message }
        }));
      }
      var data = {};
      if (newItemProps.name) {
        data.original_file_name = newItemProps.name;
      }
      if (newItemProps.folderId) {
        data.parent_folder_id = newItemProps.folderId;
      }
      if (newItemProps.tags) {
        data.tags = newItemProps.tags.join(',');
      }
      options = options || {};
      var url = settings.apiUrl + '/files/' + item.id + '/put';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(function (res) {
        res.data = utils.extend({}, item, newItemProps);
        return res;
      }).catch(toError);
    }
    return {
      upload: upload,
      uploadResumable: uploadResumable,
      uploadByUrl: uploadByUrl,
      get: get,
      update: update
    };
  };
}(bluebird_extended, utils_utils, sources_private_mappers_item, sources_private_parsers_error, sources_private_validators_new_props, utils_mappers, constants_transcoding_statuses);
sources_private_trash = function (toError) {
  return function (settings, http) {
    /**
     * @summary Remove all items in trash
     * @memberof source.trash
     * @param options
     * @returns {Promise}
     * @reject {Error}
     */
    function remove(options) {
      var url = settings.apiUrl + '/trash/delete';
      var data = {
        media_type: options.mediaType || 'picture',
        all_files: true
      };
      return http.post(url, data).catch(toError);
    }
    /**
     * @summary Restore all items in trash
     * @memberof source.trash
     * @param options
     * @returns {Promise}
     * @reject {Error}
     */
    function restore(options) {
      var url = settings.apiUrl + '/trash/restore';
      var data = {
        media_type: options.mediaType || 'picture',
        all_files: true
      };
      return http.post(url, data).catch(toError);
    }
    return {
      remove: remove,
      restore: restore
    };
  };
}(sources_private_parsers_error);
sources_private_itemstrash = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.trash_files || []).map(function (_item) {
        var item = toItem(_item, settings, thumbnailSizes);
        item.isInTrash = true;
        return item;
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        parent_folder_id: folderId,
        media_type: options.mediaType || 'picture'
      };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      return http.get(settings.apiUrl + '/files/getpage/trash', queryParams, { headers: options.headers || {} }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    function removeItem(itemId, options) {
      var url = settings.apiUrl + '/trash/files/' + itemId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    function remove(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return removeItem(itemId, options);
      });
    }
    function restoreItem(itemId, options) {
      var url = settings.apiUrl + '/trash/files/' + itemId + '/restore';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    /**
     * Restore items from trash
     * @param itemIds
     * @param options
     * @returns [Promise] Array of Promise
     */
    function restore(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return restoreItem(itemId, options);
      });
    }
    return {
      list: list,
      remove: remove,
      restore: restore
    };
  };
}(bluebird_extended, utils_utils, sources_private_mappers_item, sources_private_parsers_error);
sources_private_itemssite_media = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.files || []).map(function (_item) {
        var item = toItem(_item, settings, thumbnailSizes);
        item.isInSiteMedia = true;
        return item;
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        parent_folder_id: folderId,
        media_type: options.mediaType || 'picture',
        siteMediaToken: settings.siteMediaToken
      };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      return http.get(settings.apiUrl + '/files/getpage/site', queryParams, { headers: options.headers || {} }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    function removeItem(itemId, options) {
      var data = { files: [itemId] };
      var url = settings.apiUrl + '/files/site/remove?siteMediaToken=' + settings.siteMediaToken;
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    /**
     * Remove items from siteMedia
     * @param itemIds Array of item ids
     * @param options
     * @returns [Promise] Array of Promise
     */
    function remove(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return removeItem(itemId, options);
      });
    }
    /**
     * Add items to siteMedia
     * @param itemIds Array of item ids
     * @param options
     * @returns Promise
     */
    function add(itemIds, options) {
      options = options || {};
      var data = { files: itemIds };
      var url = settings.apiUrl + '/files/site/add?siteMediaToken=' + settings.siteMediaToken;
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).catch(toError);
    }
    return {
      list: list,
      remove: remove,
      add: add
    };
  };
}(bluebird_extended, utils_utils, sources_private_mappers_item, sources_private_parsers_error);
sources_private_folderstrash = function (Promise, utils, toFolder, toError) {
  return function (settings, http) {
    function mapFolderList(res) {
      res.data = (res.data.trash_folders || []).map(function (_folder) {
        var folder = toFolder(_folder);
        folder.isInTrash = true;
        return folder;
      });
      return res;
    }
    function list(folderId, options) {
      options = options || {};
      var queryParams = {
        media_type: options.mediaType || 'picture',
        folder_id: folderId || null,
        trash_type: 'folder'
      };
      return http.get(settings.apiUrl + '/files/getpage/trash', queryParams, { headers: options.headers || {} }).then(mapFolderList).catch(toError);
    }
    function removeFolder(folderId, options) {
      var url = settings.apiUrl + '/trash/folders/' + folderId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: folderId };
        return res;
      }).catch(toError);
    }
    function remove(folderIds, options) {
      options = options || {};
      return folderIds.map(function (folderId) {
        return removeFolder(folderId, options);
      });
    }
    function restoreFolder(folderId, options) {
      var url = settings.apiUrl + '/trash/folders/' + folderId + '/restore';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: folderId };
        return res;
      }).catch(toError);
    }
    function restore(folderIds, options) {
      options = options || {};
      return folderIds.map(function (folderId) {
        return restoreFolder(folderId, options);
      });
    }
    return {
      list: list,
      remove: remove,
      restore: restore
    };
  };
}(bluebird_extended, utils_utils, sources_private_mappers_folder, sources_private_parsers_error);
sources_private_settings = {
  apiUrl: '//files.wix.com',
  imageOperationsApi: 'vangogh',
  filesUrl: '//static.wixstatic.com',
  videoFilesUrl: '//video.wixstatic.com',
  refreshTokenUrl: null,
  requestOptions: { withCredentials: true },
  uploadLimits: {
    default: 15728640,
    document: 15728640,
    picture: 15728640,
    music: 52428800,
    secureMusic: 377487360,
    video: 524288000,
    secureVideo: 1610612736
  },
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    },
    original: {
      width: 1000,
      height: 1000,
      mode: 'fit'
    }
  },
  channel: {
    withCredentials: true,
    jsapiUrl: '/_ah/channel/jsapi',
    tokenUrl: '/users/channel'
  },
  blackArrow: {
    enabled: false,
    wsUrl: 'wss://ws.wixmp.com/ws',
    messageUrl: 'https://ws.wixmp.com/message',
    tokenUrl: '/users/get-batoken'
  },
  asyncFontUpload: false,
  asyncUploadByUrl: false,
  asyncTranscoding: false,
  videoPreviewQuality: '480p'
};
services_channel_channel = function (Promise, initHttp, utils, notifier, eventsList, TRANSCODING_STATUSES) {
  var REFRESH_INTERVAL = 25 * 60 * 1000;
  var REOPEN_CHANNEL_TIMEOUT = 20 * 1000;
  return function (settings, adapter, itemMapper) {
    var http = initHttp();
    var socket = null;
    var jsApiAlreadyLoaded = false;
    var autoRefreshInterval = null;
    function emitItemUpdateEvent(result) {
      var event = notifier.emit(adapter, eventsList.ITEM.UPDATE, {
        arguments: [
          result.data,
          result.data
        ]
      });
      event.resolve(result);
    }
    function onMessage(message) {
      if (message.data === 'server connected') {
        return;
      }
      try {
        message = JSON.parse(message.data);
      } catch (reason) {
        return;
      }
      if (message.type === 'status_update') {
        if (utils.get(message, 'file.op_status') === TRANSCODING_STATUSES.READY) {
          adapter.item.get(utils.get(message, 'file.file_name')).then(emitItemUpdateEvent);
        } else {
          var result = itemMapper(message.file, settings, {}, true);
          emitItemUpdateEvent({ data: result });
        }
      }
    }
    function reopenSocket() {
      if (socket) {
        close();
        openSocket();
      }
    }
    function loadJSLib() {
      if (jsApiAlreadyLoaded) {
        return Promise.resolve();
      }
      var url = utils.get(settings, 'channel.jsapiUrl');
      if (url.indexOf('http') === -1) {
        url = settings.apiUrl + url;
      }
      return utils.getScript(url).then(function () {
        jsApiAlreadyLoaded = true;
      });
    }
    function openSocket() {
      var url = settings.apiUrl + utils.get(settings, 'channel.tokenUrl');
      var withCredentials = utils.get(settings, 'channel.withCredentials');
      var promise = http.get(url, null, { withCredentials: withCredentials });
      return promise.then(function (tokenData) {
        var channel = new goog.appengine.Channel(tokenData.data.token);
        socket = channel.open();
        socket.onmessage = onMessage;
        socket.onclose = reopenSocket;
        socket.onerror = reopenSocket;
        autoRefreshInterval = setInterval(reopenSocket, REFRESH_INTERVAL);
        return socket;
      }).catch(function (reason) {
        return Promise.reject(reason);
      });
    }
    // Retry if user internet connection is overloaded and channel can not be opened
    function reopenChannel() {
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve(open());
        }, REOPEN_CHANNEL_TIMEOUT);
      });
    }
    function open() {
      if (socket) {
        return Promise.resolve();
      }
      return loadJSLib().then(openSocket).catch(reopenChannel);
    }
    function close() {
      if (socket) {
        socket.close();
        socket = null;
        if (autoRefreshInterval) {
          clearInterval(autoRefreshInterval);
        }
      }
    }
    return {
      open: open,
      close: close
    };
  };
}(bluebird_extended, utils_http, utils_utils, events_notifier, events_list, constants_transcoding_statuses);
services_new_relic = function () {
  function sendNewRelicError(message, details) {
    if (!window.newrelic) {
      return;
    }
    window.newrelic.addPageAction('error', {
      source: 'wixmp-sdk',
      message: message,
      details: details
    });
  }
  return { sendError: sendNewRelicError };
}();
services_channel_black_arrow = function (Promise, initHttp, utils, newRelic, notifier, eventsList, toError, TRANSCODING_STATUSES) {
  var OPEN_REJECT_TIMEOUT = 5 * 1000;
  var REOPEN_TIMEOUT = 30 * 1000;
  function cachePromise(factory) {
    var pending;
    return function () {
      if (pending) {
        return pending;
      }
      pending = factory.apply(this, arguments).catch(function (reason) {
        pending = null;
        return Promise.reject(reason);
      });
      return pending;
    };
  }
  return function (settings, adapter, itemMapper, requestOptions) {
    var http = initHttp(requestOptions);
    var socket = null;
    var openStarted;
    var openTimeout;
    var socketOpeningPromise;
    var status = 'INIT';
    var supportedEvents = [
      'open',
      'close',
      'message'
    ];
    var events = [];
    var getToken = cachePromise(function getToken() {
      return http.get(settings.apiUrl + settings.blackArrow.tokenUrl, null, { withCredentials: true }).then(function (response) {
        status = 'GOT_TOKEN';
        return utils.get(response, 'data.token', '');
      }).catch(function (response) {
        status = 'GET_TOKEN_FAILED';
        newRelic.sendError('can not get black arrow token', {
          code: response.code,
          body: response.responseText
        });
        return toError(response);
      });
    });
    function emitItemUpdateEvent(result) {
      var event = notifier.emit(adapter, eventsList.ITEM.UPDATE, {
        arguments: [
          result.data,
          result.data
        ]
      });
      event.resolve(result);
    }
    function filterEvents(eventName) {
      return function (event) {
        return event.name === eventName;
      };
    }
    function on(eventNames, callback) {
      if (typeof eventNames === 'string') {
        eventNames = [eventNames];
      }
      eventNames.forEach(function (eventName) {
        if (supportedEvents.indexOf(eventName) < 0) {
          throw new Error('This event ' + eventName + ' is not supported by websocket');
        }
        events.push({
          name: eventName,
          fn: callback
        });
      });
    }
    function off(eventNames, callback) {
      if (typeof eventNames === 'string') {
        eventNames = [eventNames];
      }
      events = events.filter(function (event) {
        return !eventNames.some(function (eventName) {
          return event.name === eventName && (!callback || event.fn === callback);
        });
      });
    }
    function emit(eventName, args) {
      var __slice = [].slice;
      args = arguments.length >= 2 ? __slice.call(arguments, 1) : [];
      events.filter(filterEvents(eventName)).forEach(function (event) {
        event.fn.apply({ event: eventName }, args);
      });
    }
    function open() {
      if (!settings.blackArrow.enabled) {
        newRelic.sendError('black arrow disabled');
        return Promise.reject('black arrow disabled');
      }
      if (socket) {
        return Promise.resolve(socket);
      }
      if (openStarted) {
        return socketOpeningPromise;
      }
      openStarted = true;
      status = 'OPEN_STARTED';
      socketOpeningPromise = getToken().then(openSocket).catch(function (reason) {
        console.log(reason);
        newRelic.sendError('can not open black arrow', {
          code: reason.code,
          body: reason.responseText || reason.message
        });
        return toError(reason);
      });
      return socketOpeningPromise;
    }
    function reopenSocket() {
      if (!openStarted) {
        return;
      }
      status = 'REOPEN_STARTED';
      openTimeout = setTimeout(openSocket, REOPEN_TIMEOUT);
    }
    function openSocket(token) {
      socket = new WebSocket(settings.blackArrow.wsUrl + '?token=' + token);
      socket.onmessage = onMessage;
      socket.onerror = function () {
        newRelic.sendError('websockets on error');
        reopenSocket();
      };
      socket.onopen = function () {
        status = 'OPENED';
        emit('open');
      };
      socket.onclose = function (closeEvent) {
        socket = null;
        newRelic.sendError('websockets on close', {
          code: closeEvent.code,
          message: closeEvent.reason
        });
        emit('close');
      };
      return new Promise(function (resolve, reject) {
        var rejectTimeoutId;
        on('open', function () {
          resolve(socket);
          clearTimeout(rejectTimeoutId);
        });
        rejectTimeoutId = setTimeout(function () {
          newRelic.sendError('reject by inner timeout');
          reject({
            code: -666,
            message: 'reject by inner timeout'
          });
        }, OPEN_REJECT_TIMEOUT);
      });
    }
    function close() {
      openStarted = false;
      if (openTimeout) {
        clearTimeout(openTimeout);
        openTimeout = null;
      }
      if (socket) {
        status = 'CLOSED';
        socket.close();
        return new Promise(function (resolve) {
          on('close', function () {
            resolve('closed');
          });
        });
      }
      newRelic.sendError('websockets: no socket to close', { message: reason });
      return Promise.reject('no socket');
    }
    function onMessage(message) {
      try {
        message = JSON.parse(message.data);
      } catch (error) {
        newRelic.sendError('parse web sockets message failed', { message: error });
        return;
      }
      if (message.type === 'status_update' && settings.asyncTranscoding) {
        if (utils.get(message, 'file.op_status') === TRANSCODING_STATUSES.READY) {
          adapter.item.get(utils.get(message, 'file.file_name')).then(emitItemUpdateEvent);
        } else {
          emitItemUpdateEvent({ data: itemMapper(message.file, settings, {}, true) });
        }
      }
      if (message.type === 'trash_file') {
        notifier.emitResolve(adapter, eventsList.ITEMS.REMOVE, { arguments: [[message.file_name]] }, { data: { id: message.file_name } });
      }
      if (message.type === 'item_update') {
        var item = itemMapper(message.file, settings, {}, true);
        var event = notifier.emit(adapter, eventsList.ITEM.UPDATE, {
          arguments: [
            item,
            item
          ]
        });
        event.resolve({ data: item });  //notifier.emitResolve(adapter, eventsList.ITEM.UPDATE,
                                        //  {arguments: [[item, item]]},
                                        //  {data: item}
                                        //);
      }
      emit('message', message);
    }
    function send(message, action, method) {
      return getToken().then(function (token) {
        if (!token) {
          newRelic.sendError('websockets: try to send message without token');
          return Promise.reject('no token');
        }
        if (!message) {
          newRelic.sendError('websockets: try to send message without message');
          return Promise.reject('no message');
        }
        action = action || 'send';
        var data = { action: action };
        if (method === 'post' || !socket) {
          data = utils.extend(data, {
            message: JSON.stringify(message),
            token: token
          });
          var options = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
          return http.post(settings.blackArrow.messageUrl, data, null, options).catch(function (reason) {
            newRelic.sendError('websockets: black arrow test failed', {
              code: reason.code,
              body: reason.responseText
            });
            return toError(reason);
          });
        }
        data = utils.extend(data, { message: message });
        socket.send(JSON.stringify(data));
        return message;
      });
    }
    return {
      open: open,
      close: close,
      send: send,
      on: on,
      off: off,
      getStatus: function () {
        return status;
      },
      getOpenStarted: function () {
        return openStarted;
      }
    };
  };
}(bluebird_extended, utils_http, utils_utils, services_new_relic, events_notifier, events_list, sources_private_parsers_error, constants_transcoding_statuses);
sources_private_refresh_token_wrapper = function (Promise, initHttp, utils) {
  var http = initHttp();
  return function (refreshTokenUrl) {
    var authHeaders = {};
    var refreshedAt = 0;
    function isRecentlyRefreshed() {
      return new Date().valueOf() - refreshedAt < 10000;
    }
    // wrap request with refresh auth token
    return function (method) {
      // add auth token to request
      var methodWithAuthHeaders = function () {
        var originalHeaders = (arguments[2] || {}).headers || {};
        return method.call(this, arguments[0], arguments[1] || {}, utils.merge(arguments[2] || {}, { headers: utils.merge(authHeaders, originalHeaders) }));
      };
      // refresh token on auth error and retry call
      return http.catchError(methodWithAuthHeaders, function (reason, callMethod) {
        if (reason.code === 403 && !isRecentlyRefreshed()) {
          return http.post(refreshTokenUrl).then(function (response) {
            authHeaders = response.data.set_headers || {};
            refreshedAt = new Date().valueOf();
            return callMethod();
          });
        }
        return Promise.reject(reason);
      });
    };
  };
}(bluebird_extended, utils_http, utils_utils);
services_polling = function (Promise, utils, notifier, eventsList, itemMapper, TRANSCODING_STATUSES) {
  var POLLING_TIMEOUT = 60 * 1000;
  return function (settings, adapter, itemMapper, http) {
    return function (itemId) {
      function emitItemUpdateEvent(result) {
        var event = notifier.emit(adapter, eventsList.ITEM.UPDATE, {
          arguments: [
            result.data,
            result.data
          ]
        });
        event.resolve(result);
      }
      return new Promise(function (resolve, reject) {
        function checkItemStatus() {
          setTimeout(function () {
            http.get(settings.apiUrl + '/files/' + itemId, null, { cache: false }).then(function (response) {
              var status = response.data.op_status;
              if (status === TRANSCODING_STATUSES.READY) {
                var responseItemId = response.data.file_name;
                adapter.item.get(responseItemId).then(emitItemUpdateEvent);
                resolve(responseItemId);
                return;
              }
              var result = itemMapper(response.data, settings, {}, true);
              emitItemUpdateEvent({ data: result });
              if (status === TRANSCODING_STATUSES.FAILED) {
                reject('Item transcoding failed');
                return;
              }
              checkItemStatus();
            }).catch(checkItemStatus);
          }, POLLING_TIMEOUT);
        }
        checkItemStatus();
      });
    };
  };
}(bluebird_extended, utils_utils, events_notifier, events_list, sources_private_mappers_item, constants_transcoding_statuses);
services_crc32 = function () {
  /*eslint-disable*/
  /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
  /* vim: set ts=2: */
  /*exported CRC32 */
  var CRC32 = {};
  CRC32.version = '1.0.1';
  /* see perf/crc32table.js */
  /*global Int32Array */
  function signed_crc_table() {
    var c = 0, table = new Array(256);
    for (var n = 0; n != 256; ++n) {
      c = n;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      table[n] = c;
    }
    return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
  }
  var T = signed_crc_table();
  function crc32_bstr(bstr, seed) {
    var C = seed ^ -1, L = bstr.length - 1;
    for (var i = 0; i < L;) {
      C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i++)) & 255];
      C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i++)) & 255];
    }
    if (i === L)
      C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i)) & 255];
    return C;
  }
  function crc32_buf(buf, seed) {
    if (buf.length > 10000)
      return crc32_buf_8(buf, seed);
    var C = seed ^ -1, L = buf.length - 3;
    for (var i = 0; i < L;) {
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
    }
    while (i < L + 3)
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
    return C;
  }
  function crc32_buf_8(buf, seed) {
    var C = seed ^ -1, L = buf.length - 7;
    for (var i = 0; i < L;) {
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
    }
    while (i < L + 7)
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
    return C;
  }
  function crc32_str(str, seed) {
    var C = seed ^ -1;
    for (var i = 0, L = str.length, c, d; i < L;) {
      c = str.charCodeAt(i++);
      if (c < 128) {
        C = C >>> 8 ^ T[(C ^ c) & 255];
      } else if (c < 2048) {
        C = C >>> 8 ^ T[(C ^ (192 | c >> 6 & 31)) & 255];
        C = C >>> 8 ^ T[(C ^ (128 | c & 63)) & 255];
      } else if (c >= 55296 && c < 57344) {
        c = (c & 1023) + 64;
        d = str.charCodeAt(i++) & 1023;
        C = C >>> 8 ^ T[(C ^ (240 | c >> 8 & 7)) & 255];
        C = C >>> 8 ^ T[(C ^ (128 | c >> 2 & 63)) & 255];
        C = C >>> 8 ^ T[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 255];
        C = C >>> 8 ^ T[(C ^ (128 | d & 63)) & 255];
      } else {
        C = C >>> 8 ^ T[(C ^ (224 | c >> 12 & 15)) & 255];
        C = C >>> 8 ^ T[(C ^ (128 | c >> 6 & 63)) & 255];
        C = C >>> 8 ^ T[(C ^ (128 | c & 63)) & 255];
      }
    }
    return C;
  }
  CRC32.table = T;
  CRC32.bstr = crc32_bstr;
  CRC32.buf = crc32_buf;
  CRC32.str = crc32_str;
  return CRC32;
}();
services_upload_file_to_upload = function (Promise) {
  function promisify(value) {
    if (value.then) {
      return value;
    }
    return Promise.resolve(value);
  }
  function canAbort(fileToUpload) {
    return fileToUpload.status === 'waiting' || fileToUpload.status === 'uploading' && Promise.prototype.cancellable;
  }
  function abortEarly(fileToUpload) {
    fileToUpload.deferred.promise.catch(function (reason) {
      fileToUpload.status = 'failed';
      fileToUpload.error = reason;
    });
    fileToUpload.deferred.promise.abort();
  }
  function initUpload(fileToUpload, data) {
    fileToUpload.status = 'uploading';
    fileToUpload.uploadPromise = promisify(data.uploadFn(fileToUpload.source)).progress(function (progress) {
      fileToUpload.deferred.promise.notify(progress);
    }).then(function (res) {
      fileToUpload.deferred.resolve(res);
    }).catch(function (reason) {
      fileToUpload.status = 'failed';
      fileToUpload.error = reason;
      fileToUpload.deferred.reject(reason);
    });
    fileToUpload.uploadPromise.notify({
      status: fileToUpload.status,
      total: fileToUpload.getFileSize(),
      loaded: 0
    });
  }
  function createDeferred() {
    return Promise.defer();
  }
  function map(data) {
    return {
      source: data.source,
      status: 'waiting',
      bytesLoaded: 0,
      currentChunkBytesLoaded: 0,
      deferred: createDeferred(),
      isAborted: false,
      error: {},
      upload: function () {
        if (!this.isAborted) {
          initUpload(this, data);
        }
        return this.deferred.promise;
      },
      abort: function () {
        if (!canAbort(this)) {
          return;
        }
        this.isAborted = true;
        if (this.status === 'waiting') {
          abortEarly(this);
          return;
        }
        this.uploadPromise.abort();
      },
      canRetry: function () {
        if (this.error instanceof Promise.CancellationError) {
          return true;
        }
        var codesToRetry = [
          -201,
          401,
          403,
          408
        ];
        return this.status === 'failed' && codesToRetry.indexOf(this.error.code) !== -1;
      },
      signUpForRetry: function () {
        this.status = 'waiting';
        this.isAborted = false;
        this.error = {};
        this.deferred = createDeferred();
      },
      canAbort: function () {
        return canAbort(this);
      },
      getFileSize: function () {
        return this.source.file ? this.source.file.size : 1;
      }
    };
  }
  return map;
}(bluebird_extended);
services_upload_upload_collection = function (Promise, utils, fileToUploadMapper) {
  var maxParallelUploads = 1;
  var uploadQueue = [];
  var uploadIsInProgress = false;
  var currentUploadedTotal = 0;
  var deferred;
  var supportedEvents = [
    'queueChanged',
    'fileStatusChanged',
    'uploadQueueStarted',
    'uploadQueueFinished'
  ];
  var events = [];
  function filterEvents(eventName) {
    return function (event) {
      return event.name === eventName;
    };
  }
  function on(eventNames, callback) {
    if (typeof eventNames === 'string') {
      eventNames = [eventNames];
    }
    eventNames.forEach(function (eventName) {
      if (supportedEvents.indexOf(eventName) === -1) {
        throw new Error('This event ' + eventName + ' is not supported by multiple file uploader');
      }
      events.push({
        name: eventName,
        fn: callback
      });
    });
  }
  function off(eventNames, callback) {
    if (typeof eventNames === 'string') {
      eventNames = [eventNames];
    }
    for (var i = events.length - 1; i >= 0; i -= 1) {
      var event = events[i];
      eventNames.forEach(function (eventName) {
        if (event.name === eventName && (!callback || event.fn === callback)) {
          events.splice(i, 1);
        }
      });
    }
  }
  function emit(eventName, args) {
    var __slice = [].slice;
    args = arguments.length >= 2 ? __slice.call(arguments, 1) : [];
    events.filter(filterEvents(eventName)).forEach(function (event) {
      event.fn.apply({ event: eventName }, args);
    });
  }
  function hasWaitingFiles() {
    return uploadQueue.some(function (fileToUpload) {
      return fileToUpload.status === 'waiting';
    });
  }
  function getWaitingFiles() {
    return uploadQueue.filter(function (fileToUpload) {
      return fileToUpload.status === 'waiting';
    });
  }
  function hasRetryableFiles() {
    return uploadQueue.some(function (fileToUpload) {
      return fileToUpload.canRetry();
    });
  }
  function getInProgressFilesCount() {
    return uploadQueue.filter(function (fileToUpload) {
      return [
        'uploading',
        'processing'
      ].indexOf(fileToUpload.status) >= 0;
    }).length;
  }
  function hasInProgressFiles() {
    return uploadQueue.some(function (fileToUpload) {
      return [
        'uploading',
        'processing'
      ].indexOf(fileToUpload.status) >= 0;
    });
  }
  function dynamicPromiseReduce() {
    if (!hasWaitingFiles() && !hasInProgressFiles()) {
      deferred.resolve();
    }
    var availableSlots = maxParallelUploads - getInProgressFilesCount();
    if (availableSlots <= 0) {
      return deferred.promise;
    }
    var filesToStartUpload = getWaitingFiles().slice(0, availableSlots);
    filesToStartUpload.forEach(function (fileToUpload) {
      fileToUpload.upload().then(function (res) {
        dynamicPromiseReduce();
        return res;
      }).catch(function (err) {
        dynamicPromiseReduce();
        console.warn(err);
      });
    });
    return deferred.promise;
  }
  function getBytesTotal() {
    return uploadQueue.reduce(function (sum, fileToUpload) {
      return sum + fileToUpload.getFileSize();
    }, 0);
  }
  function calculateItemBytesLoaded(fileToUpload, progress) {
    switch (progress.status) {
    case 'uploading':
      if (progress.loaded <= fileToUpload.getFileSize()) {
        return progress.loaded;
      }
      return fileToUpload.getFileSize();
    case 'succeeded':
    case 'processing':
      return fileToUpload.getFileSize();
    case 'failed':
      return 0;
    default:
      return 0;
    }
  }
  function processItemProgress(fileToUpload) {
    return function (progress) {
      if ([
          'failed',
          'succeeded'
        ].indexOf(fileToUpload.status) === -1) {
        fileToUpload.status = progress.status;
      } else {
        progress.status = fileToUpload.status;
      }
      var fileSize = fileToUpload.getFileSize();
      fileToUpload.bytesLoaded = progress.loaded >= fileSize ? fileSize : progress.loaded;
      progress.file = fileToUpload;
      emit('fileStatusChanged', {
        bytesTotalUploaded: currentUploadedTotal + calculateItemBytesLoaded(fileToUpload, progress),
        bytesTotal: getBytesTotal(),
        currentFileProgress: progress,
        currentFileQueueIdx: uploadQueue.indexOf(fileToUpload),
        queue: uploadQueue
      });
    };
  }
  function startUploadQueue() {
    if (uploadIsInProgress) {
      dynamicPromiseReduce();
      return;
    }
    deferred = Promise.defer();
    uploadIsInProgress = true;
    emit('uploadQueueStarted', uploadQueue);
    dynamicPromiseReduce().then(function () {
      uploadIsInProgress = false;
      emit('uploadQueueFinished', uploadQueue);
    }).catch(function (err) {
      console.warn(err);
    });
  }
  function addProgressNotifications(fileToUpload) {
    var processCurrentItemProgress = processItemProgress(fileToUpload);
    var fileSize = fileToUpload.getFileSize();
    fileToUpload.deferred.promise.progress(processCurrentItemProgress).then(function (result) {
      fileToUpload.serverResponse = result;
      processCurrentItemProgress({
        status: 'succeeded',
        total: fileSize,
        loaded: fileSize
      });
      currentUploadedTotal += fileSize;
    }).catch(function (reason) {
      fileToUpload.serverResponse = reason;
      processCurrentItemProgress({
        status: 'failed',
        total: fileSize,
        loaded: 0
      });
    });
  }
  function addRestartOnRetry(fileToUpload) {
    var nativeRetry = fileToUpload.signUpForRetry;
    fileToUpload.signUpForRetry = function () {
      nativeRetry.apply(this, arguments);
      addProgressNotifications(fileToUpload);
      startUploadQueue();
    };
  }
  function clearQueue() {
    if (uploadIsInProgress) {
      throw new Error('Upload queue can not be cleared while upload is running');
    }
    uploadQueue.length = 0;
    currentUploadedTotal = 0;
  }
  function upload(fileSources) {
    fileSources = fileSources || [];
    if (!uploadIsInProgress && !hasRetryableFiles()) {
      clearQueue();
    }
    var mappedFiles = fileSources.map(fileToUploadMapper).map(function (fileToUpload) {
      addProgressNotifications(fileToUpload);
      addRestartOnRetry(fileToUpload);
      uploadQueue.push(fileToUpload);
      return fileToUpload;
    });
    emit('queueChanged', uploadQueue);
    startUploadQueue();
    return mappedFiles;
  }
  return {
    on: on,
    off: off,
    upload: upload,
    clearQueue: clearQueue,
    set maxParallelUploads(number) {
      maxParallelUploads = Number(number) || 1;
    },
    get maxParallelUploads() {
      return maxParallelUploads;
    },
    get uploadQueue() {
      return uploadQueue;
    },
    get uploadIsInProgress() {
      return uploadIsInProgress;
    },
    get currentUploadedTotal() {
      return currentUploadedTotal;
    }
  };
}(bluebird_extended, utils_utils, services_upload_file_to_upload);
services_bi_send_request = function (utils) {
  function getBaseHost() {
    //return '//frog.wixpress.com';
    return /\.wixpress\.com/i.test(document.location.host) || /local\./i.test(document.location.host) ? '//frog.wixpress.com' : '//frog.wix.com';
  }
  return function (url, data) {
    var biImage = document.createElement('img');
    biImage.setAttribute('src', getBaseHost() + url + '?' + utils.encodeParams(data) + '&_=' + new Date().getTime());
    biImage = null;
  };
}(utils_utils);
services_bi_event_ids = {
  severity: {
    info: 10,
    warning: 20,
    error: 30,
    fatal: 40
  },
  BIEventsIds: {
    responseTime: '110',
    uploadSpeed: '142',
    uploadQueueStarted: '303',
    uploadQueueFinished: '304',
    resumableUploadStarted: '155',
    resumableUploadFinished: '156',
    resumableChunkUploadStarted: '157',
    resumableChunkUploadFinished: '158'
  },
  BIAdaptersIds: {
    private: '01',
    public: '02',
    facebook: '03',
    flickr: '04',
    instagram: '05',
    picasa: '06',
    flickrSearch: '07',
    googleSearch: '08',
    bigStock: '09',
    collection: '10',
    drive: '11',
    dropbox: '12',
    facebookVideo: '13',
    instagramVideo: '14',
    vimeo: '15',
    vimeoSearch: '16',
    youtube: '17',
    youtubeSearch: '18'
  },
  BIAdaptersRequestsIds: {
    'folders.list': '01',
    'folders.remove': '02',
    'folders.trash.list': '03',
    'folders.trash.restore': '04',
    'folders.trash.remove': '05',
    'folder.create': '06',
    'folder.update': '07',
    'items.list': '11',
    'items.remove': '12',
    'items.search': '13',
    'items.searchByTag': '14',
    'items.trash.list': '15',
    'items.trash.restore': '16',
    'items.trash.remove': '17',
    'item.get': '18',
    'item.update': '19',
    'item.upload': '20',
    'item.uploadByUrl': '21',
    'trash.remove': '22',
    'trash.restore': '23'
  }
};
services_resumable = function (Promise, utils, crc32, Uploader, sendBi, BIEventIds, toError) {
  var HASH_SIZE = 1024 * 1024;
  function getCurrentTime() {
    return new Date().getTime();
  }
  function getBlobArrayBuffer(blob) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.readAsArrayBuffer(blob);
      reader.onload = function (event) {
        var arrayBuffer = new Int32Array(event.target.result);
        resolve(arrayBuffer);
      };
      reader.onerror = function (reason) {
        reject(reason);
      };
    });
  }
  function getHash(blob) {
    var startedAt = getCurrentTime();
    return getBlobArrayBuffer(blob.slice(0, HASH_SIZE)).then(function (arrayBuffer) {
      console.log('time to get hash', getCurrentTime() - startedAt);
      return crc32.buf(arrayBuffer).toString(16);
    }, toError);
  }
  function getSliceFunction(file) {
    var funcToSlice;
    if (file.slice) {
      funcToSlice = 'slice';
    } else if (file.mozSlice) {
      funcToSlice = 'mozSlice';
    } else if (file.webkitSlice) {
      funcToSlice = 'webkitSlice';
    } else {
      funcToSlice = 'slice';
    }
    return funcToSlice;
  }
  function getBytesToUpload(chunksToUpload) {
    return chunksToUpload.reduce(function (prevValue, nextValue) {
      return prevValue + utils.get(nextValue, 'data.resumableCurrentChunkSize', 0);
    }, 0);
  }
  function getFileId(file, chunksLength) {
    var startHash = getHash(file.file.slice(0, HASH_SIZE));
    var endHash = getHash(file.file.slice(-HASH_SIZE));
    return Promise.all([
      startHash,
      endHash
    ]).then(function (response) {
      return response[0] + '_' + response[1] + '_' + chunksLength;
    }, toError);
  }
  function getChunkSize(size) {
    // 100MB
    if (size < 104857600) {
      return 10485760;  // 10MB
    }
    // 500MB
    if (size < 524288000) {
      return 26214400;  // 25MB
    }
    // 2GB
    if (size < 2147483648) {
      return 52428800;  // 50MB
    }
    // 5GB
    if (size < 5368709120) {
      return 104857600;  // 100MB
    }
    return Math.ceil(size / 100);
  }
  function getChunksFromFile(fileSource) {
    var file = fileSource.file;
    var funcToSlice = getSliceFunction(file);
    var chunks = [];
    var startBytes = 0;
    var chunkSize = getChunkSize(file.size);
    console.log('chunkSize', chunkSize);
    while (startBytes < file.size) {
      chunks.push(file[funcToSlice](startBytes, startBytes + chunkSize));
      startBytes += chunkSize;
    }
    return chunks;
  }
  function getNotReadyChunks(chunksStatuses) {
    return chunksStatuses.filter(function (chunk) {
      return chunk.status !== 'READY';
    });
  }
  return function (settings, adapter, itemMapper, http) {
    /*
        function checkChunkUploadStatus(fileId, chunkNumber, options) {
          var data = {
            resumableIdentifier: fileId,
            resumableChunkNumber: chunkNumber
          };
    
          return http
            .get(settings.apiUrl + '/resumable/chunk/status', data, options)
            .then(function (response) {
              console.log('response', response);
              return response;
            }, function (error) {
              console.log('error', error);
              return toError(error);
            });
        }
        */
    function checkAllChunks(fileId, chunks) {
      var url = settings.apiUrl + '/resumable/chunk/status';
      var data = {
        resumableIdentifier: fileId,
        resumableTotalChunks: chunks.length
      };
      var options = {
        withCredentials: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      };
      return http.post(url, data, null, options).then(function (response) {
        return response.data.resumableChunks;
      }, toError);
    }
    function uploadChunks(chunksToUpload, allChunksLength, file, fileId, resumableUploadPromise, options) {
      var bytesTotalUploaded = 0;
      var currentChunkBytesLoaded = 0;
      if (allChunksLength !== chunksToUpload.length) {
        bytesTotalUploaded = file.file.size - getBytesToUpload(chunksToUpload);
      }
      var fileToUpload = utils.find(Uploader.uploadQueue, function (el) {
        return el.source.file === file.file;
      });
      console.log('start chunks upload');
      var uploadedChunkResponses = [];
      return new Promise(function (resolve, reject) {
        function uploadChunk(chunkId) {
          var chunk = chunksToUpload[chunkId];
          if (!chunk) {
            resolve(uploadedChunkResponses);
            return;
          }
          sendBi('/mg', {
            src: 26,
            evid: BIEventIds.BIEventsIds.resumableChunkUploadStarted,
            chunk_size: utils.get(chunk, 'data.chunk.size', -1),
            file_id: fileId,
            file_size: file.file.size,
            total_chunks: allChunksLength
          });
          var chunkUploadStartedAt = getCurrentTime();
          var uploadChunkPromise = http.upload(chunk.uploadUrl, chunk.data, options).progress(function (progress) {
            var chunkBytesLoaded = progress.loaded >= progress.total ? progress.total : progress.loaded;
            bytesTotalUploaded += chunkBytesLoaded - currentChunkBytesLoaded;
            currentChunkBytesLoaded = chunkBytesLoaded;
            var progressStatus = 'uploading';
            if (bytesTotalUploaded >= file.file.size) {
              progressStatus = 'processing';
            }
            resumableUploadPromise.notify({
              loaded: bytesTotalUploaded,
              status: progressStatus,
              total: file.file.size
            });
          }).then(function (response) {
            var chunkUploadTime = (getCurrentTime() - chunkUploadStartedAt) / 1000;
            sendBi('/mg', {
              src: 26,
              evid: BIEventIds.BIEventsIds.resumableChunkUploadFinished,
              chunk_size: utils.get(chunk, 'data.chunk.size', -1),
              file_id: fileId,
              file_size: file.file.size,
              total_chunks: allChunksLength,
              upload_speed: Math.floor(file.file.size / chunkUploadTime),
              upload_time: Math.floor(chunkUploadTime)
            });
            currentChunkBytesLoaded = 0;
            uploadedChunkResponses.push(response.data);
            console.log('chunk', chunkId, 'was uploaded');
            uploadChunk(chunkId + 1);
          }, function (reason) {
            // TODO: add support to get new uploading url
            console.warn('upload file error', reason);
            if (reason instanceof Promise.CancellationError) {
              return Promise.reject(reason);
            }
            resumableUploadPromise.notify({
              loaded: bytesTotalUploaded,
              status: 'failed',
              total: file.file.size
            });
            return Promise.reject(reason);  /*
                                                            if (utils.get(reason, 'data.message') === 'link expired') {
                                                              console.log('chunk', chunkId, 'upload link was expired');
                                            
                                                              var uploadApiUrl = settings.apiUrl + '/resumable/chunk/url';
                                                              var data = {
                                                                count: 1
                                                              };
                                            
                                                              http
                                                                .post(uploadApiUrl, data, null, options)
                                                                .then(
                                                                  function (response) {
                                                                    var uploadUrl = _.get(response, 'data.upload_urls[0]');
                                            
                                                                    http
                                                                      .upload(uploadUrl, chunk.data, options)
                                                                      .then(
                                                                        function (response) {
                                                                          uploadedChunkResponses.push(response.data);
                                            
                                                                          console.log('chunk', chunkId, 'was uploaded with new link');
                                                                          uploadChunk(chunkId + 1);
                                                                        }
                                                                      );
                                                                  }
                                                                );
                                                            }
                                                            */
          }).catch(function (reason) {
            console.warn('error file upload!!!', reason);
            reject(reason);
          });
          fileToUpload.uploadPromise.abort = function () {
            uploadChunkPromise.abort();
          };
          return uploadChunkPromise;
        }
        uploadChunk(0);
      });
    }
    function finalizeItem(fileId, fileSource) {
      var params = {
        resumableIdentifier: fileId,
        content_type: fileSource.file.type,
        file_name: fileSource.file.name,
        media_type: fileSource.media_type,
        parent_folder_id: fileSource.parent_folder_id
      };
      return http.get(settings.apiUrl + '/resumable/finalize', params);
    }
    return function (fileSource, options) {
      console.log('resumable upload started');
      options = options || {};
      var fileUploadStartedAt = getCurrentTime();
      var fileId;
      var chunks = getChunksFromFile(fileSource);
      console.log('chunks', chunks.length);
      console.log('chunks', chunks);
      var resumableUploadPromise;
      resumableUploadPromise = new Promise(function (resolve, reject) {
        getFileId(fileSource, chunks.length).then(function (responseFileId) {
          fileId = responseFileId;
          console.log('fileId', fileId);
        }).then(function () {
          return checkAllChunks(fileId, chunks).then(getNotReadyChunks, toError);
        }).then(function (notReadyChunks) {
          console.log('notReadyChunks', notReadyChunks);
          sendBi('/mg', {
            src: 26,
            evid: BIEventIds.BIEventsIds.resumableUploadStarted,
            file_id: fileId,
            file_size: fileSource.file.size,
            uploaded_chunks: chunks.length - notReadyChunks.length,
            total_chunks: chunks.length,
            chunks_status_time: Math.floor((getCurrentTime() - fileUploadStartedAt) / 1000)
          });
          var defaultData = {
            resumableIdentifier: fileId,
            resumableTotalChunks: chunks.length,
            parent_folder_id: fileSource.folderId || null,
            media_type: fileSource.media_type
          };
          var chunksToUpload = notReadyChunks.map(function (chunk) {
            var chunkData = utils.merge(defaultData, {
              chunk: chunks[chunk.chunkNumber],
              resumableChunkNumber: chunk.chunkNumber,
              resumableCurrentChunkSize: chunks[chunk.chunkNumber].size
            });
            return {
              uploadUrl: chunk.uploadUrl,
              data: chunkData
            };
          });
          return uploadChunks(chunksToUpload, chunks.length, fileSource, fileId, resumableUploadPromise, options);
        }).then(function (uploadedChunkResponses) {
          console.log('all chunks were uploaded');
          console.log('all uploaded chunks responses', uploadedChunkResponses);
          var chunksUploadedInCurrentSession = uploadedChunkResponses.length;
          return finalizeItem(fileId, fileSource).then(function (response) {
            console.log('chunksUploadedInCurrentSession', chunksUploadedInCurrentSession);
            console.log('finalizeItem response', response);
            var fileSize = fileSource.file.size;
            var uploadTime = (getCurrentTime() - fileUploadStartedAt) / 1000;
            sendBi('/mg', {
              src: 26,
              evid: BIEventIds.BIEventsIds.resumableUploadFinished,
              file_id: fileId,
              file_size: fileSource.file.size,
              uploaded_chunks: chunksUploadedInCurrentSession,
              total_chunks: chunks.length,
              upload_speed: Math.floor(fileSize / uploadTime),
              upload_time: Math.floor(uploadTime)
            });
            return resolve(response);
          }, function (reason) {
            console.warn('finalize error', reason);
            return Promise.reject(reason);
          });
        }).catch(function (reason) {
          console.warn('resumable', reason);
          reject(reason);
        });
      });
      return resumableUploadPromise;
    };
  };
}(bluebird_extended, utils_utils, services_crc32, services_upload_upload_collection, services_bi_send_request, services_bi_event_ids, sources_private_parsers_error);
sources_private_Private = function (initFolders, initFolder, initItems, initItem, initTrash, initItemsTrash, initItemsSiteMedia, initFoldersTrash, itemMapper, defaultSettings, utils, decorators, eventsList, initChannel, initBlackArrow, initRefreshTokenWrapper, initHttp, initPolling, initResumable) {
  return function (userSettings) {
    var settings = utils.extendDeep({}, defaultSettings, userSettings);
    var withRefreshToken = initRefreshTokenWrapper(settings.refreshTokenUrl);
    var requestOptions = settings.requestOptions;
    if (utils.get(requestOptions, 'params.ns')) {
      settings.ns = requestOptions.params.ns;
    }
    var http = initHttp(requestOptions);
    var blackArrow = initBlackArrow(settings, this, itemMapper);
    var polling = initPolling(settings, this, itemMapper, http);
    var resumable = initResumable(settings, this, itemMapper, http);
    var settingsWithRefreshToken = {
      get: withRefreshToken(http.get),
      post: withRefreshToken(http.post),
      upload: withRefreshToken(http.upload)
    };
    var httpWithRefreshToken = settings.refreshTokenUrl ? settingsWithRefreshToken : http;
    var folders = initFolders(settings, httpWithRefreshToken);
    var folder = initFolder(settings, httpWithRefreshToken);
    var items = initItems(settings, httpWithRefreshToken);
    var item = initItem(settings, httpWithRefreshToken, blackArrow, polling, resumable);
    var trash = initTrash(settings, httpWithRefreshToken);
    var itemsTrash = initItemsTrash(settings, httpWithRefreshToken);
    var itemsSiteMedia = initItemsSiteMedia(settings, httpWithRefreshToken);
    var foldersTrash = initFoldersTrash(settings, httpWithRefreshToken);
    var channel = initChannel(settings, this, itemMapper, http);
    folders.trash = foldersTrash;
    items.trash = itemsTrash;
    items.siteMedia = itemsSiteMedia;
    this.name = 'private';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.folder = decorators.addEvents(this, eventsList.FOLDER, folder);
    this.item = decorators.addEvents(this, eventsList.ITEM, item);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
    this.trash = decorators.addEvents(this, eventsList.TRASH, trash);
    this.blackArrow = blackArrow;
    this.channel = channel;
  };
}(sources_private_folders, sources_private_folder, sources_private_items, sources_private_item, sources_private_trash, sources_private_itemstrash, sources_private_itemssite_media, sources_private_folderstrash, sources_private_mappers_item, sources_private_settings, utils_utils, sources_decorators, events_list, services_channel_channel, services_channel_black_arrow, sources_private_refresh_token_wrapper, utils_http, services_polling, services_resumable);
sources_platform_mappers_folder = function (folderData) {
  /**
   * Folder
   * {String} id
   * {String} parentId
   * {String} name
   * {String} mediaType
   * {Number} filesCount
   * {Number} createdAt
   */
  return {
    id: folderData.id,
    parentId: folderData.parent || null,
    name: folderData.title,
    mediaType: folderData.media_type,
    //filesCount: folderData.files_count,
    createdAt: Date.parse(folderData.created_at)
  };
};
sources_platform_parsers_error = function (Promise) {
  return function (response) {
    if (response.status === 403 && response.data && response.data.error_description === 'Missing Wix session') {
      response.status = 401;
      response.data.message = 'Wix Session required';
    }
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_platform_folders = function (toFolder, toError) {
  return function (settings, http) {
    function mapFolderList(res) {
      res.data = (res.data.objects || []).map(toFolder);
      return res;
    }
    /**
     * @summary Return the list of folders
     * @memberof source.folders
     * @param {String} folderId
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List[]} List with Folders
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      return http.get(settings.apiUrl + '/objects/folders/', {
        media_type: options.mediaType || 'picture',
        folder_id: folderId || null
      }, { headers: options.headers || {} }).then(mapFolderList).catch(toError);
    }
    function removeFolder(folderId, options) {
      var url = settings.apiUrl + '/objects/folders/' + folderId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: folderId };
        return res;
      }).catch(toError);
    }
    /**
     * @summary Removes the list of folders with given ids
     * @memberof source.folders
     * @param {string[]} folderIds Array of folder ids
     * @param {Object} options
     * @returns {Promise[]}
     */
    function remove(folderIds, options) {
      options = options || {};
      return folderIds.map(function (folderId) {
        return removeFolder(folderId, options);
      });
    }
    return {
      list: list,
      remove: remove
    };
  };
}(sources_platform_mappers_folder, sources_platform_parsers_error);
sources_platform_validators_new_props = function (newProps) {
  if (typeof newProps !== 'object' || newProps === null) {
    return {
      valid: false,
      message: 'Please specify new props'
    };
  }
  if (typeof newProps.name !== 'undefined' && !newProps.name) {
    return {
      valid: false,
      message: 'Please specify name'
    };
  }
  if (typeof newProps.folderId !== 'undefined' && !newProps.folderId) {
    return {
      valid: false,
      message: 'Please specify folder id'
    };
  }
  if (typeof newProps.parentId !== 'undefined' && !newProps.parentId) {
    return {
      valid: false,
      message: 'Please specify parent folder id'
    };
  }
  if (typeof newProps.tags !== 'undefined' && !Array.isArray(newProps.tags)) {
    return {
      valid: false,
      message: 'Tags should be an array'
    };
  }
  return { valid: true };
};
sources_platform_folder = function (mappers, utils, toFolder, toError, validateNewProps) {
  return function (settings, http) {
    function mapFolder(res) {
      res.data = toFolder(res.data.object);
      return res;
    }
    /**
     * @summary Create a new folder with given name and parameters
     * @memberof source.folder
     * @param {string} folderName
     * @param {object} options
     * @param {string} options.mediaType
     * @param {string} options.parentId
     * @returns {Promise}
     * @fulfill {Folder} New folder object
     * @reject {Error}
     */
    function create(folderName, options) {
      if (!folderName) {
        return toError(mappers.toError({
          status: -200,
          statusText: 'Internal JS Error',
          data: { message: 'Please specify name' }
        }));
      }
      options = options || {};
      var url = settings.apiUrl + '/objects/folders/';
      var data = {
        title: folderName,
        media_type: options.mediaType || 'picture',
        parent: options.parentId || null
      };
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(mapFolder).catch(toError);
    }
    /**
     * @summary Updates the folder with given diff object
     * @memberof source.folder
     * @param {Folder} folder Current folder object that should be updated
     * @param {object} newFolderProps
     * @param {object} options
     * @returns {Promise}
     * @fulfill {Folder} Modified folder object
     * @reject {Error}
     */
    function update(folder, newFolderProps, options) {
      var arePropsValid = validateNewProps(newFolderProps);
      if (arePropsValid.valid === false) {
        return toError(mappers.toError({
          status: -200,
          statusText: 'Internal JS Error',
          data: { message: arePropsValid.message }
        }));
      }
      var data = {};
      if (newFolderProps.name) {
        data.folder_name = newFolderProps.name;
      }
      if (newFolderProps.parentId) {
        data.parent_folder_id = newFolderProps.parentId;
      }
      options = options || {};
      var url = settings.apiUrl + '/objects/folders/' + folder.id + '/';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(function (res) {
        res.data = utils.extend({}, folder, newFolderProps);
        return res;
      }).catch(toError);
    }
    return {
      create: create,
      update: update
    };
  };
}(utils_mappers, utils_utils, sources_platform_mappers_folder, sources_platform_parsers_error, sources_platform_validators_new_props);
sources_platform_mappers_item = function (TRANSCODING_STATUSES, mappers, utils, getWixThumbnailsUrls) {
  return function (itemData, settings, thumbnailSizes) {
    var normalizeUri = utils.normalizeUri;
    var item = {
      id: itemData.id,
      folderId: itemData.folder || null,
      fileSize: itemData.file_size,
      name: itemData.title,
      mediaType: itemData.media_type,
      fileUrl: utils.get(itemData, 'meta.fileDescriptor.path'),
      fileRefId: utils.get(itemData, 'meta.fileDescriptor.id'),
      createdAt: Date.parse(itemData.created_at),
      //readOnly: itemData.read_only || null,
      labels: utils.get(itemData, 'meta.features.labels', []).map(function (label) {
        return label.name;
      }),
      //tags: utils.splitTags(itemData.tags),
      width: utils.get(itemData, 'meta.basic.width'),
      height: utils.get(itemData, 'meta.basic.height'),
      //fileInfo: itemData.file_info ? mappers.toObject(itemData.file_info) : null,
      //fileInput: itemData.file_input ? mappers.toObject(itemData.file_input) : null,
      //fileOutput: itemData.file_output ? mappers.toObject(itemData.file_output) : null,
      meta: itemData.meta || null,
      transcodingStatus: getTranscodingStatusFromTranscodingJobs(utils.get(itemData, 'meta.videoTranscodingJobs', []))
    };
    function getTranscodingStatusFromTranscodingJobs(transcodingJobs) {
      if (!transcodingJobs.length) {
        return TRANSCODING_STATUSES.IN_QUEUE;
      }
      var firstVideoTranscodingJobStatus = transcodingJobs[0].status;
      if (transcodingJobs.length === 1) {
        return firstVideoTranscodingJobStatus;
      }
      var isAllTranscodingStatusesTheSame = transcodingJobs.some(function (job) {
        return job.status === firstVideoTranscodingJobStatus;
      });
      if (isAllTranscodingStatusesTheSame) {
        return firstVideoTranscodingJobStatus;
      }
      return TRANSCODING_STATUSES.INPROGRESS;
    }
    function getVideoPreviewUrls(item) {
      var videoTranscodingJobs = utils.get(item, 'meta.videoTranscodingJobs');
      if (videoTranscodingJobs && videoTranscodingJobs[0]) {
        var videoOutputs = utils.get(videoTranscodingJobs[0], 'info.outputs.videoOutputs');
        if (videoOutputs && videoOutputs[0] && videoOutputs[0].url) {
          return [settings.filesUrl + videoOutputs[0].url];
        }
      }
      return null;
    }
    if (item.mediaType === 'video') {
      item.thumbnailUrl = normalizeUri(item.fileUrl + '.output/posters/' + item.fileRefId + '002.jpg');
    }
    var sizes = utils.extend({}, settings.thumbnailSizes, thumbnailSizes);
    utils.extend(item, getWixThumbnailsUrls(item, sizes, settings));
    //if (sizes.thumbnail && !item.thumbnailUrl && itemData.icon_url) {
    //  item.thumbnailUrl = normalizeUri(settings.filesUrl + '/' + itemData.icon_url);
    //}
    Object.keys(sizes).forEach(function (thumbType) {
      if (!item[thumbType + 'Url']) {
        item[thumbType + 'Url'] = item.thumbnailUrl;
      }
    });
    Object.keys(item).forEach(function (prop) {
      if (item[prop] === undefined) {
        delete item[prop];
      }
    });
    item.videoPreviewUrls = getVideoPreviewUrls(item);
    return item;
  };
}(constants_transcoding_statuses, utils_mappers, utils_utils, services_thumbnail_generator_get_wix_thumbnails_urls);
sources_platform_items = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.objects || []).map(function (data) {
        return toItem(data, settings, thumbnailSizes);
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    /**
     * @summary Returns the list of items from the given folder
     * @memberof source.items
     * @param {string} folderId
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        folder: folderId,
        media_type: options.mediaType || 'picture'
      };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      return http.get(settings.apiUrl + '/objects/items/', queryParams, { headers: options.headers || {} }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    function removeItem(itemId, options) {
      var queryParams = {};
      if (settings.ns) {
        queryParams.ns = settings.ns;
      }
      var url = settings.apiUrl + '/objects/items/' + itemId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, queryParams, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    /**
     * @summary Removes the items with given ids
     * @memberof source.items
     * @param {Array} itemIds
     * @returns {Array}
     */
    function remove(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return removeItem(itemId, options);
      });
    }
    /**
     * @summary Return list of items found by tag
     * @memberof source.items
     * @param {string} tag
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function searchByTag(tag, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        media_type: options.mediaType || 'picture',
        order: sort.direction === 'desc' ? '-' + sort.order : sort.order
      };
      return http.get(settings.apiUrl + '/files/get?tag=' + tag, queryParams, {
        cache: false,
        headers: options.headers || {}
      }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    /**
     * @summary Return list of items found by text query
     * @memberof source.items
     * @param {string} folderId
     * @param {string} query
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function search(folderId, query, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      query = encodeURIComponent(query);
      var queryParams = {
        query: query,
        page_size: paging.size,
        cursor: paging.cursor,
        media_type: options.mediaType || 'picture',
        folder: folderId,
        order: sort.direction === 'desc' ? '-' + sort.order : sort.order
      };
      return http.get(settings.apiUrl + '/search/items', queryParams, {
        cache: false,
        headers: options.headers || {}
      }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    return {
      list: list,
      remove: remove,
      searchByTag: searchByTag,
      search: search
    };
  };
}(bluebird_extended, utils_utils, sources_platform_mappers_item, sources_platform_parsers_error);
sources_platform_item = function (Promise, utils, toItem, toError, validateNewProps, mappers, TRANSCODING_STATUSES) {
  var POLLING_TIMEOUT = 15 * 1000;
  var TIMEOUT_BEFORE_REJECT = 10 * 60 * 1000;
  var MIN_FONT_SIZE = 4096;
  return function (settings, http, socket, pollItem) {
    var isPromiseResolved;
    var rejectTimeoutId;
    var funcToUnsubscribe;
    function getFilesSizeLimit(mediaType) {
      return settings.uploadLimits[utils.snakeToCamel(mediaType)];
    }
    function fileSizeIsInvalid(fileSource) {
      return fileSource.file.size >= getFilesSizeLimit(fileSource.mediaType);
    }
    function mapItem(res, thumbnailsSizes) {
      res.data = toItem(res.data, settings, thumbnailsSizes);
      return res;
    }
    function cleanUp() {
      isPromiseResolved = true;
      clearTimeout(rejectTimeoutId);
      socket.off('message', funcToUnsubscribe);
    }
    function resolveItemIdFromSocketMessage(itemIdFromResponse, resolve) {
      return function (message) {
        var itemId = utils.get(message, 'file.file_name');
        if (message.type === 'status_update' && utils.get(message, 'file.op_status') === TRANSCODING_STATUSES.READY && itemId === itemIdFromResponse) {
          resolve(itemId);
        }
      };
    }
    function checkItemStatus(itemId, resolve) {
      setTimeout(function () {
        if (isPromiseResolved) {
          return;
        }
        get(itemId).then(function (response) {
          if (utils.get(response, 'data.transcodingStatus') !== TRANSCODING_STATUSES.READY) {
            return Promise.reject();
          }
          resolve(itemId);
        }).catch(function () {
          checkItemStatus(itemId, resolve);
        });
      }, POLLING_TIMEOUT);
    }
    function resolveItemIdFromResponse(itemId) {
      return new Promise(function (resolve, reject) {
        if (!itemId) {
          reject();
          return;
        }
        checkItemStatus(itemId, resolve);
      });
    }
    function waitForItemFromStorage(response) {
      isPromiseResolved = false;
      var itemId = utils.get(response, 'data.payload.file_name') || utils.get(response, 'data.file_name');
      var resolveItemIdFromSocket = new Promise(function (resolve) {
        funcToUnsubscribe = resolveItemIdFromSocketMessage(itemId, resolve);
        socket.on('message', funcToUnsubscribe);
      });
      var rejectNotReadyItem = new Promise(function (resolve, reject) {
        rejectTimeoutId = setTimeout(function () {
          reject({
            status: 406,
            data: { message: 'Not ready item' }
          });
        }, TIMEOUT_BEFORE_REJECT);
      });
      return Promise.race([
        resolveItemIdFromSocket,
        resolveItemIdFromResponse(itemId),
        rejectNotReadyItem
      ]).then(function (itemId) {
        cleanUp();
        return Promise.resolve(itemId);
      }).catch(function (error) {
        cleanUp();
        return Promise.reject(error);
      });
    }
    function getUploadUrl(fileSource) {
      //function getEndpoint(mediaType) {
      //  if (mediaType === 'secure_music') {
      //    return 'music-goods/upload';
      //  } else if (mediaType === 'video') {
      //    return 'video/upload';
      //  }
      //  return 'upload';
      //}
      var file = fileSource.file;
      //var url = settings.apiUrl + '/files/' + getEndpoint(fileSource.mediaType) + '/url';
      var url = settings.apiUrl + '/upload/url';
      var data = {
        media_type: fileSource.mediaType,
        // we just need an extension here
        file_name: file.name.toLowerCase(),
        // file_name: '_.' + file.name.split('.').pop().toLowerCase(),
        file_size: file.size,
        content_type: file.type
      };
      var postOptions = {
        withCredentials: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      };
      return http.post(url, data, null, postOptions);
    }
    function uploadByUrl(fileSource, options, skipWaitingItemFromStorage) {
      options = options || {};
      var data = {
        url: utils.normalizeUri(fileSource.url),
        media_type: fileSource.mediaType,
        name: fileSource.name || 'Untitled',
        tags: fileSource.tags ? fileSource.tags.join(',') : null,
        folder: fileSource.folderId || null
      };
      // some sources as Google Drive requires auth headers to allow downloading files via url
      if (fileSource.headers) {
        data.headers = JSON.stringify(fileSource.headers);
      }
      if (fileSource.catalogCallbackUrl) {
        data.cat_callback_url = fileSource.catalogCallbackUrl;
      }
      if (settings.siteMediaToken) {
        data.siteMediaToken = settings.siteMediaToken;
      }
      var apiUrl = settings.apiUrl + '/files/upload/external';
      if (settings.asyncUploadByUrl || skipWaitingItemFromStorage) {
        socket.open();
        var apiUrlAsync = apiUrl + '/async';
        var headers = utils.extend({}, options.headers, { 'Content-Type': 'application/x-www-form-urlencoded' });
        var postOptions = { headers: headers };
        return http.post(apiUrlAsync, data, null, postOptions).then(function (response) {
          if (skipWaitingItemFromStorage) {
            pollItem(response.data.payload.file_name);
            response.data = toItem(response.data.payload, settings);
            return response;
          }
          return waitForItemFromStorage(response).then(get);
        }).catch(toError);
      }
      var uploadPromise = http.get(apiUrl, data, { headers: options.headers || {} }).progress(function (progress) {
        uploadPromise.notify(progress);
      }).then(function (res) {
        return mapItem(res, options.thumbnails);
      });
      return uploadPromise;
    }
    function upload(fileSource, options) {
      options = options || {};
      var mediaType = fileSource.mediaType;
      var data = {
        file: fileSource.file,
        media_type: mediaType
      };
      if (fileSource.catalogCallbackUrl) {
        data.cat_callback_url = fileSource.catalogCallbackUrl;
      }
      if (fileSource.encodingOptions) {
        data.encoding_options = JSON.stringify(fileSource.encodingOptions);
      }
      if (settings.vision) {
        data.vision = settings.vision.join(',');
      }
      if (settings.siteMediaToken) {
        data.siteMediaToken = settings.siteMediaToken;
      }
      if (fileSizeIsInvalid(fileSource)) {
        var limit = utils.bytesToSize(getFilesSizeLimit(fileSource.mediaType));
        var fileSize = utils.bytesToSize(fileSource.file.size);
        return Promise.reject(mappers.toError({
          status: -406,
          statusText: 'Not Acceptable',
          data: {
            error_code: -7752,
            error_description: 'File size ' + fileSize + ' exceeds upload limit of ' + limit,
            error_info: {
              key: 'wmp_error.file_size_exceeded_limit',
              args: [
                fileSize,
                limit
              ]
            }
          }
        }));
      }
      var title = utils.get(fileSource, 'file.name', '');
      var folderId = fileSource.folderId || null;
      var isAsyncFontUploadAllowed = settings.asyncFontUpload;
      var isUploadFont = data.media_type === 'ufont';
      var isBigFile = utils.get(data, 'file.size') > MIN_FONT_SIZE;
      var isAsyncFontUpload = isAsyncFontUploadAllowed && isUploadFont && isBigFile;
      var uploadPromiseChain = getUploadUrl(fileSource).then(function (response) {
        var responseData = response.data;
        data.directory = responseData.path;
        data.uploadToken = responseData.payload.uploadToken;
        if (isAsyncFontUpload) {
          socket.open();
          data.upload_async = true;
        }
        return http.upload(responseData.payload.uploadUrl, data, { headers: options.headers || {} }).progress(function (progress) {
          uploadPromiseChain.notify(progress);
        });
      }).then(function (response) {
        var refId = utils.get(response, 'data.payload') && response.data.payload[0] && response.data.payload[0].id;
        if (!refId) {
          return Promise.reject('No ref id');
        }
        return http.post(settings.apiUrl + '/objects/items/', {
          title: title,
          folder: folderId,
          media_type: mediaType,
          ref_id: refId
        });
      }).then(function (response) {
        response.data = response.data.object;
        // if (isAsyncFontUpload) {
        //   return waitForItemFromStorage(response)
        //     .then(get);
        // }
        // var status = utils.get(response, 'data.op_status');
        // if (settings.asyncTranscoding && status && status !== TRANSCODING_STATUSES.READY) {
        //   socket.open();
        //   pollItem(response.data.file_name);
        // }
        response.data = toItem(response.data, settings);
        return response;
      }).catch(toError);
      return uploadPromiseChain;
    }
    /**
     * @summary Returns item
     * @memberof source.item
     * @param {String} itemId
     * @param {Object} [options]
     * @returns {Promise}
     * @fulfill {Item}
     * @reject {Error}
     */
    function get(itemId, options) {
      options = options || {};
      return http.get(settings.apiUrl + '/files/' + itemId, null, {
        cache: false,
        headers: options.headers || {}
      }).then(function (res) {
        return mapItem(res, options.thumbnails);
      }).catch(toError);
    }
    /**
     * @summary Updates the item with given diff object
     * @memberof source.item
     * @param {Item} item Current item object that should be updated
     * @param {object} newItemProps
     * @param {Object} options
     * @returns {Promise}
     * @fulfill {Item} Modified item object
     * @reject {Error}
     */
    function update(item, newItemProps, options) {
      var arePropsValid = validateNewProps(newItemProps);
      if (arePropsValid.valid === false) {
        return toError(mappers.toError({
          status: -200,
          statusText: 'Internal JS Error',
          data: { message: arePropsValid.message }
        }));
      }
      var data = {};
      if (newItemProps.name) {
        data.title = newItemProps.name;
      }
      if (newItemProps.folderId) {
        data.folder = newItemProps.folderId;
      }
      if (newItemProps.tags) {
        data.tags = newItemProps.tags.join(',');
      }
      options = options || {};
      var url = settings.apiUrl + '/objects/items/' + item.id + '/';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(function (res) {
        res.data = utils.extend({}, item, newItemProps);
        return res;
      }).catch(toError);
    }
    return {
      upload: upload,
      uploadByUrl: uploadByUrl,
      get: get,
      update: update
    };
  };
}(bluebird_extended, utils_utils, sources_platform_mappers_item, sources_platform_parsers_error, sources_platform_validators_new_props, utils_mappers, constants_transcoding_statuses);
sources_platform_trash = function (toError) {
  return function (settings, http) {
    /**
     * @summary Remove all items in trash
     * @memberof source.trash
     * @param options
     * @returns {Promise}
     * @reject {Error}
     */
    function remove(options) {
      var url = settings.apiUrl + '/trash/delete';
      var data = {
        media_type: options.mediaType || 'picture',
        all_files: true
      };
      return http.post(url, data).catch(toError);
    }
    /**
     * @summary Restore all items in trash
     * @memberof source.trash
     * @param options
     * @returns {Promise}
     * @reject {Error}
     */
    function restore(options) {
      var url = settings.apiUrl + '/trash/restore';
      var data = {
        media_type: options.mediaType || 'picture',
        all_files: true
      };
      return http.post(url, data).catch(toError);
    }
    return {
      remove: remove,
      restore: restore
    };
  };
}(sources_platform_parsers_error);
sources_platform_itemstrash = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.trash_files || []).map(function (_item) {
        var item = toItem(_item, settings, thumbnailSizes);
        item.isInTrash = true;
        return item;
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        parent_folder_id: folderId,
        media_type: options.mediaType || 'picture'
      };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      return http.get(settings.apiUrl + '/files/getpage/trash', queryParams, { headers: options.headers || {} }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    function removeItem(itemId, options) {
      var url = settings.apiUrl + '/trash/files/' + itemId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    function remove(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return removeItem(itemId, options);
      });
    }
    function restoreItem(itemId, options) {
      var url = settings.apiUrl + '/trash/files/' + itemId + '/restore';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    /**
     * Restore items from trash
     * @param itemIds
     * @param options
     * @returns [Promise] Array of Promise
     */
    function restore(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return restoreItem(itemId, options);
      });
    }
    return {
      list: list,
      remove: remove,
      restore: restore
    };
  };
}(bluebird_extended, utils_utils, sources_platform_mappers_item, sources_platform_parsers_error);
sources_platform_itemssite_media = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.files || []).map(function (_item) {
        var item = toItem(_item, settings, thumbnailSizes);
        item.isInSiteMedia = true;
        return item;
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        parent_folder_id: folderId,
        media_type: options.mediaType || 'picture',
        siteMediaToken: settings.siteMediaToken
      };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      return http.get(settings.apiUrl + '/files/getpage/site', queryParams, { headers: options.headers || {} }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    function removeItem(itemId, options) {
      var data = { files: [itemId] };
      var url = settings.apiUrl + '/files/site/remove?siteMediaToken=' + settings.siteMediaToken;
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    /**
     * Remove items from siteMedia
     * @param itemIds Array of item ids
     * @param options
     * @returns [Promise] Array of Promise
     */
    function remove(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return removeItem(itemId, options);
      });
    }
    /**
     * Add items to siteMedia
     * @param itemIds Array of item ids
     * @param options
     * @returns Promise
     */
    function add(itemIds, options) {
      options = options || {};
      var data = { files: itemIds };
      var url = settings.apiUrl + '/files/site/add?siteMediaToken=' + settings.siteMediaToken;
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).catch(toError);
    }
    return {
      list: list,
      remove: remove,
      add: add
    };
  };
}(bluebird_extended, utils_utils, sources_platform_mappers_item, sources_platform_parsers_error);
sources_platform_folderstrash = function (Promise, utils, toFolder, toError) {
  return function (settings, http) {
    function mapFolderList(res) {
      res.data = (res.data.trash_folders || []).map(function (_folder) {
        var folder = toFolder(_folder);
        folder.isInTrash = true;
        return folder;
      });
      return res;
    }
    function list(folderId, options) {
      options = options || {};
      var queryParams = {
        media_type: options.mediaType || 'picture',
        folder_id: folderId || null,
        trash_type: 'folder'
      };
      return http.get(settings.apiUrl + '/files/getpage/trash', queryParams, { headers: options.headers || {} }).then(mapFolderList).catch(toError);
    }
    function removeFolder(folderId, options) {
      var url = settings.apiUrl + '/trash/folders/' + folderId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: folderId };
        return res;
      }).catch(toError);
    }
    function remove(folderIds, options) {
      options = options || {};
      return folderIds.map(function (folderId) {
        return removeFolder(folderId, options);
      });
    }
    function restoreFolder(folderId, options) {
      var url = settings.apiUrl + '/trash/folders/' + folderId + '/restore';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: folderId };
        return res;
      }).catch(toError);
    }
    function restore(folderIds, options) {
      options = options || {};
      return folderIds.map(function (folderId) {
        return restoreFolder(folderId, options);
      });
    }
    return {
      list: list,
      remove: remove,
      restore: restore
    };
  };
}(bluebird_extended, utils_utils, sources_platform_mappers_folder, sources_platform_parsers_error);
sources_platform_settings = {
  apiUrl: '//files.wix.com',
  imageOperationsApi: 'vangogh',
  filesUrl: '//static.wixstatic.com',
  videoFilesUrl: '//video.wixstatic.com',
  refreshTokenUrl: null,
  requestOptions: { withCredentials: true },
  uploadLimits: {
    default: 15728640,
    document: 15728640,
    picture: 15728640,
    music: 52428800,
    secureMusic: 377487360,
    video: 524288000,
    secureVideo: 1610612736
  },
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    },
    original: {
      width: 1000,
      height: 1000,
      mode: 'fit'
    }
  },
  channel: {
    withCredentials: true,
    jsapiUrl: '/_ah/channel/jsapi',
    tokenUrl: '/users/channel'
  },
  blackArrow: {
    enabled: false,
    wsUrl: 'wss://ws.wixmp.com/ws',
    messageUrl: 'https://ws.wixmp.com/message',
    tokenUrl: '/get-batoken'
  },
  asyncFontUpload: false,
  asyncUploadByUrl: false,
  asyncTranscoding: false,
  videoPreviewQuality: '480p'
};
sources_platform_Platform = function (initFolders, initFolder, initItems, initItem, initTrash, initItemsTrash, initItemsSiteMedia, initFoldersTrash, itemMapper, defaultSettings, utils, decorators, eventsList, initBlackArrow, initHttp, initPolling) {
  return function (userSettings) {
    var settings = utils.extendDeep({}, defaultSettings, userSettings);
    var requestOptions = settings.requestOptions;
    var http = initHttp(requestOptions);
    var blackArrow = initBlackArrow(settings, this, itemMapper, requestOptions);
    var polling = initPolling(settings, this, itemMapper, http);
    var folders = initFolders(settings, http);
    var folder = initFolder(settings, http);
    var items = initItems(settings, http);
    var item = initItem(settings, http, blackArrow, polling);
    var trash = initTrash(settings, http);
    var itemsTrash = initItemsTrash(settings, http);
    var itemsSiteMedia = initItemsSiteMedia(settings, http);
    var foldersTrash = initFoldersTrash(settings, http);
    folders.trash = foldersTrash;
    items.trash = itemsTrash;
    items.siteMedia = itemsSiteMedia;
    this.name = 'platform';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.folder = decorators.addEvents(this, eventsList.FOLDER, folder);
    this.item = decorators.addEvents(this, eventsList.ITEM, item);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
    this.trash = decorators.addEvents(this, eventsList.TRASH, trash);
    this.blackArrow = blackArrow;
  };
}(sources_platform_folders, sources_platform_folder, sources_platform_items, sources_platform_item, sources_platform_trash, sources_platform_itemstrash, sources_platform_itemssite_media, sources_platform_folderstrash, sources_platform_mappers_item, sources_platform_settings, utils_utils, sources_decorators, events_list, services_channel_black_arrow, utils_http, services_polling);
sources_picasa_settings = {
  apiUrl: '//pix.wix.com/services/google',
  foldersLimit: 500,
  itemsLimit: 50
};
sources_picasa_mappers_folder = function (data) {
  return {
    id: data.gphoto$id.$t,
    name: data.title.$t,
    mediaType: 'picture',
    thumbnailUrl: data.media$group.media$thumbnail[0].url,
    parentId: null,
    filesCount: data.gphoto$numphotos.$t,
    createdAt: data.published.$t
  };
};
sources_picasa_parsers_folders = function (toFolder) {
  return function (res) {
    res.data = (res.data.feed.entry || []).map(toFolder);
    return res;
  };
}(sources_picasa_mappers_folder);
sources_picasa_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_picasa_folders = function (mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        thumbsize: '150c',
        'max-results': options.paging.size || settings.foldersLimit,
        'start-index': options.paging.cursor || 1
      };
      return http.get(settings.apiUrl + '/albums', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapFolderList).catch(toError);
    }
    return { list: list };
  };
}(sources_picasa_parsers_folders, sources_picasa_parsers_error);
sources_picasa_mappers_item = function (utils) {
  function getLastImage(mediaGroup) {
    var images = mediaGroup.media$thumbnail.filter(function (item) {
      return !item.medium || item.medium !== 'video';
    });
    return images[images.length - 1].url || '';
  }
  return function (data) {
    var lastImage, width, height, bigImage, preview;
    lastImage = getLastImage(data.media$group);
    width = Number(data.gphoto$width.$t || 1024);
    height = Number(data.gphoto$height.$t || 768);
    // hack. API does not provide really full images
    // w1024-h768-no is used by google at slideshows
    bigImage = lastImage.replace(/\/s[0-9]+/, '/w' + width + '-h' + height + '-no');
    // sizes: 128, 200, 220, 288, 320, 400, 512, 576, 640, 720, 800, 912, 1024, 1152, 1280, 1440, 1600
    if (width > 400) {
      preview = lastImage.replace(/\/s[0-9]+(-c)?/, '/s400');
    } else {
      preview = bigImage;
    }
    return {
      id: data.id.$t,
      name: data.summary.$t || data.title.$t,
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(bigImage),
      thumbnailUrl: utils.normalizeUri(lastImage),
      previewUrl: utils.normalizeUri(preview),
      createdAt: data.published.$t,
      tags: [],
      width: width,
      height: height
    };
  };
}(utils_utils);
sources_picasa_parsers_items = function (toItem) {
  return function (res) {
    var paging = {
      cursor: res.data.feed.openSearch$startIndex.$t + res.data.feed.openSearch$itemsPerPage.$t,
      size: res.data.feed.openSearch$itemsPerPage.$t
    };
    res.data = (res.data.feed.entry || []).map(toItem);
    res.paging = paging;
    return res;
  };
}(sources_picasa_mappers_item);
sources_picasa_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        album_id: folderId || null,
        kind: 'photo',
        thumbsize: '150c',
        'max-results': options.paging.size || settings.itemsLimit,
        'start-index': options.paging.cursor || 1
      };
      return http.get(settings.apiUrl + '/photos', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapItemList).catch(toError);
    }
    return { list: list };
  };
}(sources_picasa_parsers_items, sources_picasa_parsers_error);
sources_picasa_Picasa = function (settings, initFolders, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'picasa';
    // rename picasa google photos
    this.translationKey = 'google-photos';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_picasa_settings, sources_picasa_folders, sources_picasa_items, utils_http, sources_decorators, events_list);
sources_drive_settings = {
  apiUrl: '//pix.wix.com/services/gdrive',
  foldersLimit: 500,
  itemsLimit: 50
};
sources_drive_mappers_folder = function (data) {
  return {
    id: data.id,
    name: data.title,
    mediaType: 'picture',
    //thumbnailUrl: data.iconLink,
    parentId: data.parents[0].id,
    filesCount: 1,
    //data.gphoto$numphotos.$t,
    createdAt: data.createdDate
  };
};
sources_drive_parsers_folders = function (toFolder) {
  return function (res) {
    res.data = (res.data.items || []).map(toFolder);
    return res;
  };
}(sources_drive_mappers_folder);
sources_drive_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_drive_folders = function (mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        'max-results': options.paging.size || settings.foldersLimit,
        'start-index': options.paging.cursor || 1
      };
      if (folderId) {
        requestOptions.album_id = folderId;
      }
      return http.get(settings.apiUrl + '/albums', requestOptions, { withCredentials: true }).then(mapFolderList).catch(toError);
    }
    return { list: list };
  };
}(sources_drive_parsers_folders, sources_drive_parsers_error);
sources_drive_mappers_item = function (utils) {
  return function (data) {
    return {
      id: data.id,
      name: data.title,
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(data.fixedDownloadUrl || data.webContentLink),
      thumbnailUrl: data.thumbnailLink ? utils.normalizeUri(data.thumbnailLink) : null,
      previewUrl: data.thumbnailLink ? utils.normalizeUri(data.thumbnailLink) : null,
      createdAt: data.createdDate,
      tags: [],
      width: data.imageMediaMetadata.width,
      height: data.imageMediaMetadata.height
    };
  };
}(utils_utils);
sources_drive_parsers_items = function (toItem) {
  return function (res) {
    res.data = (res.data.items || []).map(toItem);
    res.paging = {};
    return res;
  };
}(sources_drive_mappers_item);
sources_drive_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        album_id: folderId || null,
        'max-results': options.paging.size || settings.itemsLimit,
        'start-index': options.paging.cursor || 1
      };
      return http.get(settings.apiUrl + '/photos', requestOptions, { withCredentials: true }).then(mapItemList, toError);
    }
    return { list: list };
  };
}(sources_drive_parsers_items, sources_drive_parsers_error);
sources_drive_Drive = function (settings, initFolders, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'drive';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_drive_settings, sources_drive_folders, sources_drive_items, utils_http, sources_decorators, events_list);
sources_dropbox_settings = {
  apiUrl: '//pix.wix.com/services/dropbox2',
  foldersLimit: 500,
  itemsLimit: 50
};
sources_dropbox_mappers_folder = function (data) {
  return {
    id: data.path_lower,
    name: data.name,
    mediaType: 'picture',
    parentId: null,
    filesCount: 1,
    createdAt: null
  };
};
sources_dropbox_parsers_folders = function (toFolder) {
  function isFolder(e) {
    return e['.tag'] == 'folder';
  }
  return function (res) {
    res.data = (res.data.entries || []).filter(isFolder).map(toFolder);
    return res;
  };
}(sources_dropbox_mappers_folder);
sources_dropbox_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_dropbox_folders = function (mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {};
      if (folderId) {
        requestOptions.album_id = folderId;
      }
      return http.get(settings.apiUrl + '/albums', requestOptions, { withCredentials: true }).then(mapFolderList).catch(toError);
    }
    return { list: list };
  };
}(sources_dropbox_parsers_folders, sources_dropbox_parsers_error);
sources_dropbox_mappers_item = function (data) {
  function encodePath(uriComponent) {
    return encodeURIComponent(uriComponent).replace('\'', '%27');
  }
  return {
    id: data.path_lower,
    name: data.name,
    mediaType: 'picture',
    fileUrl: data.url,
    thumbnailUrl: '//pix.wix.com/services/dropbox2/thumbnail?path=' + encodePath(data.path_lower),
    previewUrl: '//pix.wix.com/services/dropbox2/thumbnail?path=' + encodePath(data.path_lower) + '&size=w640h480',
    createdAt: data.client_modified,
    tags: []
  };
};
sources_dropbox_parsers_items = function (utils, toItem) {
  function isImage(item) {
    var name = item.name.toLowerCase();
    return item['.tag'] === 'file' && (utils.endsWith(name, '.jpg') || utils.endsWith(name, '.jpeg') || utils.endsWith(name, '.png') || utils.endsWith(name, '.gif'));
  }
  return function (res) {
    var paging = { cursor: res.data.has_more ? res.data.cursor : null };
    res.data = utils.get(res, 'data.entries', []).filter(isImage).map(toItem);
    res.paging = paging;
    return res;
  };
}(utils_utils, sources_dropbox_mappers_item);
sources_dropbox_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        album_id: folderId || null,
        cursor: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/photos', requestOptions, { withCredentials: true }).then(mapItemList, toError);
    }
    return { list: list };
  };
}(sources_dropbox_parsers_items, sources_dropbox_parsers_error);
sources_dropbox_Dropbox = function (settings, initFolders, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'dropbox';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_dropbox_settings, sources_dropbox_folders, sources_dropbox_items, utils_http, sources_decorators, events_list);
sources_instagram_settings = {
  apiUrl: '//pix.wix.com/services/instagram',
  api2Url: '//pix.wix.com/services/instagram2',
  itemsLimit: 50
};
sources_instagram_mappers_folder = function (data) {
  return {
    id: 'Instagram',
    name: 'Instagram',
    mediaType: 'picture',
    parentId: null,
    filesCount: data.counts.media,
    createdAt: null
  };
};
sources_instagram_parsers_folders = function (toFolder) {
  return function (data) {
    return { data: [toFolder(data)] };
  };
}(sources_instagram_mappers_folder);
sources_instagram_parsers_error = function (Promise) {
  return function (response) {
    if (response.code === 500) {
      response.code = 403;
      response.data = {
        message: 'Unauthorized',
        result: 'error'
      };
    }
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_instagram_folders = function (toFolders, toError) {
  return function (settings, http) {
    function successHandler(response) {
      return toFolders(response.data);
    }
    function list(folderId, options) {
      options = options || {};
      return http.get(settings.apiUrl + '/user', null, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(successHandler).catch(toError);
    }
    return { list: list };
  };
}(sources_instagram_parsers_folders, sources_instagram_parsers_error);
sources_instagram_mappers_item = function (utils) {
  return function (data) {
    if (!data.caption) {
      data.caption = { text: '' };
    }
    return {
      id: data.id,
      name: data.caption.text,
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(data.images.standard_resolution.url),
      thumbnailUrl: utils.normalizeUri(data.images.low_resolution.url),
      previewUrl: utils.normalizeUri(data.images.standard_resolution.url),
      createdAt: Number(data.created_time) * 1000,
      tags: utils.splitTags(data.tags),
      width: data.images.standard_resolution.width,
      height: data.images.standard_resolution.height
    };
  };
}(utils_utils);
sources_instagram_parsers_items = function (toItem) {
  return function (res) {
    res.data.next = res.data.next || {};
    var cursor = res.data.next.max_id || null;
    var size = res.data.next.count || null;
    res.data = (res.data.photos || []).map(toItem);
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_instagram_mappers_item);
sources_instagram_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        count: options.paging.size || settings.itemsLimit,
        max_id: options.paging.cursor || null
      };
      return http.get(settings.api2Url + '/photos', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapItemList).catch(toError);
    }
    return { list: list };
  };
}(sources_instagram_parsers_items, sources_instagram_parsers_error);
sources_instagram_Instagram = function (settings, initFolders, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'instagram';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_instagram_settings, sources_instagram_folders, sources_instagram_items, utils_http, sources_decorators, events_list);
sources_instagram_video_settings = {
  apiUrl: '//pix.wix.com/services/instagram2',
  itemsLimit: 50,
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  }
};
sources_instagram_video_mappers_folder = function () {
  return {
    id: 'InstagramVideo',
    name: 'InstagramVideo',
    mediaType: 'video',
    parentId: null,
    filesCount: null,
    createdAt: null
  };
};
sources_instagram_video_parsers_folders = function (toFolder) {
  return function () {
    return { data: [toFolder()] };
  };
}(sources_instagram_video_mappers_folder);
sources_instagram_video_folders = function (toFolders, Promise) {
  return function () {
    function list() {
      return Promise.resolve(toFolders());
    }
    return { list: list };
  };
}(sources_instagram_video_parsers_folders, bluebird_extended);
sources_instagram_video_mappers_item = function (utils) {
  return function (settings, data) {
    var item = {
      id: data.id,
      name: utils.replaceHtml(data.caption ? data.caption.text : data.id),
      fileName: data.id,
      previewUrl: data.images.thumbnail.url,
      thumbnailUrl: data.images.thumbnail.url,
      videoPreviewUrl: [data.videos.standard_resolution.url],
      embedHtml: '<video controls width="' + data.videos.standard_resolution.width + '" height="' + data.videos.standard_resolution.height + '" poster="' + data.images.thumbnail.url + '"><source src="' + data.videos.standard_resolution.url + '" type="video/mp4" /></video>',
      width: Number(data.videos.standard_resolution.width),
      height: Number(data.videos.standard_resolution.height),
      createdAt: Number(data.created_time),
      externalSources: {
        videos: data.videos,
        images: data.images
      },
      folderId: null,
      mediaType: 'video'
    };
    if (!data.format) {
      return item;
    }
    var availableThumbnailsSizes = data.format.map(function (pictureSize) {
      return utils.extend({}, pictureSize, { url: pictureSize.picture });
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend(item, urls);
  };
}(utils_utils);
sources_instagram_video_parsers_items = function (toItem, utils) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data.paging && res.data.paging.cursors && res.data.paging.cursors.after && res.data.paging.next) {
      cursor = res.data.paging.cursors.after;
      size = Number(utils.getParameterByName(res.data.paging.next, 'limit'));
    }
    res.data = (res.data.videos || []).map(utils.partial(toItem, settings));
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_instagram_video_mappers_item, utils_utils);
sources_instagram_video_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_instagram_video_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      var requestOptions = {
        limit: options.paging.size || settings.itemsLimit,
        after: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/videos', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(utils.partial(mapItemList, listSettings)).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_instagram_video_parsers_items, sources_instagram_video_parsers_error);
sources_instagram_video_InstagramVideo = function (defaultSettings, initFolders, initItems, initHttp, decorators, eventsList, utils) {
  return function (settings) {
    settings = utils.extend({}, defaultSettings, settings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'instagramVideo';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_instagram_video_settings, sources_instagram_video_folders, sources_instagram_video_items, utils_http, sources_decorators, events_list, utils_utils);
sources_facebook_settings = {
  apiUrl: '//pix.wix.com/services/facebook2',
  foldersLimit: 50,
  itemsLimit: 50
};
sources_facebook_mappers_folder = function (utils) {
  return function (data, settings) {
    return {
      id: data.id,
      name: data.name,
      mediaType: 'picture',
      parentId: null,
      thumbnailUrl: utils.normalizeUri(settings.apiUrl + '/picture?type=album&album_id=' + data.id),
      filesCount: data.count,
      createdAt: data.created_time
    };
  };
}(utils_utils);
sources_facebook_parsers_folders = function (toFolder) {
  return function (settings, res) {
    res.data = (res.data.data || []).map(function (data) {
      return toFolder(data, settings);
    });
    return res;
  };
}(sources_facebook_mappers_folder);
sources_facebook_parsers_error = function (Promise) {
  return function (response) {
    if (response.code === 400 && response.data && response.data.code === 190) {
      response.code = 403;
    }
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_facebook_folders = function (utils, mapFolderList, toError) {
  return function (settings, http) {
    function list(folderID, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        limit: options.paging.size || settings.foldersLimit,
        after: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/albums', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(utils.partial(mapFolderList, settings)).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_facebook_parsers_folders, sources_facebook_parsers_error);
sources_facebook_mappers_item = function (utils) {
  function findThumbnailUrl(images, minWidth, minHeight) {
    minHeight = minHeight || 190;
    minWidth = minWidth || 190;
    var bigImages, biggestImage, smallestImage;
    if (images.length === 1) {
      return images[0].source;
    }
    bigImages = images.filter(function (image) {
      return image.width > minWidth && image.height > minHeight;
    });
    smallestImage = utils.min(bigImages, function (image) {
      return image.width + image.height;
    });
    if (smallestImage) {
      return smallestImage.source;
    }
    biggestImage = utils.max(images, function (image) {
      return image.width + image.height;
    });
    return biggestImage.source;
  }
  return function (data) {
    return {
      id: data.id,
      folderId: null,
      name: data.name || '',
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(data.source),
      thumbnailUrl: utils.normalizeUri(findThumbnailUrl(data.images)),
      previewUrl: utils.normalizeUri(data.source),
      createdAt: data.created_time,
      tags: [],
      width: data.width,
      height: data.height
    };
  };
}(utils_utils);
sources_facebook_parsers_items = function (toItem) {
  return function (res) {
    var cursor;
    if (res.data.paging && res.data.paging.cursors) {
      cursor = res.data.paging.cursors.after;
    }
    res.data = (res.data.data || []).map(toItem);
    res.paging = {
      cursor: cursor || null,
      size: null
    };
    return res;
  };
}(sources_facebook_mappers_item);
sources_facebook_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        album_id: folderId,
        limit: options.paging.size || settings.itemsLimit,
        after: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/photos', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapItemList).catch(toError);
    }
    return { list: list };
  };
}(sources_facebook_parsers_items, sources_facebook_parsers_error);
sources_facebook_Facebook = function (settings, initFolders, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'facebook';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_facebook_settings, sources_facebook_folders, sources_facebook_items, utils_http, sources_decorators, events_list);
sources_facebook_video_settings = {
  apiUrl: '//pix.wix.com/services/facebook2',
  itemsLimit: 50,
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  }
};
sources_facebook_video_mappers_folder = function () {
  return {
    id: 'FacebookVideo',
    name: 'FacebookVideo',
    mediaType: 'video',
    parentId: null,
    filesCount: null,
    createdAt: null
  };
};
sources_facebook_video_parsers_folders = function (toFolder) {
  return function () {
    return { data: [toFolder()] };
  };
}(sources_facebook_video_mappers_folder);
sources_facebook_video_folders = function (toFolders, Promise) {
  return function () {
    function list() {
      return Promise.resolve(toFolders());
    }
    return { list: list };
  };
}(sources_facebook_video_parsers_folders, bluebird_extended);
sources_facebook_video_mappers_item = function (utils) {
  return function (settings, data) {
    function getAttribute(htmlElement, attributeName) {
      var regex = new RegExp(attributeName + '="(.+?)"', 'i');
      var res = htmlElement.match(regex);
      return res ? res[1] : '';
    }
    function toTimeStamp(date) {
      var correctDate = date.replace(/([+\-]\d\d)(\d\d)$/, '$1:$2');
      return utils.toTimeStamp(correctDate);
    }
    var item = {
      id: Number(data.id),
      name: utils.replaceHtml(data.title),
      iframeSrc: getAttribute(data.embed_html, 'src'),
      embedHtml: data.embed_html,
      width: Number(getAttribute(data.embed_html, 'width')),
      height: Number(getAttribute(data.embed_html, 'height')),
      createdAt: toTimeStamp(data.created_time),
      folderId: null,
      mediaType: 'video'
    };
    if (!data.format) {
      return item;
    }
    var availableThumbnailsSizes = data.format.map(function (pictureSize) {
      return utils.extend({}, pictureSize, { url: pictureSize.picture });
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend(item, urls);
  };
}(utils_utils);
sources_facebook_video_parsers_items = function (toItem, utils) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data.paging && res.data.paging.cursors && res.data.paging.cursors.after && res.data.paging.next) {
      cursor = res.data.paging.cursors.after;
      size = Number(utils.getParameterByName(res.data.paging.next, 'limit'));
    }
    res.data = (res.data.data || []).map(utils.partial(toItem, settings));
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_facebook_video_mappers_item, utils_utils);
sources_facebook_video_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_facebook_video_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        limit: options.paging.size || settings.itemsLimit,
        after: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/videos', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(utils.partial(mapItemList, listSettings)).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_facebook_video_parsers_items, sources_facebook_video_parsers_error);
sources_facebook_video_FacebookVideo = function (defaultSettings, initFolders, initItems, initHttp, decorators, eventsList, utils) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'facebookVideo';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_facebook_video_settings, sources_facebook_video_folders, sources_facebook_video_items, utils_http, sources_decorators, events_list, utils_utils);
sources_flickr_settings = {
  apiUrl: '//pix.wix.com/services/flickr',
  foldersLimit: 50,
  itemsLimit: 50
};
sources_flickr_mappers_folder = function (data) {
  return {
    id: data.id,
    name: data.title._content,
    mediaType: 'picture',
    thumbnailUrl: data.primary_photo_extras.url_m || data.primary_photo_extras.url_s || data.primary_photo_extras.url_t,
    parentId: null,
    filesCount: Number(data.photos) + Number(data.videos),
    createdAt: Number(data.date_create) * 1000
  };
};
sources_flickr_parsers_folders = function (toFolder) {
  return function (res) {
    res.data = (res.data.photosets.photoset || []).map(toFolder);
    return res;
  };
}(sources_flickr_mappers_folder);
sources_flickr_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_flickr_folders = function (mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        primary_photo_extras: 'url_t,url_s,url_m,url_b,url_o',
        per_page: options.paging.size || settings.foldersLimit,
        page: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/albums', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapFolderList).catch(toError);
    }
    return { list: list };
  };
}(sources_flickr_parsers_folders, sources_flickr_parsers_error);
sources_flickr_mappers_item = function (utils) {
  function toThumbnails(photo) {
    var thumbnail = photo.url_m || photo.url_s || photo.url_t;
    var big = photo.url_b || thumbnail;
    var original = photo.url_o || big;
    return {
      fileUrl: original,
      thumbnailUrl: thumbnail,
      previewUrl: big
    };
  }
  return function (data) {
    var thumbnails = toThumbnails(data);
    return {
      id: data.id,
      name: data.title,
      folderId: null,
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(thumbnails.fileUrl),
      thumbnailUrl: utils.normalizeUri(thumbnails.thumbnailUrl),
      previewUrl: utils.normalizeUri(thumbnails.previewUrl),
      createdAt: null,
      tags: [],
      width: Number(data.width_o || data.width_m || data.width_s || data.width_t),
      height: Number(data.height_o || data.height_m || data.height_s || data.height_t)
    };
  };
}(utils_utils);
sources_flickr_parsers_items = function (toItem) {
  return function (res) {
    var cursor = res.data.photoset.page < res.data.photoset.pages ? Number(res.data.photoset.page) + 1 : null;
    var size = Number(res.data.photoset.perpage);
    res.data = (res.data.photoset.photo || []).map(toItem);
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_flickr_mappers_item);
sources_flickr_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        extras: 'url_t,url_s,url_m,url_b,url_o',
        set_id: folderId,
        per_page: options.paging.size || settings.itemsLimit,
        page: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/photoset', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapItemList).catch(toError);
    }
    return { list: list };
  };
}(sources_flickr_parsers_items, sources_flickr_parsers_error);
sources_flickr_Flickr = function (settings, initFolders, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'flickr';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_flickr_settings, sources_flickr_folders, sources_flickr_items, utils_http, sources_decorators, events_list);
sources_flickr_search_settings = {
  apiUrl: '//pix.wix.com/services/flickr',
  itemsLimit: 50
};
sources_flickr_search_mappers_item = function (utils) {
  function toThumbnails(photo) {
    var thumbnail = photo.url_m || photo.url_s || photo.url_t;
    var big = photo.url_b || thumbnail;
    var original = photo.url_o || big;
    return {
      fileUrl: original,
      thumbnailUrl: thumbnail,
      previewUrl: big
    };
  }
  return function (data) {
    var thumbnails = toThumbnails(data);
    return {
      id: data.id,
      name: data.title,
      folderId: null,
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(thumbnails.fileUrl),
      thumbnailUrl: utils.normalizeUri(thumbnails.thumbnailUrl),
      previewUrl: utils.normalizeUri(thumbnails.previewUrl),
      createdAt: null,
      tags: [],
      width: Number(data.width_o || data.width_m || data.width_s || data.width_t),
      height: Number(data.height_o || data.height_m || data.height_s || data.height_t)
    };
  };
}(utils_utils);
sources_flickr_search_parsers_items = function (toItem) {
  return function (res) {
    var cursor = res.data.photos.page < res.data.photos.pages ? res.data.photos.page + 1 : null;
    var size = Number(res.data.photos.perpage);
    res.data = (res.data.photos.photo || []).map(toItem);
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_flickr_search_mappers_item);
sources_flickr_search_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_flickr_search_items = function (mapItemList, toError) {
  return function (settings, http) {
    function search(folderId, query, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        extras: 'url_t,url_s,url_m,url_b,url_o',
        text: query,
        per_page: options.paging.size || settings.itemsLimit,
        page: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(mapItemList).catch(toError);
    }
    return { search: search };
  };
}(sources_flickr_search_parsers_items, sources_flickr_search_parsers_error);
sources_flickr_search_FlickrSearch = function (settings, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var items = initItems(settings, http);
    this.name = 'flickrSearch';
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_flickr_search_settings, sources_flickr_search_items, utils_http, sources_decorators, events_list);
sources_google_search_settings = {
  apiUrl: '//pix.wix.com/services/gcs',
  itemsLimit: 50
};
sources_google_search_mappers_item = function (utils) {
  return function (data) {
    return {
      id: data.link,
      name: utils.replaceHtml(data.title),
      folderId: null,
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(data.link),
      thumbnailUrl: utils.normalizeUri(data.image.thumbnailLink || data.link),
      previewUrl: utils.normalizeUri(data.link),
      createdAt: null,
      tags: [],
      width: Number(data.image.width),
      height: Number(data.image.height)
    };
  };
}(utils_utils);
sources_google_search_parsers_items = function (toItem) {
  return function (res) {
    var cursor = null;
    var size = null;
    if (res.data.queries && res.data.queries.nextPage && res.data.queries.nextPage[0]) {
      cursor = res.data.queries.nextPage[0].startIndex;
      size = res.data.queries.nextPage[0].count;
    }
    res.data = (res.data.items || []).map(toItem);
    res.paging = {
      cursor: cursor >= 92 ? null : cursor,
      size: size
    };
    return res;
  };
}(sources_google_search_mappers_item);
sources_google_search_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_google_search_items = function (mapItemList, toError) {
  return function (settings, http) {
    function search(folderId, query, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        q: query,
        count: options.paging.size || settings.itemsLimit,
        start: options.paging.cursor || null
      };
      if (options.excludeQuery) {
        requestOptions.filter = options.excludeQuery;
      }
      return http.get(settings.apiUrl + '/images', requestOptions, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(mapItemList).catch(toError);
    }
    return { search: search };
  };
}(sources_google_search_parsers_items, sources_google_search_parsers_error);
sources_google_search_GoogleSearch = function (settings, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var items = initItems(settings, http);
    this.name = 'googleSearch';
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_google_search_settings, sources_google_search_items, utils_http, sources_decorators, events_list);
sources_collection_settings = {
  apiUrl: '//collections.wixstatic.com/collections',
  filesUrl: '//static.wixstatic.com',
  collectionId: '68c4b99f-d5b7-4583-b1d1-e00e31605678',
  imageOperationsApi: 'vangogh',
  itemsLimit: 50
};
sources_collection_mappers_folder = function (utils, mapPrivateFolder) {
  return function (data, settings) {
    var privateFolderData = utils.extend({
      folder_id: data.id,
      folder_name: data.title,
      media_type: data.type,
      created_ts: data.date_created
    }, data.public_properties);
    var folder = mapPrivateFolder(privateFolderData);
    if (data.public_properties.thumbnail_url && !folder.thumbnailUrl) {
      folder.thumbnailUrl = utils.normalizeUri(settings.filesUrl + '/' + data.public_properties.thumbnail_url);
    }
    return folder;
  };
}(utils_utils, sources_private_mappers_folder);
sources_collection_parsers_selector = function (entities, parentId, isFolder) {
  return entities.filter(function (entity) {
    return isFolder ? !entity.public_properties.file_url && (parentId ? entity.public_properties.parent_id === parentId : !entity.public_properties.parent_id) : entity.public_properties.file_url && (parentId ? entity.public_properties.folder_id === parentId : !entity.public_properties.folder_id);
  });
};
sources_collection_parsers_folders = function (toFolder, select) {
  return function (res, folderId, currentPaging, settings) {
    var foldersData = select(res.data.collection.items, folderId, true);
    var paging = {
      cursor: currentPaging.cursor + currentPaging.size,
      size: foldersData.length - currentPaging.cursor
    };
    res.data = foldersData.map(function (data) {
      var folder = toFolder(data, settings);
      folder.filesCount = folder.filesCount || select(res.data.collection.items, folder.id, false).length;
      return folder;
    });
    if (paging.size > 0) {
      res.paging = paging;
    }
    return res;
  };
}(sources_collection_mappers_folder, sources_collection_parsers_selector);
sources_collection_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_collection_folders = function (mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      options.paging.cursor = options.paging.cursor || 0;
      options.paging.size = options.paging.size || settings.itemsLimit;
      return http.get(settings.apiUrl + '/' + settings.collectionId + '.json', {}, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(function (res) {
        return mapFolderList(res, folderId, options.paging, settings);
      }).catch(toError);
    }
    return { list: list };
  };
}(sources_collection_parsers_folders, sources_collection_parsers_error);
sources_collection_mappers_item = function (mappers, utils, mapPrivateItem) {
  return function (data, settings, thumbnailSizes) {
    var privateItemData = utils.extend({
      file_name: data.id,
      original_file_name: data.title,
      media_type: data.type,
      created_ts: data.date_created
    }, data.public_properties);
    return mapPrivateItem(privateItemData, settings, thumbnailSizes);
  };
}(utils_mappers, utils_utils, sources_private_mappers_item);
sources_collection_parsers_items = function (toItem, select) {
  return function (res, folderId, currentPaging, settings, thumbnailSizes) {
    var itemsData = select(res.data.collection.items, folderId, false);
    var paging = {
      cursor: currentPaging.cursor + currentPaging.size,
      size: itemsData.length - currentPaging.cursor
    };
    res.data = itemsData.map(function (data) {
      return toItem(data, settings, thumbnailSizes);
    });
    if (paging.size > 0) {
      res.paging = paging;
    }
    return res;
  };
}(sources_collection_mappers_item, sources_collection_parsers_selector);
sources_collection_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      options.paging.cursor = options.paging.cursor || 0;
      options.paging.size = options.paging.size || settings.itemsLimit;
      return http.get(settings.apiUrl + '/' + settings.collectionId + '.json', {}, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(function (res) {
        return mapItemList(res, folderId, options.paging, settings, options.thumbnails);
      }).catch(toError);
    }
    return { list: list };
  };
}(sources_collection_parsers_items, sources_collection_parsers_error);
sources_collection_Collection = function (defaultSettings, initFolders, initItems, initHttp, decorators, utils, eventsList) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'collection';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_collection_settings, sources_collection_folders, sources_collection_items, utils_http, sources_decorators, utils_utils, events_list);
sources_vimeo_settings = {
  apiUrl: '//pix.wix.com/services/vimeo2',
  itemsLimit: 50,
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  }
};
sources_vimeo_mappers_folder = function () {
  return {
    id: 'Vimeo',
    name: 'Vimeo',
    mediaType: 'video',
    parentId: null,
    filesCount: null,
    createdAt: null
  };
};
sources_vimeo_parsers_folders = function (toFolder) {
  return function () {
    return { data: [toFolder()] };
  };
}(sources_vimeo_mappers_folder);
sources_vimeo_folders = function (toFolders, Promise) {
  return function () {
    function list() {
      return Promise.resolve(toFolders());
    }
    return { list: list };
  };
}(sources_vimeo_parsers_folders, bluebird_extended);
sources_vimeo_mappers_item = function (utils) {
  return function (settings, data) {
    function getIframeSrc(str) {
      var res = str.match(/src="(.+?)"/i);
      return res ? res[1] : '';
    }
    function toTimeStamp(date) {
      return Math.floor(new Date(date).getTime() / 1000);
    }
    function getTags(tags) {
      if (tags === null || !tags.length) {
        return [];
      }
      return tags.reduce(function (resultTags, tag) {
        if (tag) {
          resultTags.push(tag.tag);
        }
        return resultTags;
      }, []);
    }
    function getId(str) {
      return Number(str.match(/\/videos\/(\d+)/i)[1]);
    }
    var item = {
      id: getId(data.uri),
      name: utils.replaceHtml(data.name),
      description: utils.replaceHtml(data.description),
      link: utils.normalizeUri(data.link),
      iframeSrc: getIframeSrc(data.embed.html),
      embedHtml: data.embed.html,
      tags: getTags(data.tags),
      width: Number(data.width) || 0,
      height: Number(data.height) || 0,
      createdAt: toTimeStamp(data.created_time),
      folderId: null,
      mediaType: 'video'
    };
    if (!data.pictures || !data.pictures.sizes) {
      return item;
    }
    var availableThumbnailsSizes = data.pictures.sizes.map(function (pictureSize) {
      return utils.extend({}, pictureSize, { url: pictureSize.link });
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend(item, urls);
  };
}(utils_utils);
sources_vimeo_parsers_items = function (toItem, utils) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data.paging && res.data.paging.next) {
      cursor = Number(res.data.paging.next.match(/\&page\=(\d+)/i)[1]);
      size = res.data.per_page;
    }
    res.data = (res.data.data || []).filter(function (item) {
      return item && item.embed && item.embed.html;
    }).map(utils.partial(toItem, settings));
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_vimeo_mappers_item, utils_utils);
sources_vimeo_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_vimeo_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        per_page: options.paging.size || settings.itemsLimit,
        page: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/videos', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(utils.partial(mapItemList, listSettings)).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_vimeo_parsers_items, sources_vimeo_parsers_error);
sources_vimeo_Vimeo = function (defaultSettings, initFolders, initItems, initHttp, decorators, eventsList, utils) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'vimeo';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_vimeo_settings, sources_vimeo_folders, sources_vimeo_items, utils_http, sources_decorators, events_list, utils_utils);
sources_vimeo_search_settings = {
  apiUrl: '//pix.wix.com/services/vimeo2',
  itemsLimit: 50,
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  }
};
sources_vimeo_search_mappers_item = function (utils) {
  return function (settings, data) {
    function getIframeSrc(str) {
      var res = str.match(/src="(.+?)"/i);
      return res ? res[1] : '';
    }
    function getTags(tags) {
      if (tags === null || !tags.length) {
        return [];
      }
      return tags.reduce(function (resultTags, tag) {
        if (tag) {
          resultTags.push(tag.tag);
        }
        return resultTags;
      }, []);
    }
    function getId(str) {
      return Number(str.match(/\/videos\/(\d+)/i)[1]);
    }
    var item = {
      id: getId(data.uri),
      name: utils.replaceHtml(data.name),
      description: utils.replaceHtml(data.description),
      link: utils.normalizeUri(data.link),
      iframeSrc: getIframeSrc(data.embed.html),
      embedHtml: data.embed.html,
      tags: getTags(data.tags),
      width: Number(data.width) || 0,
      height: Number(data.height) || 0,
      createdAt: utils.toTimeStamp(data.created_time),
      folderId: null,
      mediaType: 'video'
    };
    if (!data.pictures || !data.pictures.sizes) {
      return item;
    }
    var availableThumbnailsSizes = data.pictures.sizes.map(function (pictureSize) {
      return utils.extend({}, pictureSize, { url: pictureSize.link });
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend(item, urls);
  };
}(utils_utils);
sources_vimeo_search_parsers_items = function (toItem, utils) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data.paging && res.data.paging.next) {
      cursor = Number(res.data.paging.next.match(/\&page\=(\d+)/i)[1]);
      size = res.data.per_page;
    }
    res.data = (res.data.data || []).filter(function (item) {
      return item && item.embed && item.embed.html;
    }).map(utils.partial(toItem, settings));
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_vimeo_search_mappers_item, utils_utils);
sources_vimeo_search_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_vimeo_search_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function search(folderId, query, options) {
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        query: query,
        per_page: options.paging.size || settings.itemsLimit,
        page: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(utils.partial(mapItemList, listSettings)).catch(toError);
    }
    return { search: search };
  };
}(utils_utils, sources_vimeo_search_parsers_items, sources_vimeo_search_parsers_error);
sources_vimeo_search_VimeoSearch = function (defaultSettings, initItems, initHttp, decorators, eventsList, utils) {
  return function (settings) {
    var http = initHttp();
    settings = utils.extend({}, defaultSettings, settings);
    var items = initItems(settings, http);
    this.name = 'vimeoSearch';
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_vimeo_search_settings, sources_vimeo_search_items, utils_http, sources_decorators, events_list, utils_utils);
sources_youtube_settings = {
  apiUrl: '//pix.wix.com/services/youtube',
  foldersLimit: 50,
  itemsLimit: 50,
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  }
};
sources_youtube_mappers_folder = function (utils) {
  return function (data, settings) {
    var snippet = data.snippet;
    var availableThumbnailsSizes = Object.keys(snippet.thumbnails).map(function (prop) {
      return snippet.thumbnails[prop];
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend({
      id: data.id,
      name: snippet.title,
      mediaType: 'video',
      parentId: null,
      filesCount: null,
      /* filesCount - from api contentDetails.itemCount. We can get it but its paid */
      createdAt: utils.toTimeStamp(snippet.publishedAt)
    }, urls);
  };
}(utils_utils);
sources_youtube_parsers_folders = function (toFolder) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data && res.data.nextPageToken) {
      cursor = res.data.nextPageToken;
      size = res.data.pageInfo.resultsPerPage;
    }
    res.data = (res.data.items || []).map(function (data) {
      return toFolder(data, settings);
    });
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_youtube_mappers_folder);
sources_youtube_parsers_error = function (Promise) {
  return function (response) {
    if (response.code === 404 && response.data && response.data.message === 'Channel not found.') {
      return {
        data: [],
        status: response.code,
        error: response.data
      };
    }
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_youtube_folders = function (utils, mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        maxResults: options.paging.size || settings.foldersLimit,
        pageToken: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/myplaylists', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(utils.partial(mapFolderList, listSettings)).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_youtube_parsers_folders, sources_youtube_parsers_error);
sources_youtube_mappers_item = function (utils) {
  return function (data, settings) {
    var snippet = data.snippet;
    var videoId = data.contentDetails.videoId;
    function getIframeSrc(videoId) {
      return '//www.youtube.com/embed/' + videoId;
    }
    var availableThumbnailsSizes = Object.keys(snippet.thumbnails).map(function (prop) {
      return snippet.thumbnails[prop];
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend({}, {
      id: videoId,
      name: utils.replaceHtml(snippet.title),
      iframeSrc: getIframeSrc(videoId),
      folderId: null,
      mediaType: 'video',
      createdAt: utils.toTimeStamp(snippet.publishedAt)
    }, urls);
  };
}(utils_utils);
sources_youtube_parsers_items = function (toItem) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data && res.data.nextPageToken) {
      cursor = res.data.nextPageToken;
      size = res.data.pageInfo.resultsPerPage;
    }
    res.data = (res.data.items || []).filter(function (item) {
      return item && item.snippet && item.snippet.thumbnails;
    }).map(function (data) {
      return toItem(data, settings);
    });
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_youtube_mappers_item);
sources_youtube_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        playlistId: folderId,
        maxResults: options.paging.size || settings.itemsLimit,
        pageToken: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/myplaylistitems', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(utils.partial(mapItemList, listSettings)).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_youtube_parsers_items, sources_youtube_parsers_error);
sources_youtube_YouTube = function (defaultSettings, initFolders, initItems, initHttp, decorators, eventsList, utils) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'youtube';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_youtube_settings, sources_youtube_folders, sources_youtube_items, utils_http, sources_decorators, events_list, utils_utils);
sources_youtube_search_settings = {
  apiUrl: '//pix.wix.com/services/youtube',
  itemsLimit: 50,
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  }
};
sources_youtube_search_mappers_item = function (utils) {
  return function (settings, data) {
    var snippet = data.snippet;
    var videoId = data.id.videoId;
    function getIframeSrc(videoId) {
      return '//www.youtube.com/embed/' + videoId;
    }
    var availableThumbnailsSizes = Object.keys(snippet.thumbnails).map(function (prop) {
      return snippet.thumbnails[prop];
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend({}, {
      id: videoId,
      name: utils.replaceHtml(snippet.title),
      iframeSrc: getIframeSrc(videoId),
      folderId: null,
      mediaType: 'video'
    }, urls);
  };
}(utils_utils);
sources_youtube_search_parsers_items = function (toItem, utils) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data && res.data.nextPageToken) {
      cursor = res.data.nextPageToken;
      size = res.data.pageInfo.resultsPerPage;
    }
    res.data = (res.data.items || []).map(utils.partial(toItem, settings));
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_youtube_search_mappers_item, utils_utils);
sources_youtube_search_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_youtube_search_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function search(folderId, query, options) {
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        f: 'ext',
        q: query,
        maxResults: options.paging.size || settings.itemsLimit,
        pageToken: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(utils.partial(mapItemList, listSettings)).catch(toError);
    }
    return { search: search };
  };
}(utils_utils, sources_youtube_search_parsers_items, sources_youtube_search_parsers_error);
sources_youtube_search_YouTubeSearch = function (defaultSettings, initItems, initHttp, decorators, eventsList, utils) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var items = initItems(settings, http);
    this.name = 'youtubeSearch';
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_youtube_search_settings, sources_youtube_search_items, utils_http, sources_decorators, events_list, utils_utils);
sources_showbox_mappers_folder = function (folderData) {
  /**
   * Folder
   * {String} id
   * {String} parentId
   * {String} name
   * {Number} createdAt
   */
  return {
    id: folderData.cms_id,
    parentId: folderData.parents.pop(),
    name: folderData.title,
    createdAt: folderData.created_at
  };
};
sources_showbox_parsers_error = function (Promise) {
  return function (response) {
    //if (response.status === 403 && response.data && response.data.error_description === 'Missing Wix session') {
    //  response.status = 401;
    //  response.data.message = 'Wix Session required';
    //}
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_showbox_folders = function (toFolder, toError) {
  return function (settings, http) {
    function mapFolderList(res) {
      res.data = (res.data.collection || []).map(toFolder);
      return res;
    }
    /**
     * @summary Return the list of folders
     * @memberof source.folders
     * @param {String} folderId
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List[]} List with Folders
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      var url = settings.apiUrl + '/taxonomy/';
      if (folderId) {
        url += 'cms_id/' + folderId;
      }
      return http.get(url, {}, {
        withCredentials: false,
        headers: options.headers || {}
      })  //.then(function (response) {
          //  if(folderId) {
          //    return mapFolderList(response.data.collection[0].children);
          //  }
          //  else {
          //    return mapFolderList(response.data);
          //  }
          //})
.then(mapFolderList).catch(toError);
    }
    return { list: list };
  };
}(sources_showbox_mappers_folder, sources_showbox_parsers_error);
sources_showbox_mappers_item = function (mappers, utils, getWixThumbnailsUrls, getWixVideoPreviewUrls, resize) {
  //function getResizedUrls(thumbnailSizes, urlForResize, imageOperationsApi) {
  //  return Object.keys(thumbnailSizes).reduce(function (urls, sizeName) {
  //    var url = resize(urlForResize, thumbnailSizes[sizeName], imageOperationsApi);
  //
  //    if (url) {
  //      urls[sizeName + 'Url'] = url;
  //    }
  //    return urls;
  //  }, {});
  //}
  return function (itemData, settings, thumbnailSizes) {
    var normalizeUri = utils.normalizeUri;
    //noinspection UnnecessaryLocalVariableJS
    var item = {
      mediaType: 'video',
      id: itemData.cms_id,
      fileUrl: itemData.cms_id,
      folderId: itemData.category[0] || null,
      name: itemData.title,
      width: utils.get(itemData, 'aux.width'),
      height: utils.get(itemData, 'aux.height'),
      thumbnailUrl: itemData.thumbnail || null,
      previewUrl: itemData.thumbnail || null,
      video: itemData.video || null,
      fileOutput: utils.get(itemData, 'aux.file_output'),
      fileInput: utils.get(itemData, 'aux.file_input')
    };
    //var sizes = utils.extend({}, settings.thumbnailSizes, thumbnailSizes);
    //item.thumbnailUrl = getResizedUrls(sizes, itemData.thumbnail, settings.imageOperationsApi);
    //console.log(resize(itemData.thumbnail, sizes[sizeName], imageOperationsApi));
    //console.log(getResizedUrls(sizes, itemData.thumbnail, settings.imageOperationsApi));
    item.videoPreviewUrls = getWixVideoPreviewUrls(item, settings);
    return item;
  };
}(utils_mappers, utils_utils, services_thumbnail_generator_get_wix_thumbnails_urls, services_thumbnail_generator_get_wix_video_preview_urls, services_thumbnail_generator_resize);
sources_showbox_items = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.collection || []).map(function (data) {
        return toItem(data, settings, thumbnailSizes);
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    /**
     * @summary Returns the list of items from the given folder
     * @memberof source.items
     * @param {string} folderId
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = { cursor: paging.cursor };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      var url = settings.apiUrl + '/taxonomy/cms_id/' + folderId;
      return http.get(url, queryParams, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(function (response) {
        response.paging = { cursor: response.data.cursor };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    /**
     * @summary Return list of items found by text query
     * @memberof source.items
     * @param {string} folderId
     * @param {string} query
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function search(folderId, query, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      query = encodeURIComponent(query);
      var queryParams = {
        query: query,
        page_size: paging.size,
        cursor: paging.cursor,
        media_type: options.mediaType || 'picture',
        folder: folderId,
        order: sort.direction === 'desc' ? '-' + sort.order : sort.order
      };
      return http.get(settings.apiUrl + '/search/items', queryParams, {
        cache: false,
        headers: options.headers || {}
      }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    return {
      list: list,
      search: search
    };
  };
}(bluebird_extended, utils_utils, sources_showbox_mappers_item, sources_showbox_parsers_error);
sources_showbox_settings = {
  apiUrl: '//api.showbox.com/',
  imageOperationsApi: 'rembrandt',
  filesUrl: '//video-showbox.wixmp.com',
  videoFilesUrl: '//video-showbox.wixmp.com',
  refreshTokenUrl: null,
  requestOptions: { withCredentials: true },
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    },
    original: {
      width: 1000,
      height: 1000,
      mode: 'fit'
    }
  },
  asyncFontUpload: false,
  asyncUploadByUrl: false,
  asyncTranscoding: false,
  videoPreviewQuality: '480p'
};
sources_showbox_Showbox = function (initFolders, initItems, defaultSettings, utils, decorators, eventsList, initHttp) {
  return function (userSettings) {
    this.name = 'showbox';
    var settings = utils.extendDeep({}, defaultSettings, userSettings);
    var requestOptions = settings.requestOptions;
    var http = initHttp(requestOptions);
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_showbox_folders, sources_showbox_items, sources_showbox_settings, utils_utils, sources_decorators, events_list, utils_http);
sources_list = function (BigStock, ShutterStock, Public, Private, Platform, Picasa, Drive, Dropbox, Instagram, InstagramVideo, Facebook, FacebookVideo, Flickr, FlickrSearch, GoogleSearch, Collection, Vimeo, VimeoSearch, YouTube, YouTubeSearch, Showbox) {
  /**
   * @summary The list of available source constructors
   * @enum
   * @memberof wixmp
   */
  var sources = {
    BIGSTOCK: BigStock,
    SHUTTERSTOCK: ShutterStock,
    PUBLIC: Public,
    PRIVATE: Private,
    PLATFORM: Platform,
    PICASA: Picasa,
    DRIVE: Drive,
    DROPBOX: Dropbox,
    INSTAGRAM: Instagram,
    INSTAGRAM_VIDEO: InstagramVideo,
    FACEBOOK: Facebook,
    FACEBOOK_VIDEO: FacebookVideo,
    FLICKR: Flickr,
    FLICKR_SEARCH: FlickrSearch,
    GOOGLE_SEARCH: GoogleSearch,
    COLLECTION: Collection,
    VIMEO: Vimeo,
    VIMEO_SEARCH: VimeoSearch,
    YOUTUBE: YouTube,
    YOUTUBE_SEARCH: YouTubeSearch,
    SHOWBOX: Showbox
  };
  return sources;
}(sources_bigstock_BigStock, sources_shutterstock_ShutterStock, sources_public_Public, sources_private_Private, sources_platform_Platform, sources_picasa_Picasa, sources_drive_Drive, sources_dropbox_Dropbox, sources_instagram_Instagram, sources_instagram_video_InstagramVideo, sources_facebook_Facebook, sources_facebook_video_FacebookVideo, sources_flickr_Flickr, sources_flickr_search_FlickrSearch, sources_google_search_GoogleSearch, sources_collection_Collection, sources_vimeo_Vimeo, sources_vimeo_search_VimeoSearch, sources_youtube_YouTube, sources_youtube_search_YouTubeSearch, sources_showbox_Showbox);
events_events = function (notifier, list, utils) {
  var events = utils.merge(list);
  function defineNonEnumerableProperty(name, value) {
    Object.defineProperty(events, name, {
      enumerable: false,
      value: value
    });
  }
  defineNonEnumerableProperty('on', notifier.addListener);
  defineNonEnumerableProperty('off', notifier.removeListener);
  return events;
}(events_notifier, events_list, utils_utils);
connector_connector_settings = {
  PICASA: {
    connectUrl: '//pix.wix.com/services/google/connect',
    disconnectUrl: '//pix.wix.com/services/google/disconnect',
    parameterName: 'goglact'
  },
  DRIVE: {
    connectUrl: '//pix.wix.com/services/gdrive/connect',
    disconnectUrl: '//pix.wix.com/services/gdrive/disconnect',
    parameterName: 'gdrvact'
  },
  DROPBOX: {
    connectUrl: '//pix.wix.com/services/dropbox/connect',
    disconnectUrl: '//pix.wix.com/services/dropbox/disconnect',
    parameterName: 'dbact'
  },
  INSTAGRAM: {
    connectUrl: '//pix.wix.com/services/instagram/connect',
    disconnectUrl: '//pix.wix.com/services/instagram/disconnect',
    parameterName: 'instact'
  },
  INSTAGRAM_VIDEO: {
    connectUrl: '//pix.wix.com/services/instagram/connect',
    disconnectUrl: '//pix.wix.com/services/instagram/disconnect',
    parameterName: 'instact'
  },
  FACEBOOK: {
    connectUrl: '//pix.wix.com/services/facebook/connect',
    disconnectUrl: '//pix.wix.com/services/facebook/disconnect',
    parameterName: 'fbact'
  },
  FACEBOOK_VIDEO: {
    connectUrl: '//pix.wix.com/services/facebook/connect',
    disconnectUrl: '//pix.wix.com/services/facebook/disconnect',
    parameterName: 'fbact'
  },
  FLICKR: {
    connectUrl: '//pix.wix.com/services/flickr/connect',
    disconnectUrl: '//pix.wix.com/services/flickr/disconnect',
    parameterName: 'flact'
  },
  YOUTUBE: {
    connectUrl: '//pix.wix.com/services/youtube/connect',
    disconnectUrl: '//pix.wix.com/services/youtube/disconnect',
    parameterName: 'ytact'
  },
  VIMEO: {
    connectUrl: '//pix.wix.com/services/vimeo/connect',
    disconnectUrl: '//pix.wix.com/services/vimeo/disconnect',
    parameterName: 'vmact'
  }
};
connector_connector = function (Promise, connectorSettings, initHttp, utils, mappers) {
  return function (adapterName, userSettings) {
    var settings = connectorSettings[adapterName];
    var http = initHttp();
    if (typeof settings !== 'object') {
      throw new Error('Invalid source');
    }
    function getParameterName() {
      return settings.parameterName;
    }
    function isConnected() {
      return Boolean(localStorage.getItem(settings.parameterName));
    }
    function disconnect() {
      localStorage.removeItem(settings.parameterName);
      return http.get(settings.disconnectUrl, null, { withCredentials: true });
    }
    function connect() {
      var promise;
      window.open(settings.connectUrl + '?return_url=' + userSettings.redirectUrl, 'connector', 'width=950,height=550');
      promise = new Promise(function (resolve, reject) {
        window.connectService = function (data) {
          var token, status;
          token = utils.getParameterByName(data, getParameterName());
          status = utils.getParameterByName(data, 'status');
          if (token && (!status || status !== 'FAIL')) {
            resolve(token);
          } else {
            reject(mappers.toError({
              code: 401,
              message: 'Not Authorized'
            }));
          }
        };
      });
      promise.then(function (token) {
        localStorage.setItem(settings.parameterName, token);
      }, function (reason) {
        return reason;
      });
      return promise;
    }
    return {
      isConnected: isConnected,
      disconnect: disconnect,
      connect: connect
    };
  };
}(bluebird_extended, connector_connector_settings, utils_http, utils_utils, utils_mappers);
services_bi_benchmarks = function (BIEventIds, sendBi) {
  function getCurrentTime() {
    return new Date().getTime();
  }
  function notifyResponseTime(adapter, eventName, data) {
    var requestName = adapter.name + '(' + eventName + ')';
    var responseTime = getCurrentTime() - data.startedAt;
    // TODO: if responseTime and responseSize
    //console.log('BI: [',requestName, '] ',responseTime, ' ms');
    if (responseTime > 0 && data.responseSize > 0) {
      sendBi('/mg', {
        src: 26,
        evid: BIEventIds.BIEventsIds.responseTime,
        call_name: requestName || '',
        result: data.isSuccess ? 'success' : 'fail',
        response_speed: Math.floor((data.responseSize || 0) / (responseTime / 1000)),
        response_time: responseTime || 0,
        response_size: data.responseSize
      });
    }
  }
  function benchmarkResponse(promise, params) {
    var startedAt = getCurrentTime();
    promise.then(function (result) {
      notifyResponseTime(params.eventTarget, params.eventName, {
        startedAt: startedAt,
        responseSize: result.responseSize,
        isSuccess: true
      });
    }).catch(function (result) {
      notifyResponseTime(params.eventTarget, params.eventName, {
        startedAt: startedAt,
        responseSize: result.responseSize,
        isSuccess: false
      });
    });
  }
  function benchmarkUpload(promise, params) {
    var startedAt = getCurrentTime();
    var fileSize = params.arguments[0].file.size;
    if (fileSize < 10240) {
      return;
    }
    promise.then(function () {
      var responseTime = (getCurrentTime() - startedAt) / 1000;
      if (responseTime < 1) {
        return;
      }
      sendBi('/mg', {
        src: 26,
        evid: BIEventIds.BIEventsIds.uploadSpeed,
        time_seconds: Math.floor(responseTime),
        size_bytes: fileSize,
        bytes_per_second: Math.floor(fileSize / responseTime)
      });
    }).catch(function (err) {
      console.warn(err);
    });
  }
  return {
    response: benchmarkResponse,
    upload: benchmarkUpload
  };
}(services_bi_event_ids, services_bi_send_request);
services_bi_errors = function (BIEventIds, sendBi) {
  var catalogIds = {
    default: 0,
    private: 1,
    public: 2,
    // static - unused
    bigstock: 4,
    drive: 5,
    dropbox: 6,
    facebook: 7,
    flickr: 8,
    instagram: 9,
    picasa: 10
  };
  return function (adapterName, eventName, response, options) {
    var httpCode = response.code || '000';
    var adapterCode = BIEventIds.BIAdaptersIds[adapterName] || '00';
    var requestCode = BIEventIds.BIAdaptersRequestsIds[eventName] || '00';
    var errorDesc = adapterName + ' ' + eventName + ': ' + response.message;
    var errorCode = adapterCode + requestCode + httpCode;
    var errorName = adapterName + '.' + eventName + '.' + httpCode;
    // error code string
    return sendBi('/trg', {
      src: 25,
      evid: 10,
      cat: catalogIds[adapterName] || catalogIds.default,
      // event type
      iss: 1,
      // issue (sub-category)
      sev: BIEventIds.severity.error,
      errc: errorCode || '0000000',
      errn: errorName || '',
      ver: options.version || 'VERSION',
      did: options.siteId || '',
      p1: httpCode || '000',
      ts: options.requestTimeMs || '',
      dsc: errorDesc || ''
    });
  };
}(services_bi_event_ids, services_bi_send_request);
services_bi_upload_queue = function (BIEventIds, sendBi) {
  var currentUploadId = '';
  // 00000000-0000-0000-0000-000000000000 - 32 digits
  function generateId() {
    var id = '';
    while (id.length < 32) {
      id += Math.floor(Math.random() * 10000000000000000);
    }
    return [
      id.slice(0, 8),
      id.slice(8, 12),
      id.slice(12, 16),
      id.slice(16, 20),
      id.slice(20, 32)
    ].join('-');
  }
  function sendUploadStart() {
    currentUploadId = generateId();
    sendBi('/mg', {
      src: 26,
      evid: BIEventIds.BIEventsIds.uploadQueueStarted,
      upload_queue_id: currentUploadId
    });
  }
  function sendUploadFinish(queue) {
    sendBi('/mg', {
      src: 26,
      evid: BIEventIds.BIEventsIds.uploadQueueFinished,
      upload_queue_id: currentUploadId,
      files_count: queue.length
    });
  }
  return {
    start: sendUploadStart,
    finish: sendUploadFinish
  };
}(services_bi_event_ids, services_bi_send_request);
services_bi_bi = function (notifier, eventsList, benchmarks, sendError, Uploader, uploadQueue, utils) {
  return function (isEnabled, options) {
    function getCurrentTime() {
      return new Date().getTime();
    }
    var biListener = function (promise, params) {
      // params.eventTarget
      // params.eventName
      // if called by emitWithArrayOfPromises
      if (Array.isArray(promise)) {
        promise = Promise.all(promise);
      }
      benchmarks.response(promise, params);
      var reportSuccess = function () {
      };
      var requestStartTime = getCurrentTime();
      var reportError = function (response) {
        var currentOptions = utils.extend({ requestTimeMs: getCurrentTime() - requestStartTime }, options);
        sendError(params.eventTarget.name, params.eventName, response, currentOptions);
      };
      return promise.then(reportSuccess, reportError);
    };
    Object.keys(eventsList).forEach(function (group) {
      Object.keys(eventsList[group]).forEach(function (action) {
        if (isEnabled === true) {
          notifier.addListener(eventsList[group][action], biListener);
        } else {
          notifier.removeListener(eventsList[group][action], biListener);
        }
      });
    });
    if (isEnabled === true) {
      notifier.addListener(eventsList.ITEM.UPLOAD, benchmarks.upload);
    } else {
      notifier.removeListener(eventsList.ITEM.UPLOAD, benchmarks.upload);
    }
    if (isEnabled === true) {
      Uploader.on('uploadQueueStarted', uploadQueue.start);
      Uploader.on('uploadQueueFinished', uploadQueue.finish);
    }
  };
}(events_notifier, events_list, services_bi_benchmarks, services_bi_errors, services_upload_upload_collection, services_bi_upload_queue, utils_utils);
services_thumbnail_generator_thumbnail_generator = function (resize, getWixThumbnailsUrls, getWixVideoPreviewUrls) {
  return {
    resize: resize,
    getWixThumbnailsUrls: getWixThumbnailsUrls,
    getWixVideoPreviewUrls: getWixVideoPreviewUrls,
    APIS: {
      REMBRANDT: 'rembrandt',
      VANBRANDT: 'vanbrandt',
      VANGOGH: 'vangogh'
    },
    MODES: {
      FILL: 'fill',
      FIT: 'fit'
    }
  };
}(services_thumbnail_generator_resize, services_thumbnail_generator_get_wix_thumbnails_urls, services_thumbnail_generator_get_wix_video_preview_urls);
wixmp = function (Source, sources, events, externalSourceConnector, enableBI, Uploader, thumbnailGenerator) {
  /**
   * @namespace wixmp
   */
  return {
    Source: Source,
    sources: sources,
    events: events,
    thumbnailGenerator: thumbnailGenerator,
    bi: enableBI,
    connectExternalSource: externalSourceConnector,
    Uploader: Uploader
  };
}(sources_Source, sources_list, events_events, connector_connector, services_bi_bi, services_upload_upload_collection, services_thumbnail_generator_thumbnail_generator);
    return wixmp;
  };

  if (typeof exports === 'object' && typeof module !== 'undefined') {
    var globalPromise = window.Promise;

    try {
      globalPromise = require('bluebird');
    } catch (error) {
      console.warn('Bluebird is not available, requests cancellation will not work');
    }

    module.exports = factory(globalPromise);
  } else if (typeof define === 'function' && define.amd) {
    define('wixmp', ['require'], function (_require) {
      var globalPromise = window.Promise;

      try {
        globalPromise = _require('bluebird');
      } catch (error) {
        console.log('Bluebird is not available, requests cancellation will not work');
      }

      return factory(globalPromise);
    });
  } else {
    if (window.Promise !== window.P) {
      console.warn('Bluebird is not available, requests cancellation will not work');
    }

    window.wixmp = factory(window.Promise);
  }
})();



//////////////////
// WEBPACK FOOTER
// ./~/wixmp-sdk/dist/wixmp-sdk.js
// module id = 520
// module chunks = 0 1 2 3 4